/**
 * **INSTRUCTIONS for Devs**
 * 1. generate a new client in NSwag Studio
 * 2. replace the  code beginning with `export interface IClient {` till the end with the same block
 *     of the niwly generated client;
 * 3. add `export` to the last `throwException` function;
 * 4. find `export class Client` and make `protected` its member function `http` and `baseUrl`.
 */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import ClientBase from './clientBase';

export interface IClient {

    /**
     * Get entities from AanvoerderclusterAanvoerders
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_ListAanvoerderclusterAanvoerder(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderclusterAanvoerderCollectionResponse>;

    /**
     * Add new entity to AanvoerderclusterAanvoerders
     * @param body New entity
     * @return Created entity
     */
    aanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_CreateAanvoerderclusterAanvoerder(body: AanvoerderclusterAanvoerder): Promise<AanvoerderclusterAanvoerder>;

    /**
     * Get entity from AanvoerderclusterAanvoerders by key
     * @param aanvoerderclusterAanvoerderId The unique identifier of AanvoerderclusterAanvoerder
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_GetAanvoerderclusterAanvoerder(aanvoerderclusterAanvoerderId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderclusterAanvoerder>;

    /**
     * Update entity in AanvoerderclusterAanvoerders
     * @param aanvoerderclusterAanvoerderId The unique identifier of AanvoerderclusterAanvoerder
     * @param body New property values
     * @return Success
     */
    aanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_UpdateAanvoerderclusterAanvoerder(aanvoerderclusterAanvoerderId: number, body: AanvoerderclusterAanvoerder): Promise<void>;

    /**
     * Delete entity from AanvoerderclusterAanvoerders
     * @param aanvoerderclusterAanvoerderId The unique identifier of AanvoerderclusterAanvoerder
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_DeleteAanvoerderclusterAanvoerder(aanvoerderclusterAanvoerderId: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderclusterAanvoerders_GetCount12e4(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from Aanvoerderclusters
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderclusters_Aanvoerdercluster_ListAanvoerdercluster(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderclusterCollectionResponse>;

    /**
     * Add new entity to Aanvoerderclusters
     * @param body New entity
     * @return Created entity
     */
    aanvoerderclusters_Aanvoerdercluster_CreateAanvoerdercluster(body: Aanvoerdercluster): Promise<Aanvoerdercluster>;

    /**
     * Get entity from Aanvoerderclusters by key
     * @param aanvoerderclusterNummer The unique identifier of Aanvoerdercluster
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderclusters_Aanvoerdercluster_GetAanvoerdercluster(aanvoerderclusterNummer: number, select: string[] | undefined, expand: string[] | undefined): Promise<Aanvoerdercluster>;

    /**
     * Update entity in Aanvoerderclusters
     * @param aanvoerderclusterNummer The unique identifier of Aanvoerdercluster
     * @param body New property values
     * @return Success
     */
    aanvoerderclusters_Aanvoerdercluster_UpdateAanvoerdercluster(aanvoerderclusterNummer: number, body: Aanvoerdercluster): Promise<void>;

    /**
     * Delete entity from Aanvoerderclusters
     * @param aanvoerderclusterNummer The unique identifier of Aanvoerdercluster
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderclusters_Aanvoerdercluster_DeleteAanvoerdercluster(aanvoerderclusterNummer: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderclusters_GetCountC8ad(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from AanvoerderclusterViews
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderclusterViews_AanvoerderclusterView_ListAanvoerderclusterView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderclusterViewCollectionResponse>;

    /**
     * Add new entity to AanvoerderclusterViews
     * @param body New entity
     * @return Created entity
     */
    aanvoerderclusterViews_AanvoerderclusterView_CreateAanvoerderclusterView(body: AanvoerderclusterView): Promise<AanvoerderclusterView>;

    /**
     * Get entity from AanvoerderclusterViews by key
     * @param aanvoerderclusterNummer The unique identifier of AanvoerderclusterView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderclusterViews_AanvoerderclusterView_GetAanvoerderclusterView(aanvoerderclusterNummer: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderclusterView>;

    /**
     * Update entity in AanvoerderclusterViews
     * @param aanvoerderclusterNummer The unique identifier of AanvoerderclusterView
     * @param body New property values
     * @return Success
     */
    aanvoerderclusterViews_AanvoerderclusterView_UpdateAanvoerderclusterView(aanvoerderclusterNummer: number, body: AanvoerderclusterView): Promise<void>;

    /**
     * Delete entity from AanvoerderclusterViews
     * @param aanvoerderclusterNummer The unique identifier of AanvoerderclusterView
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderclusterViews_AanvoerderclusterView_DeleteAanvoerderclusterView(aanvoerderclusterNummer: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get aanvoerderclusterAanvoerders from AanvoerderclusterViews
     * @param aanvoerderclusterNummer The unique identifier of AanvoerderclusterView
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderclusterViews_ListAanvoerderclusterAanvoerders(aanvoerderclusterNummer: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderclusterAanvoerderCollectionResponse>;

    /**
     * Get aanvoerderclusterAanvoerders from AanvoerderclusterViews
     * @param aanvoerderclusterNummer The unique identifier of AanvoerderclusterView
     * @param aanvoerderclusterAanvoerderId The unique identifier of AanvoerderclusterAanvoerder
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved navigation property
     */
    aanvoerderclusterViews_GetAanvoerderclusterAanvoerders(aanvoerderclusterNummer: number, aanvoerderclusterAanvoerderId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderclusterAanvoerder>;

    /**
     * Get the number of the resource
     * @param aanvoerderclusterNummer The unique identifier of AanvoerderclusterView
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderclusterViews_aanvoerderclusterAanvoerders_GetCount6b58(aanvoerderclusterNummer: number, search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderclusterViews_GetCount4011(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from AanvoerderOnregelmatig
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderOnregelmatig_AanvoerderOnregelmatig_ListAanvoerderOnregelmatig(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderOnregelmatigCollectionResponse>;

    /**
     * Add new entity to AanvoerderOnregelmatig
     * @param body New entity
     * @return Created entity
     */
    aanvoerderOnregelmatig_AanvoerderOnregelmatig_CreateAanvoerderOnregelmatig(body: AanvoerderOnregelmatig): Promise<AanvoerderOnregelmatig>;

    /**
     * Get entity from AanvoerderOnregelmatig by key
     * @param aanvoerderOnregelmatigId The unique identifier of AanvoerderOnregelmatig
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderOnregelmatig_AanvoerderOnregelmatig_GetAanvoerderOnregelmatig(aanvoerderOnregelmatigId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderOnregelmatig>;

    /**
     * Update entity in AanvoerderOnregelmatig
     * @param aanvoerderOnregelmatigId The unique identifier of AanvoerderOnregelmatig
     * @param body New property values
     * @return Success
     */
    aanvoerderOnregelmatig_AanvoerderOnregelmatig_UpdateAanvoerderOnregelmatig(aanvoerderOnregelmatigId: number, body: AanvoerderOnregelmatig): Promise<void>;

    /**
     * Delete entity from AanvoerderOnregelmatig
     * @param aanvoerderOnregelmatigId The unique identifier of AanvoerderOnregelmatig
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderOnregelmatig_AanvoerderOnregelmatig_DeleteAanvoerderOnregelmatig(aanvoerderOnregelmatigId: number, if_Match: string | undefined): Promise<void>;

    /**
     * Invoke action Delete
     * @param aanvoerderOnregelmatigId The unique identifier of AanvoerderOnregelmatig
     * @param body Action parameters
     * @return Success
     */
    aanvoerderOnregelmatig_AanvoerderOnregelmatig_Delete(aanvoerderOnregelmatigId: number, body: Body): Promise<Anonymous>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderOnregelmatig_GetCountD8b3(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Invoke function GetAanvoerderOnregelmatig
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    aanvoerderOnregelmatig_GetAanvoerderOnregelmatig(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous2>;

    /**
     * Get entities from AanvoerderProductgroepRegelmatigs
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_ListAanvoerderProductgroepRegelmatig(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatigCollectionResponse>;

    /**
     * Add new entity to AanvoerderProductgroepRegelmatigs
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_CreateAanvoerderProductgroepRegelmatig(body: AanvoerderProductgroepRegelmatig): Promise<AanvoerderProductgroepRegelmatig>;

    /**
     * Get entity from AanvoerderProductgroepRegelmatigs by key
     * @param aanvoerderProductgroepRegelmatigId The unique identifier of AanvoerderProductgroepRegelmatig
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_GetAanvoerderProductgroepRegelmatig(aanvoerderProductgroepRegelmatigId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatig>;

    /**
     * Update entity in AanvoerderProductgroepRegelmatigs
     * @param aanvoerderProductgroepRegelmatigId The unique identifier of AanvoerderProductgroepRegelmatig
     * @param body New property values
     * @return Success
     */
    aanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_UpdateAanvoerderProductgroepRegelmatig(aanvoerderProductgroepRegelmatigId: number, body: AanvoerderProductgroepRegelmatig): Promise<void>;

    /**
     * Delete entity from AanvoerderProductgroepRegelmatigs
     * @param aanvoerderProductgroepRegelmatigId The unique identifier of AanvoerderProductgroepRegelmatig
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_DeleteAanvoerderProductgroepRegelmatig(aanvoerderProductgroepRegelmatigId: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductgroepRegelmatigs_GetCountAffe(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from AanvoerderProductgroepRegelmatigUitzonderingen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_ListAanvoerderProductgroepRegelmatigUitzondering(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatigUitzonderingCollectionResponse>;

    /**
     * Add new entity to AanvoerderProductgroepRegelmatigUitzonderingen
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_CreateAanvoerderProductgroepRegelmatigUitzondering(body: AanvoerderProductgroepRegelmatigUitzondering): Promise<AanvoerderProductgroepRegelmatigUitzondering>;

    /**
     * Get entity from AanvoerderProductgroepRegelmatigUitzonderingen by key
     * @param aanvoerderProductgroepRegelmatigUitzonderingId The unique identifier of AanvoerderProductgroepRegelmatigUitzondering
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_GetAanvoerderProductgroepRegelmatigUitzondering(aanvoerderProductgroepRegelmatigUitzonderingId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatigUitzondering>;

    /**
     * Update entity in AanvoerderProductgroepRegelmatigUitzonderingen
     * @param aanvoerderProductgroepRegelmatigUitzonderingId The unique identifier of AanvoerderProductgroepRegelmatigUitzondering
     * @param body New property values
     * @return Success
     */
    aanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_UpdateAanvoerderProductgroepRegelmatigUitzondering(aanvoerderProductgroepRegelmatigUitzonderingId: number, body: AanvoerderProductgroepRegelmatigUitzondering): Promise<void>;

    /**
     * Delete entity from AanvoerderProductgroepRegelmatigUitzonderingen
     * @param aanvoerderProductgroepRegelmatigUitzonderingId The unique identifier of AanvoerderProductgroepRegelmatigUitzondering
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_DeleteAanvoerderProductgroepRegelmatigUitzondering(aanvoerderProductgroepRegelmatigUitzonderingId: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductgroepRegelmatigUitzonderingen_GetCountDd2b(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from AanvoerderProductgroepRegelmatigUitzonderingenViews
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_ListAanvoerderProductgroepRegelmatigUitzonderingView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatigUitzonderingViewCollectionResponse>;

    /**
     * Add new entity to AanvoerderProductgroepRegelmatigUitzonderingenViews
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_CreateAanvoerderProductgroepRegelmatigUitzonderingView(body: AanvoerderProductgroepRegelmatigUitzonderingView): Promise<AanvoerderProductgroepRegelmatigUitzonderingView>;

    /**
     * Get entity from AanvoerderProductgroepRegelmatigUitzonderingenViews by key
     * @param aanvoerderProductgroepRegelmatigUitzonderingId The unique identifier of AanvoerderProductgroepRegelmatigUitzonderingView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_GetAanvoerderProductgroepRegelmatigUitzonderingView(aanvoerderProductgroepRegelmatigUitzonderingId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatigUitzonderingView>;

    /**
     * Update entity in AanvoerderProductgroepRegelmatigUitzonderingenViews
     * @param aanvoerderProductgroepRegelmatigUitzonderingId The unique identifier of AanvoerderProductgroepRegelmatigUitzonderingView
     * @param body New property values
     * @return Success
     */
    aanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_UpdateAanvoerderProductgroepRegelmatigUitzonderingView(aanvoerderProductgroepRegelmatigUitzonderingId: number, body: AanvoerderProductgroepRegelmatigUitzonderingView): Promise<void>;

    /**
     * Delete entity from AanvoerderProductgroepRegelmatigUitzonderingenViews
     * @param aanvoerderProductgroepRegelmatigUitzonderingId The unique identifier of AanvoerderProductgroepRegelmatigUitzonderingView
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_DeleteAanvoerderProductgroepRegelmatigUitzonderingView(aanvoerderProductgroepRegelmatigUitzonderingId: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductgroepRegelmatigUitzonderingenViews_GetCount7939(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from AanvoerderProductgroepRegelmatigViews
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_ListAanvoerderProductgroepRegelmatigView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatigViewCollectionResponse>;

    /**
     * Add new entity to AanvoerderProductgroepRegelmatigViews
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_CreateAanvoerderProductgroepRegelmatigView(body: AanvoerderProductgroepRegelmatigView): Promise<AanvoerderProductgroepRegelmatigView>;

    /**
     * Get entity from AanvoerderProductgroepRegelmatigViews by key
     * @param aanvoerderProductgroepRegelmatigId The unique identifier of AanvoerderProductgroepRegelmatigView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_GetAanvoerderProductgroepRegelmatigView(aanvoerderProductgroepRegelmatigId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatigView>;

    /**
     * Update entity in AanvoerderProductgroepRegelmatigViews
     * @param aanvoerderProductgroepRegelmatigId The unique identifier of AanvoerderProductgroepRegelmatigView
     * @param body New property values
     * @return Success
     */
    aanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_UpdateAanvoerderProductgroepRegelmatigView(aanvoerderProductgroepRegelmatigId: number, body: AanvoerderProductgroepRegelmatigView): Promise<void>;

    /**
     * Delete entity from AanvoerderProductgroepRegelmatigViews
     * @param aanvoerderProductgroepRegelmatigId The unique identifier of AanvoerderProductgroepRegelmatigView
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_DeleteAanvoerderProductgroepRegelmatigView(aanvoerderProductgroepRegelmatigId: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductgroepRegelmatigViews_GetCountB8a7(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Invoke function ZoekHistorie
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param aanvoerderNummer Usage: aanvoerderNummer={aanvoerderNummer}
     * @param productgroepCode Usage: productgroepCode={productgroepCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    aanvoerderProductgroepRegelmatigViews_ZoekHistorie(vestigingCode: number, aanvoerderNummer: number, productgroepCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous3>;

    /**
     * Get entities from AanvoerderProductRegelmatigs
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_ListAanvoerderProductRegelmatig(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatigCollectionResponse>;

    /**
     * Add new entity to AanvoerderProductRegelmatigs
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_CreateAanvoerderProductRegelmatig(body: AanvoerderProductRegelmatig): Promise<AanvoerderProductRegelmatig>;

    /**
     * Get entity from AanvoerderProductRegelmatigs by key
     * @param aanvoerderProductRegelmatigId The unique identifier of AanvoerderProductRegelmatig
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_GetAanvoerderProductRegelmatig(aanvoerderProductRegelmatigId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatig>;

    /**
     * Update entity in AanvoerderProductRegelmatigs
     * @param aanvoerderProductRegelmatigId The unique identifier of AanvoerderProductRegelmatig
     * @param body New property values
     * @return Success
     */
    aanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_UpdateAanvoerderProductRegelmatig(aanvoerderProductRegelmatigId: number, body: AanvoerderProductRegelmatig): Promise<void>;

    /**
     * Delete entity from AanvoerderProductRegelmatigs
     * @param aanvoerderProductRegelmatigId The unique identifier of AanvoerderProductRegelmatig
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_DeleteAanvoerderProductRegelmatig(aanvoerderProductRegelmatigId: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductRegelmatigs_GetCount8877(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from AanvoerderProductRegelmatigUitzonderingen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_ListAanvoerderProductRegelmatigUitzondering(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatigUitzonderingCollectionResponse>;

    /**
     * Add new entity to AanvoerderProductRegelmatigUitzonderingen
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_CreateAanvoerderProductRegelmatigUitzondering(body: AanvoerderProductRegelmatigUitzondering): Promise<AanvoerderProductRegelmatigUitzondering>;

    /**
     * Get entity from AanvoerderProductRegelmatigUitzonderingen by key
     * @param aanvoerderProductRegelmatigUitzonderingId The unique identifier of AanvoerderProductRegelmatigUitzondering
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_GetAanvoerderProductRegelmatigUitzondering(aanvoerderProductRegelmatigUitzonderingId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatigUitzondering>;

    /**
     * Update entity in AanvoerderProductRegelmatigUitzonderingen
     * @param aanvoerderProductRegelmatigUitzonderingId The unique identifier of AanvoerderProductRegelmatigUitzondering
     * @param body New property values
     * @return Success
     */
    aanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_UpdateAanvoerderProductRegelmatigUitzondering(aanvoerderProductRegelmatigUitzonderingId: number, body: AanvoerderProductRegelmatigUitzondering): Promise<void>;

    /**
     * Delete entity from AanvoerderProductRegelmatigUitzonderingen
     * @param aanvoerderProductRegelmatigUitzonderingId The unique identifier of AanvoerderProductRegelmatigUitzondering
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_DeleteAanvoerderProductRegelmatigUitzondering(aanvoerderProductRegelmatigUitzonderingId: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductRegelmatigUitzonderingen_GetCount5d33(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from AanvoerderProductRegelmatigUitzonderingenViews
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_ListAanvoerderProductRegelmatigUitzonderingView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatigUitzonderingViewCollectionResponse>;

    /**
     * Add new entity to AanvoerderProductRegelmatigUitzonderingenViews
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_CreateAanvoerderProductRegelmatigUitzonderingView(body: AanvoerderProductRegelmatigUitzonderingView): Promise<AanvoerderProductRegelmatigUitzonderingView>;

    /**
     * Get entity from AanvoerderProductRegelmatigUitzonderingenViews by key
     * @param aanvoerderProductRegelmatigUitzonderingId The unique identifier of AanvoerderProductRegelmatigUitzonderingView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_GetAanvoerderProductRegelmatigUitzonderingView(aanvoerderProductRegelmatigUitzonderingId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatigUitzonderingView>;

    /**
     * Update entity in AanvoerderProductRegelmatigUitzonderingenViews
     * @param aanvoerderProductRegelmatigUitzonderingId The unique identifier of AanvoerderProductRegelmatigUitzonderingView
     * @param body New property values
     * @return Success
     */
    aanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_UpdateAanvoerderProductRegelmatigUitzonderingView(aanvoerderProductRegelmatigUitzonderingId: number, body: AanvoerderProductRegelmatigUitzonderingView): Promise<void>;

    /**
     * Delete entity from AanvoerderProductRegelmatigUitzonderingenViews
     * @param aanvoerderProductRegelmatigUitzonderingId The unique identifier of AanvoerderProductRegelmatigUitzonderingView
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_DeleteAanvoerderProductRegelmatigUitzonderingView(aanvoerderProductRegelmatigUitzonderingId: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductRegelmatigUitzonderingenViews_GetCount9644(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from AanvoerderProductRegelmatigViews
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_ListAanvoerderProductRegelmatigView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatigViewCollectionResponse>;

    /**
     * Add new entity to AanvoerderProductRegelmatigViews
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_CreateAanvoerderProductRegelmatigView(body: AanvoerderProductRegelmatigView): Promise<AanvoerderProductRegelmatigView>;

    /**
     * Get entity from AanvoerderProductRegelmatigViews by key
     * @param aanvoerderProductRegelmatigId The unique identifier of AanvoerderProductRegelmatigView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_GetAanvoerderProductRegelmatigView(aanvoerderProductRegelmatigId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatigView>;

    /**
     * Update entity in AanvoerderProductRegelmatigViews
     * @param aanvoerderProductRegelmatigId The unique identifier of AanvoerderProductRegelmatigView
     * @param body New property values
     * @return Success
     */
    aanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_UpdateAanvoerderProductRegelmatigView(aanvoerderProductRegelmatigId: number, body: AanvoerderProductRegelmatigView): Promise<void>;

    /**
     * Delete entity from AanvoerderProductRegelmatigViews
     * @param aanvoerderProductRegelmatigId The unique identifier of AanvoerderProductRegelmatigView
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_DeleteAanvoerderProductRegelmatigView(aanvoerderProductRegelmatigId: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductRegelmatigViews_GetCount22af(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Invoke function ZoekHistorie
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param aanvoerderNummer Usage: aanvoerderNummer={aanvoerderNummer}
     * @param productCode Usage: productCode={productCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    aanvoerderProductRegelmatigViews_ZoekHistorie(vestigingCode: number, aanvoerderNummer: number, productCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous4>;

    /**
     * Get entities from AanvoerderPromotieKenmerk
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_ListAanvoerderPromotieKenmerk(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderPromotieKenmerkCollectionResponse>;

    /**
     * Add new entity to AanvoerderPromotieKenmerk
     * @param body New entity
     * @return Created entity
     */
    aanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_CreateAanvoerderPromotieKenmerk(body: AanvoerderPromotieKenmerk): Promise<AanvoerderPromotieKenmerk>;

    /**
     * Get entity from AanvoerderPromotieKenmerk by key
     * @param aanvoerderPromotieKenmerkId The unique identifier of AanvoerderPromotieKenmerk
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_GetAanvoerderPromotieKenmerk(aanvoerderPromotieKenmerkId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderPromotieKenmerk>;

    /**
     * Update entity in AanvoerderPromotieKenmerk
     * @param aanvoerderPromotieKenmerkId The unique identifier of AanvoerderPromotieKenmerk
     * @param body New property values
     * @return Success
     */
    aanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_UpdateAanvoerderPromotieKenmerk(aanvoerderPromotieKenmerkId: number, body: AanvoerderPromotieKenmerk): Promise<void>;

    /**
     * Delete entity from AanvoerderPromotieKenmerk
     * @param aanvoerderPromotieKenmerkId The unique identifier of AanvoerderPromotieKenmerk
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_DeleteAanvoerderPromotieKenmerk(aanvoerderPromotieKenmerkId: number, if_Match: string | undefined): Promise<void>;

    /**
     * Invoke action Delete
     * @param aanvoerderPromotieKenmerkId The unique identifier of AanvoerderPromotieKenmerk
     * @param body Action parameters
     * @return Success
     */
    aanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_Delete(aanvoerderPromotieKenmerkId: number, body: Body2): Promise<Anonymous5>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderPromotieKenmerk_GetCount47dd(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Invoke action AddPromotieKenmerk
     * @return Success
     */
    aanvoerderPromotieKenmerk_AddPromotieKenmerk(): Promise<Anonymous6>;

    /**
     * Invoke function GetByAanvoerderProductVervallen
     * @param aanvoerdernummer Usage: aanvoerdernummer={aanvoerdernummer}
     * @param productcode Usage: productcode={productcode}
     * @param inclusiefVervallen Usage: inclusiefVervallen={inclusiefVervallen}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    aanvoerderPromotieKenmerk_GetByAanvoerderProductVervallen(aanvoerdernummer: number, productcode: number, inclusiefVervallen: boolean, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous7>;

    /**
     * Invoke action UpdatePromotieKenmerk
     * @return Success
     */
    aanvoerderPromotieKenmerk_UpdatePromotieKenmerk(): Promise<Anonymous8>;

    /**
     * Get entities from Aanvoerders
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerders_Aanvoerder_ListAanvoerder(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderCollectionResponse>;

    /**
     * Add new entity to Aanvoerders
     * @param body New entity
     * @return Created entity
     */
    aanvoerders_Aanvoerder_CreateAanvoerder(body: Aanvoerder): Promise<Aanvoerder>;

    /**
     * Get entity from Aanvoerders by key
     * @param aanvoerderNummer The unique identifier of Aanvoerder
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerders_Aanvoerder_GetAanvoerder(aanvoerderNummer: number, select: string[] | undefined, expand: string[] | undefined): Promise<Aanvoerder>;

    /**
     * Update entity in Aanvoerders
     * @param aanvoerderNummer The unique identifier of Aanvoerder
     * @param body New property values
     * @return Success
     */
    aanvoerders_Aanvoerder_UpdateAanvoerder(aanvoerderNummer: number, body: Aanvoerder): Promise<void>;

    /**
     * Delete entity from Aanvoerders
     * @param aanvoerderNummer The unique identifier of Aanvoerder
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerders_Aanvoerder_DeleteAanvoerder(aanvoerderNummer: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerders_GetCount7590(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from Kenmerken
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    kenmerken_Kenmerk_ListKenmerk(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<KenmerkCollectionResponse>;

    /**
     * Add new entity to Kenmerken
     * @param body New entity
     * @return Created entity
     */
    kenmerken_Kenmerk_CreateKenmerk(body: Kenmerk): Promise<Kenmerk>;

    /**
     * Get entity from Kenmerken by key
     * @param kenmerkCode The unique identifier of Kenmerk
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    kenmerken_Kenmerk_GetKenmerk(kenmerkCode: string, select: string[] | undefined, expand: string[] | undefined): Promise<Kenmerk>;

    /**
     * Update entity in Kenmerken
     * @param kenmerkCode The unique identifier of Kenmerk
     * @param body New property values
     * @return Success
     */
    kenmerken_Kenmerk_UpdateKenmerk(kenmerkCode: string, body: Kenmerk): Promise<void>;

    /**
     * Delete entity from Kenmerken
     * @param kenmerkCode The unique identifier of Kenmerk
     * @param if_Match (optional) ETag
     * @return Success
     */
    kenmerken_Kenmerk_DeleteKenmerk(kenmerkCode: string, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    kenmerken_GetCountEbe7(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from KenmerkWaardes
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    kenmerkWaardes_KenmerkWaarde_ListKenmerkWaarde(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<KenmerkWaardeCollectionResponse>;

    /**
     * Add new entity to KenmerkWaardes
     * @param body New entity
     * @return Created entity
     */
    kenmerkWaardes_KenmerkWaarde_CreateKenmerkWaarde(body: KenmerkWaarde): Promise<KenmerkWaarde>;

    /**
     * Get entity from KenmerkWaardes by key
     * @param refSysIdf The unique identifier of KenmerkWaarde
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    kenmerkWaardes_KenmerkWaarde_GetKenmerkWaarde(refSysIdf: number, select: string[] | undefined, expand: string[] | undefined): Promise<KenmerkWaarde>;

    /**
     * Update entity in KenmerkWaardes
     * @param refSysIdf The unique identifier of KenmerkWaarde
     * @param body New property values
     * @return Success
     */
    kenmerkWaardes_KenmerkWaarde_UpdateKenmerkWaarde(refSysIdf: number, body: KenmerkWaarde): Promise<void>;

    /**
     * Delete entity from KenmerkWaardes
     * @param refSysIdf The unique identifier of KenmerkWaarde
     * @param if_Match (optional) ETag
     * @return Success
     */
    kenmerkWaardes_KenmerkWaarde_DeleteKenmerkWaarde(refSysIdf: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    kenmerkWaardes_GetCount307d(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from PartijStatussen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    partijStatussen_PartijStatusReport_ListPartijStatusReport(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<PartijStatusReportCollectionResponse>;

    /**
     * Add new entity to PartijStatussen
     * @param body New entity
     * @return Created entity
     */
    partijStatussen_PartijStatusReport_CreatePartijStatusReport(body: PartijStatusReport): Promise<PartijStatusReport>;

    /**
     * Get entity from PartijStatussen by key
     * @param aantalBronHerkeur The unique identifier of PartijStatusReport
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    partijStatussen_PartijStatusReport_GetPartijStatusReport(aantalBronHerkeur: number, select: string[] | undefined, expand: string[] | undefined): Promise<PartijStatusReport>;

    /**
     * Update entity in PartijStatussen
     * @param aantalBronHerkeur The unique identifier of PartijStatusReport
     * @param body New property values
     * @return Success
     */
    partijStatussen_PartijStatusReport_UpdatePartijStatusReport(aantalBronHerkeur: number, body: PartijStatusReport): Promise<void>;

    /**
     * Delete entity from PartijStatussen
     * @param aantalBronHerkeur The unique identifier of PartijStatusReport
     * @param if_Match (optional) ETag
     * @return Success
     */
    partijStatussen_PartijStatusReport_DeletePartijStatusReport(aantalBronHerkeur: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    partijStatussen_GetCount119d(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Invoke function GetVeildatum
     * @param veilDatum Usage: veilDatum={veilDatum}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    partijStatussen_GetVeildatum(veilDatum: Date, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous9>;

    /**
     * Invoke function GetVeildatumVestiging
     * @param veilDatum Usage: veilDatum={veilDatum}
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    partijStatussen_GetVeildatumVestiging(veilDatum: Date, vestigingCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous10>;

    /**
     * Get entities from ProductclusterProductgroepen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productclusterProductgroepen_ProductclusterProductgroep_ListProductclusterProductgroep(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterProductgroepCollectionResponse>;

    /**
     * Add new entity to ProductclusterProductgroepen
     * @param body New entity
     * @return Created entity
     */
    productclusterProductgroepen_ProductclusterProductgroep_CreateProductclusterProductgroep(body: ProductclusterProductgroep): Promise<ProductclusterProductgroep>;

    /**
     * Get entity from ProductclusterProductgroepen by key
     * @param productclusterProductgroepID The unique identifier of ProductclusterProductgroep
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    productclusterProductgroepen_ProductclusterProductgroep_GetProductclusterProductgroep(productclusterProductgroepID: number, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterProductgroep>;

    /**
     * Update entity in ProductclusterProductgroepen
     * @param productclusterProductgroepID The unique identifier of ProductclusterProductgroep
     * @param body New property values
     * @return Success
     */
    productclusterProductgroepen_ProductclusterProductgroep_UpdateProductclusterProductgroep(productclusterProductgroepID: number, body: ProductclusterProductgroep): Promise<void>;

    /**
     * Delete entity from ProductclusterProductgroepen
     * @param productclusterProductgroepID The unique identifier of ProductclusterProductgroep
     * @param if_Match (optional) ETag
     * @return Success
     */
    productclusterProductgroepen_ProductclusterProductgroep_DeleteProductclusterProductgroep(productclusterProductgroepID: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get productcluster from ProductclusterProductgroepen
     * @param productclusterProductgroepID The unique identifier of ProductclusterProductgroep
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved navigation property
     */
    productclusterProductgroepen_GetProductcluster(productclusterProductgroepID: number, select: string[] | undefined, expand: string[] | undefined): Promise<Productcluster>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productclusterProductgroepen_GetCountA27c(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from Productclusters
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productclusters_Productcluster_ListProductcluster(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterCollectionResponse>;

    /**
     * Add new entity to Productclusters
     * @param body New entity
     * @return Created entity
     */
    productclusters_Productcluster_CreateProductcluster(body: Productcluster): Promise<Productcluster>;

    /**
     * Get entity from Productclusters by key
     * @param productclusterID The unique identifier of Productcluster
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    productclusters_Productcluster_GetProductcluster(productclusterID: number, select: string[] | undefined, expand: string[] | undefined): Promise<Productcluster>;

    /**
     * Update entity in Productclusters
     * @param productclusterID The unique identifier of Productcluster
     * @param body New property values
     * @return Success
     */
    productclusters_Productcluster_UpdateProductclusterPATCH(productclusterID: number, body: Productcluster): Promise<void>;

    /**
     * Delete entity from Productclusters
     * @param productclusterID The unique identifier of Productcluster
     * @param if_Match (optional) ETag
     * @return Success
     */
    productclusters_Productcluster_DeleteProductcluster(productclusterID: number, if_Match: string | undefined): Promise<void>;

    /**
     * Invoke action UpdateProductcluster
     * @param productclusterID The unique identifier of Productcluster
     * @return Success
     */
    productclusters_Productcluster_UpdateProductclusterPOST(productclusterID: number): Promise<Anonymous11>;

    /**
     * Get productclusterProductgroepen from Productclusters
     * @param productclusterID The unique identifier of Productcluster
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productclusters_ListProductclusterProductgroepen(productclusterID: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterProductgroepCollectionResponse>;

    /**
     * Get productclusterProductgroepen from Productclusters
     * @param productclusterID The unique identifier of Productcluster
     * @param productclusterProductgroepID The unique identifier of ProductclusterProductgroep
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved navigation property
     */
    productclusters_GetProductclusterProductgroepen(productclusterID: number, productclusterProductgroepID: number, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterProductgroep>;

    /**
     * Get the number of the resource
     * @param productclusterID The unique identifier of Productcluster
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productclusters_productclusterProductgroepen_GetCountD7fe(productclusterID: number, search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get veilgroepRegels from Productclusters
     * @param productclusterID The unique identifier of Productcluster
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productclusters_ListVeilgroepRegels(productclusterID: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepRegelCollectionResponse>;

    /**
     * Get veilgroepRegels from Productclusters
     * @param productclusterID The unique identifier of Productcluster
     * @param veilgroepRegelId The unique identifier of VeilgroepRegel
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved navigation property
     */
    productclusters_GetVeilgroepRegels(productclusterID: number, veilgroepRegelId: number, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepRegel>;

    /**
     * Get the number of the resource
     * @param productclusterID The unique identifier of Productcluster
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productclusters_veilgroepRegels_GetCount9043(productclusterID: number, search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productclusters_GetCount527c(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Invoke function GetToegestaneProductgroepen
     * @param bloemenPlantenCode Usage: bloemenPlantenCode={bloemenPlantenCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @return Success
     */
    productclusters_GetToegestaneProductgroepen(bloemenPlantenCode: string | null, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined): Promise<Anonymous12>;

    /**
     * Invoke function MagProductgroepWordenVerwijderd
     * @param productclusterId Usage: productclusterId={productclusterId}
     * @param productgroepCode Usage: productgroepCode={productgroepCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @return Success
     */
    productclusters_MagProductgroepWordenVerwijderd(productclusterId: number, productgroepCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined): Promise<Anonymous13>;

    /**
     * Get entities from ProductclusterViews
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productclusterViews_ProductclusterView_ListProductclusterView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterViewCollectionResponse>;

    /**
     * Add new entity to ProductclusterViews
     * @param body New entity
     * @return Created entity
     */
    productclusterViews_ProductclusterView_CreateProductclusterView(body: ProductclusterView): Promise<ProductclusterView>;

    /**
     * Get entity from ProductclusterViews by key
     * @param productclusterID The unique identifier of ProductclusterView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    productclusterViews_ProductclusterView_GetProductclusterView(productclusterID: number, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterView>;

    /**
     * Update entity in ProductclusterViews
     * @param productclusterID The unique identifier of ProductclusterView
     * @param body New property values
     * @return Success
     */
    productclusterViews_ProductclusterView_UpdateProductclusterView(productclusterID: number, body: ProductclusterView): Promise<void>;

    /**
     * Delete entity from ProductclusterViews
     * @param productclusterID The unique identifier of ProductclusterView
     * @param if_Match (optional) ETag
     * @return Success
     */
    productclusterViews_ProductclusterView_DeleteProductclusterView(productclusterID: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get productclusterProductgroepen from ProductclusterViews
     * @param productclusterID The unique identifier of ProductclusterView
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productclusterViews_ListProductclusterProductgroepen(productclusterID: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterProductgroepCollectionResponse>;

    /**
     * Get productclusterProductgroepen from ProductclusterViews
     * @param productclusterID The unique identifier of ProductclusterView
     * @param productclusterProductgroepID The unique identifier of ProductclusterProductgroep
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved navigation property
     */
    productclusterViews_GetProductclusterProductgroepen(productclusterID: number, productclusterProductgroepID: number, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterProductgroep>;

    /**
     * Get the number of the resource
     * @param productclusterID The unique identifier of ProductclusterView
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productclusterViews_productclusterProductgroepen_GetCountCb26(productclusterID: number, search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get veilgroepRegels from ProductclusterViews
     * @param productclusterID The unique identifier of ProductclusterView
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productclusterViews_ListVeilgroepRegels(productclusterID: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterVeilgroepRegelCollectionResponse>;

    /**
     * Get veilgroepRegels from ProductclusterViews
     * @param productclusterID The unique identifier of ProductclusterView
     * @param productclusterVeilgroepRegelId The unique identifier of ProductclusterVeilgroepRegel
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved navigation property
     */
    productclusterViews_GetVeilgroepRegels(productclusterID: number, productclusterVeilgroepRegelId: number, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterVeilgroepRegel>;

    /**
     * Get the number of the resource
     * @param productclusterID The unique identifier of ProductclusterView
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productclusterViews_veilgroepRegels_GetCount37d4(productclusterID: number, search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productclusterViews_GetCount8446(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from Producten
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    producten_Product_ListProduct(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductCollectionResponse>;

    /**
     * Add new entity to Producten
     * @param body New entity
     * @return Created entity
     */
    producten_Product_CreateProduct(body: Product): Promise<Product>;

    /**
     * Get entity from Producten by key
     * @param productCode The unique identifier of Product
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    producten_Product_GetProduct(productCode: number, select: string[] | undefined, expand: string[] | undefined): Promise<Product>;

    /**
     * Update entity in Producten
     * @param productCode The unique identifier of Product
     * @param body New property values
     * @return Success
     */
    producten_Product_UpdateProduct(productCode: number, body: Product): Promise<void>;

    /**
     * Delete entity from Producten
     * @param productCode The unique identifier of Product
     * @param if_Match (optional) ETag
     * @return Success
     */
    producten_Product_DeleteProduct(productCode: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    producten_GetCount7f36(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from Productgroepen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productgroepen_Productgroep_ListProductgroep(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductgroepCollectionResponse>;

    /**
     * Add new entity to Productgroepen
     * @param body New entity
     * @return Created entity
     */
    productgroepen_Productgroep_CreateProductgroep(body: Productgroep): Promise<Productgroep>;

    /**
     * Get entity from Productgroepen by key
     * @param productgroepCode The unique identifier of Productgroep
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    productgroepen_Productgroep_GetProductgroep(productgroepCode: number, select: string[] | undefined, expand: string[] | undefined): Promise<Productgroep>;

    /**
     * Update entity in Productgroepen
     * @param productgroepCode The unique identifier of Productgroep
     * @param body New property values
     * @return Success
     */
    productgroepen_Productgroep_UpdateProductgroep(productgroepCode: number, body: Productgroep): Promise<void>;

    /**
     * Delete entity from Productgroepen
     * @param productgroepCode The unique identifier of Productgroep
     * @param if_Match (optional) ETag
     * @return Success
     */
    productgroepen_Productgroep_DeleteProductgroep(productgroepCode: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productgroepen_GetCount313e(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from ProductVeilgroepen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productVeilgroepen_ProductVeilgroep_ListProductVeilgroep(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductVeilgroepCollectionResponse>;

    /**
     * Add new entity to ProductVeilgroepen
     * @param body New entity
     * @return Created entity
     */
    productVeilgroepen_ProductVeilgroep_CreateProductVeilgroep(body: ProductVeilgroep): Promise<ProductVeilgroep>;

    /**
     * Get entity from ProductVeilgroepen by key
     * @param productVeilgroepAisID The unique identifier of ProductVeilgroep
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    productVeilgroepen_ProductVeilgroep_GetProductVeilgroep(productVeilgroepAisID: number, select: string[] | undefined, expand: string[] | undefined): Promise<ProductVeilgroep>;

    /**
     * Update entity in ProductVeilgroepen
     * @param productVeilgroepAisID The unique identifier of ProductVeilgroep
     * @param body New property values
     * @return Success
     */
    productVeilgroepen_ProductVeilgroep_UpdateProductVeilgroep(productVeilgroepAisID: number, body: ProductVeilgroep): Promise<void>;

    /**
     * Delete entity from ProductVeilgroepen
     * @param productVeilgroepAisID The unique identifier of ProductVeilgroep
     * @param if_Match (optional) ETag
     * @return Success
     */
    productVeilgroepen_ProductVeilgroep_DeleteProductVeilgroep(productVeilgroepAisID: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productVeilgroepen_GetCount8340(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Invoke function GetVeilgroep
     * @param veilgroepCode Usage: veilgroepCode={veilgroepCode}
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    productVeilgroepen_GetVeilgroep(veilgroepCode: number, vestigingCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous14>;

    /**
     * Invoke function ZoekProductVeilgroepen
     * @param bloemenPlantenCode Usage: bloemenPlantenCode={bloemenPlantenCode}
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    productVeilgroepen_ZoekProductVeilgroepen(bloemenPlantenCode: string | null, vestigingCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous15>;

    /**
     * Get entities from TribuneKlokken
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    tribuneKlokken_TribuneKlok_ListTribuneKlok(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<TribuneKlokCollectionResponse>;

    /**
     * Add new entity to TribuneKlokken
     * @param body New entity
     * @return Created entity
     */
    tribuneKlokken_TribuneKlok_CreateTribuneKlok(body: TribuneKlok): Promise<TribuneKlok>;

    /**
     * Get entity from TribuneKlokken by key
     * @param klokNummer The unique identifier of TribuneKlok
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    tribuneKlokken_TribuneKlok_GetTribuneKlok(klokNummer: number, select: string[] | undefined, expand: string[] | undefined): Promise<TribuneKlok>;

    /**
     * Update entity in TribuneKlokken
     * @param klokNummer The unique identifier of TribuneKlok
     * @param body New property values
     * @return Success
     */
    tribuneKlokken_TribuneKlok_UpdateTribuneKlok(klokNummer: number, body: TribuneKlok): Promise<void>;

    /**
     * Delete entity from TribuneKlokken
     * @param klokNummer The unique identifier of TribuneKlok
     * @param if_Match (optional) ETag
     * @return Success
     */
    tribuneKlokken_TribuneKlok_DeleteTribuneKlok(klokNummer: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    tribuneKlokken_GetCount19e6(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from UitzonderingRedenen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    uitzonderingRedenen_UitzonderingReden_ListUitzonderingReden(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<UitzonderingRedenCollectionResponse>;

    /**
     * Add new entity to UitzonderingRedenen
     * @param body New entity
     * @return Created entity
     */
    uitzonderingRedenen_UitzonderingReden_CreateUitzonderingReden(body: UitzonderingReden): Promise<UitzonderingReden>;

    /**
     * Get entity from UitzonderingRedenen by key
     * @param uitzonderingRedenCode The unique identifier of UitzonderingReden
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    uitzonderingRedenen_UitzonderingReden_GetUitzonderingReden(uitzonderingRedenCode: number, select: string[] | undefined, expand: string[] | undefined): Promise<UitzonderingReden>;

    /**
     * Update entity in UitzonderingRedenen
     * @param uitzonderingRedenCode The unique identifier of UitzonderingReden
     * @param body New property values
     * @return Success
     */
    uitzonderingRedenen_UitzonderingReden_UpdateUitzonderingReden(uitzonderingRedenCode: number, body: UitzonderingReden): Promise<void>;

    /**
     * Delete entity from UitzonderingRedenen
     * @param uitzonderingRedenCode The unique identifier of UitzonderingReden
     * @param if_Match (optional) ETag
     * @return Success
     */
    uitzonderingRedenen_UitzonderingReden_DeleteUitzonderingReden(uitzonderingRedenCode: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    uitzonderingRedenen_GetCountD40e(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from VeilgroepIndelingen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    veilgroepIndelingen_VeilgroepIndelingOverview_ListVeilgroepIndelingOverview(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepIndelingOverviewCollectionResponse>;

    /**
     * Add new entity to VeilgroepIndelingen
     * @param body New entity
     * @return Created entity
     */
    veilgroepIndelingen_VeilgroepIndelingOverview_CreateVeilgroepIndelingOverview(body: VeilgroepIndelingOverview): Promise<VeilgroepIndelingOverview>;

    /**
     * Get entity from VeilgroepIndelingen by key
     * @param productclusterID The unique identifier of VeilgroepIndelingOverview
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    veilgroepIndelingen_VeilgroepIndelingOverview_GetVeilgroepIndelingOverview(productclusterID: number, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepIndelingOverview>;

    /**
     * Update entity in VeilgroepIndelingen
     * @param productclusterID The unique identifier of VeilgroepIndelingOverview
     * @param body New property values
     * @return Success
     */
    veilgroepIndelingen_VeilgroepIndelingOverview_UpdateVeilgroepIndelingOverview(productclusterID: number, body: VeilgroepIndelingOverview): Promise<void>;

    /**
     * Delete entity from VeilgroepIndelingen
     * @param productclusterID The unique identifier of VeilgroepIndelingOverview
     * @param if_Match (optional) ETag
     * @return Success
     */
    veilgroepIndelingen_VeilgroepIndelingOverview_DeleteVeilgroepIndelingOverview(productclusterID: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    veilgroepIndelingen_GetCountCd00(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Invoke function GetByBloemenPlantenVestiging
     * @param bloemenPlantenCode Usage: bloemenPlantenCode={bloemenPlantenCode}
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    veilgroepIndelingen_GetByBloemenPlantenVestiging(bloemenPlantenCode: string | null, vestigingCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous16>;

    /**
     * Get entities from VeilgroepIndelingRegelViews
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    veilgroepIndelingRegelViews_VeilgroepIndelingRegelView_ListVeilgroepIndelingRegelView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepIndelingRegelViewCollectionResponse>;

    /**
     * Add new entity to VeilgroepIndelingRegelViews
     * @param body New entity
     * @return Created entity
     */
    veilgroepIndelingRegelViews_VeilgroepIndelingRegelView_CreateVeilgroepIndelingRegelView(body: VeilgroepIndelingRegelView): Promise<VeilgroepIndelingRegelView>;

    /**
     * Get entity from VeilgroepIndelingRegelViews by key
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    veilgroepIndelingRegelViews_VeilgroepIndelingRegelView_GetVeilgroepIndelingRegelView(productclusterVeilgroepRegelId: number, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepIndelingRegelView>;

    /**
     * Update entity in VeilgroepIndelingRegelViews
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelView
     * @param body New property values
     * @return Success
     */
    veilgroepIndelingRegelViews_VeilgroepIndelingRegelView_UpdateVeilgroepIndelingRegelView(productclusterVeilgroepRegelId: number, body: VeilgroepIndelingRegelView): Promise<void>;

    /**
     * Delete entity from VeilgroepIndelingRegelViews
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelView
     * @param if_Match (optional) ETag
     * @return Success
     */
    veilgroepIndelingRegelViews_VeilgroepIndelingRegelView_DeleteVeilgroepIndelingRegelView(productclusterVeilgroepRegelId: number, if_Match: string | undefined): Promise<void>;

    /**
     * Invoke action Delete
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelView
     * @param body Action parameters
     * @return Success
     */
    veilgroepIndelingRegelViews_VeilgroepIndelingRegelView_Delete(productclusterVeilgroepRegelId: number, body: Body3): Promise<Anonymous17>;

    /**
     * Invoke action UpdateMultiple
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelView
     * @return Success
     */
    veilgroepIndelingRegelViews_VeilgroepIndelingRegelView_UpdateMultiple(productclusterVeilgroepRegelId: number): Promise<Anonymous18>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    veilgroepIndelingRegelViews_GetCountCd69(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Invoke function GetByProductclusterVestiging
     * @param productclusterId Usage: productclusterId={productclusterId}
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    veilgroepIndelingRegelViews_GetByProductclusterVestiging(productclusterId: number, vestigingCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous19>;

    /**
     * Invoke function ZoekFustcodes
     * @param productclusterVeilgroepRegelId Usage: productclusterVeilgroepRegelId={productclusterVeilgroepRegelId}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @return Success
     */
    veilgroepIndelingRegelViews_ZoekFustcodes(productclusterVeilgroepRegelId: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined): Promise<Anonymous20>;

    /**
     * Invoke function ZoekProducten
     * @param productclusterId Usage: productclusterId={productclusterId}
     * @param productclusterVeilgroepRegelId Usage: productclusterVeilgroepRegelId={productclusterVeilgroepRegelId}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @return Success
     */
    veilgroepIndelingRegelViews_ZoekProducten(productclusterId: number, productclusterVeilgroepRegelId: number | null, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined): Promise<Anonymous21>;

    /**
     * Invoke function ZoekProductgroepen
     * @param productclusterId Usage: productclusterId={productclusterId}
     * @param productclusterVeilgroepRegelId Usage: productclusterVeilgroepRegelId={productclusterVeilgroepRegelId}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @return Success
     */
    veilgroepIndelingRegelViews_ZoekProductgroepen(productclusterId: number, productclusterVeilgroepRegelId: number | null, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined): Promise<Anonymous22>;

    /**
     * Get entities from VeilgroepIndelingRegelWithCodesView
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    veilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_ListVeilgroepIndelingRegelWithCodesView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepIndelingRegelWithCodesViewCollectionResponse>;

    /**
     * Add new entity to VeilgroepIndelingRegelWithCodesView
     * @param body New entity
     * @return Created entity
     */
    veilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_CreateVeilgroepIndelingRegelWithCodesView(body: VeilgroepIndelingRegelWithCodesView): Promise<VeilgroepIndelingRegelWithCodesView>;

    /**
     * Get entity from VeilgroepIndelingRegelWithCodesView by key
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelWithCodesView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    veilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_GetVeilgroepIndelingRegelWithCodesView(productclusterVeilgroepRegelId: number, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepIndelingRegelWithCodesView>;

    /**
     * Update entity in VeilgroepIndelingRegelWithCodesView
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelWithCodesView
     * @param body New property values
     * @return Success
     */
    veilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_UpdateVeilgroepIndelingRegelWithCodesView(productclusterVeilgroepRegelId: number, body: VeilgroepIndelingRegelWithCodesView): Promise<void>;

    /**
     * Delete entity from VeilgroepIndelingRegelWithCodesView
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelWithCodesView
     * @param if_Match (optional) ETag
     * @return Success
     */
    veilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_DeleteVeilgroepIndelingRegelWithCodesView(productclusterVeilgroepRegelId: number, if_Match: string | undefined): Promise<void>;

    /**
     * Invoke action UpsertSingleWithCodes
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelWithCodesView
     * @return Success
     */
    veilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_UpsertSingleWithCodes(productclusterVeilgroepRegelId: number): Promise<Anonymous23>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    veilgroepIndelingRegelWithCodesView_GetCount2fdd(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from VeilgroepRegelKenmerken
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    veilgroepRegelKenmerken_VeilgroepRegelKenmerk_ListVeilgroepRegelKenmerk(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepRegelKenmerkCollectionResponse>;

    /**
     * Add new entity to VeilgroepRegelKenmerken
     * @param body New entity
     * @return Created entity
     */
    veilgroepRegelKenmerken_VeilgroepRegelKenmerk_CreateVeilgroepRegelKenmerk(body: VeilgroepRegelKenmerk): Promise<VeilgroepRegelKenmerk>;

    /**
     * Get entity from VeilgroepRegelKenmerken by key
     * @param veilgroepRegelKenmerkId The unique identifier of VeilgroepRegelKenmerk
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    veilgroepRegelKenmerken_VeilgroepRegelKenmerk_GetVeilgroepRegelKenmerk(veilgroepRegelKenmerkId: number, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepRegelKenmerk>;

    /**
     * Update entity in VeilgroepRegelKenmerken
     * @param veilgroepRegelKenmerkId The unique identifier of VeilgroepRegelKenmerk
     * @param body New property values
     * @return Success
     */
    veilgroepRegelKenmerken_VeilgroepRegelKenmerk_UpdateVeilgroepRegelKenmerk(veilgroepRegelKenmerkId: number, body: VeilgroepRegelKenmerk): Promise<void>;

    /**
     * Delete entity from VeilgroepRegelKenmerken
     * @param veilgroepRegelKenmerkId The unique identifier of VeilgroepRegelKenmerk
     * @param if_Match (optional) ETag
     * @return Success
     */
    veilgroepRegelKenmerken_VeilgroepRegelKenmerk_DeleteVeilgroepRegelKenmerk(veilgroepRegelKenmerkId: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    veilgroepRegelKenmerken_GetCount046b(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Get entities from VeilgroepRegels
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    veilgroepRegels_VeilgroepRegel_ListVeilgroepRegel(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepRegelCollectionResponse>;

    /**
     * Add new entity to VeilgroepRegels
     * @param body New entity
     * @return Created entity
     */
    veilgroepRegels_VeilgroepRegel_CreateVeilgroepRegel(body: VeilgroepRegel): Promise<VeilgroepRegel>;

    /**
     * Get entity from VeilgroepRegels by key
     * @param veilgroepRegelId The unique identifier of VeilgroepRegel
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    veilgroepRegels_VeilgroepRegel_GetVeilgroepRegel(veilgroepRegelId: number, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepRegel>;

    /**
     * Update entity in VeilgroepRegels
     * @param veilgroepRegelId The unique identifier of VeilgroepRegel
     * @param body New property values
     * @return Success
     */
    veilgroepRegels_VeilgroepRegel_UpdateVeilgroepRegel(veilgroepRegelId: number, body: VeilgroepRegel): Promise<void>;

    /**
     * Delete entity from VeilgroepRegels
     * @param veilgroepRegelId The unique identifier of VeilgroepRegel
     * @param if_Match (optional) ETag
     * @return Success
     */
    veilgroepRegels_VeilgroepRegel_DeleteVeilgroepRegel(veilgroepRegelId: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    veilgroepRegels_GetCount9095(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Invoke function GetByRegelnummer
     * @param veilgroepRegelNummer Usage: veilgroepRegelNummer={veilgroepRegelNummer}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    veilgroepRegels_GetByRegelnummer(veilgroepRegelNummer: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous24>;

    /**
     * Invoke function GetClusterEnRegels
     * @param productCode Usage: productCode={productCode}
     * @return Success
     */
    veilgroepRegels_GetClusterEnRegelsDfe1(productCode: number | null): Promise<Anonymous25>;

    /**
     * Invoke function GetClusterEnRegels
     * @param productgroepCode Usage: productgroepCode={productgroepCode}
     * @return Success
     */
    veilgroepRegels_GetClusterEnRegels4adc(productgroepCode: number | null): Promise<Anonymous26>;

    /**
     * Invoke function ZoekVeilgroepRegels
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @return Success
     */
    veilgroepRegels_ZoekVeilgroepRegels(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined): Promise<Anonymous27>;

    /**
     * Get entities from VeilgroepTellingen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    veilgroepTellingen_VeildagVeilgroepTellingReport_ListVeildagVeilgroepTellingReport(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<VeildagVeilgroepTellingReportCollectionResponse>;

    /**
     * Add new entity to VeilgroepTellingen
     * @param body New entity
     * @return Created entity
     */
    veilgroepTellingen_VeildagVeilgroepTellingReport_CreateVeildagVeilgroepTellingReport(body: VeildagVeilgroepTellingReport): Promise<VeildagVeilgroepTellingReport>;

    /**
     * Get entity from VeilgroepTellingen by key
     * @param vestigingCode The unique identifier of VeildagVeilgroepTellingReport
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    veilgroepTellingen_VeildagVeilgroepTellingReport_GetVeildagVeilgroepTellingReport(vestigingCode: number, select: string[] | undefined, expand: string[] | undefined): Promise<VeildagVeilgroepTellingReport>;

    /**
     * Update entity in VeilgroepTellingen
     * @param vestigingCode The unique identifier of VeildagVeilgroepTellingReport
     * @param body New property values
     * @return Success
     */
    veilgroepTellingen_VeildagVeilgroepTellingReport_UpdateVeildagVeilgroepTellingReport(vestigingCode: number, body: VeildagVeilgroepTellingReport): Promise<void>;

    /**
     * Delete entity from VeilgroepTellingen
     * @param vestigingCode The unique identifier of VeildagVeilgroepTellingReport
     * @param if_Match (optional) ETag
     * @return Success
     */
    veilgroepTellingen_VeildagVeilgroepTellingReport_DeleteVeildagVeilgroepTellingReport(vestigingCode: number, if_Match: string | undefined): Promise<void>;

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    veilgroepTellingen_GetCount5f59(search: string | undefined, filter: string | undefined): Promise<number>;

    /**
     * Invoke function GetPerVeildatumKlokrange
     * @param veilDatum Usage: veilDatum={veilDatum}
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param klokNummerVan Usage: klokNummerVan={klokNummerVan}
     * @param klokNummerTotEnMet Usage: klokNummerTotEnMet={klokNummerTotEnMet}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    veilgroepTellingen_GetPerVeildatumKlokrange(veilDatum: Date, vestigingCode: number | null, klokNummerVan: number, klokNummerTotEnMet: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous28>;

    /**
     * Invoke function GetPerVeildatumVestiging
     * @param veilDatum Usage: veilDatum={veilDatum}
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    veilgroepTellingen_GetPerVeildatumVestiging(veilDatum: Date, vestigingCode: number | null, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous29>;
}

export class Client extends ClientBase implements IClient {
    protected http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost", baseUrl);
    }

    /**
     * Get entities from AanvoerderclusterAanvoerders
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_ListAanvoerderclusterAanvoerder(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderclusterAanvoerderCollectionResponse> {
        let url_ = this.baseUrl + "/AanvoerderclusterAanvoerders?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_ListAanvoerderclusterAanvoerder(_response));
        });
    }

    protected processAanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_ListAanvoerderclusterAanvoerder(response: Response): Promise<AanvoerderclusterAanvoerderCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderclusterAanvoerderCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to AanvoerderclusterAanvoerders
     * @param body New entity
     * @return Created entity
     */
    aanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_CreateAanvoerderclusterAanvoerder(body: AanvoerderclusterAanvoerder): Promise<AanvoerderclusterAanvoerder> {
        let url_ = this.baseUrl + "/AanvoerderclusterAanvoerders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_CreateAanvoerderclusterAanvoerder(_response));
        });
    }

    protected processAanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_CreateAanvoerderclusterAanvoerder(response: Response): Promise<AanvoerderclusterAanvoerder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AanvoerderclusterAanvoerder.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from AanvoerderclusterAanvoerders by key
     * @param aanvoerderclusterAanvoerderId The unique identifier of AanvoerderclusterAanvoerder
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_GetAanvoerderclusterAanvoerder(aanvoerderclusterAanvoerderId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderclusterAanvoerder> {
        let url_ = this.baseUrl + "/AanvoerderclusterAanvoerders({aanvoerderclusterAanvoerderId})?";
        if (aanvoerderclusterAanvoerderId === undefined || aanvoerderclusterAanvoerderId === null)
            throw new Error("The parameter 'aanvoerderclusterAanvoerderId' must be defined.");
        url_ = url_.replace("{aanvoerderclusterAanvoerderId}", encodeURIComponent("" + aanvoerderclusterAanvoerderId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_GetAanvoerderclusterAanvoerder(_response));
        });
    }

    protected processAanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_GetAanvoerderclusterAanvoerder(response: Response): Promise<AanvoerderclusterAanvoerder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderclusterAanvoerder.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in AanvoerderclusterAanvoerders
     * @param aanvoerderclusterAanvoerderId The unique identifier of AanvoerderclusterAanvoerder
     * @param body New property values
     * @return Success
     */
    aanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_UpdateAanvoerderclusterAanvoerder(aanvoerderclusterAanvoerderId: number, body: AanvoerderclusterAanvoerder): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderclusterAanvoerders({aanvoerderclusterAanvoerderId})";
        if (aanvoerderclusterAanvoerderId === undefined || aanvoerderclusterAanvoerderId === null)
            throw new Error("The parameter 'aanvoerderclusterAanvoerderId' must be defined.");
        url_ = url_.replace("{aanvoerderclusterAanvoerderId}", encodeURIComponent("" + aanvoerderclusterAanvoerderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_UpdateAanvoerderclusterAanvoerder(_response));
        });
    }

    protected processAanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_UpdateAanvoerderclusterAanvoerder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from AanvoerderclusterAanvoerders
     * @param aanvoerderclusterAanvoerderId The unique identifier of AanvoerderclusterAanvoerder
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_DeleteAanvoerderclusterAanvoerder(aanvoerderclusterAanvoerderId: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderclusterAanvoerders({aanvoerderclusterAanvoerderId})";
        if (aanvoerderclusterAanvoerderId === undefined || aanvoerderclusterAanvoerderId === null)
            throw new Error("The parameter 'aanvoerderclusterAanvoerderId' must be defined.");
        url_ = url_.replace("{aanvoerderclusterAanvoerderId}", encodeURIComponent("" + aanvoerderclusterAanvoerderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_DeleteAanvoerderclusterAanvoerder(_response));
        });
    }

    protected processAanvoerderclusterAanvoerders_AanvoerderclusterAanvoerder_DeleteAanvoerderclusterAanvoerder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderclusterAanvoerders_GetCount12e4(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/AanvoerderclusterAanvoerders/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusterAanvoerders_GetCount12e4(_response));
        });
    }

    protected processAanvoerderclusterAanvoerders_GetCount12e4(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from Aanvoerderclusters
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderclusters_Aanvoerdercluster_ListAanvoerdercluster(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderclusterCollectionResponse> {
        let url_ = this.baseUrl + "/Aanvoerderclusters?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusters_Aanvoerdercluster_ListAanvoerdercluster(_response));
        });
    }

    protected processAanvoerderclusters_Aanvoerdercluster_ListAanvoerdercluster(response: Response): Promise<AanvoerderclusterCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderclusterCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to Aanvoerderclusters
     * @param body New entity
     * @return Created entity
     */
    aanvoerderclusters_Aanvoerdercluster_CreateAanvoerdercluster(body: Aanvoerdercluster): Promise<Aanvoerdercluster> {
        let url_ = this.baseUrl + "/Aanvoerderclusters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusters_Aanvoerdercluster_CreateAanvoerdercluster(_response));
        });
    }

    protected processAanvoerderclusters_Aanvoerdercluster_CreateAanvoerdercluster(response: Response): Promise<Aanvoerdercluster> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Aanvoerdercluster.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from Aanvoerderclusters by key
     * @param aanvoerderclusterNummer The unique identifier of Aanvoerdercluster
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderclusters_Aanvoerdercluster_GetAanvoerdercluster(aanvoerderclusterNummer: number, select: string[] | undefined, expand: string[] | undefined): Promise<Aanvoerdercluster> {
        let url_ = this.baseUrl + "/Aanvoerderclusters({aanvoerderclusterNummer})?";
        if (aanvoerderclusterNummer === undefined || aanvoerderclusterNummer === null)
            throw new Error("The parameter 'aanvoerderclusterNummer' must be defined.");
        url_ = url_.replace("{aanvoerderclusterNummer}", encodeURIComponent("" + aanvoerderclusterNummer));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusters_Aanvoerdercluster_GetAanvoerdercluster(_response));
        });
    }

    protected processAanvoerderclusters_Aanvoerdercluster_GetAanvoerdercluster(response: Response): Promise<Aanvoerdercluster> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Aanvoerdercluster.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in Aanvoerderclusters
     * @param aanvoerderclusterNummer The unique identifier of Aanvoerdercluster
     * @param body New property values
     * @return Success
     */
    aanvoerderclusters_Aanvoerdercluster_UpdateAanvoerdercluster(aanvoerderclusterNummer: number, body: Aanvoerdercluster): Promise<void> {
        let url_ = this.baseUrl + "/Aanvoerderclusters({aanvoerderclusterNummer})";
        if (aanvoerderclusterNummer === undefined || aanvoerderclusterNummer === null)
            throw new Error("The parameter 'aanvoerderclusterNummer' must be defined.");
        url_ = url_.replace("{aanvoerderclusterNummer}", encodeURIComponent("" + aanvoerderclusterNummer));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusters_Aanvoerdercluster_UpdateAanvoerdercluster(_response));
        });
    }

    protected processAanvoerderclusters_Aanvoerdercluster_UpdateAanvoerdercluster(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from Aanvoerderclusters
     * @param aanvoerderclusterNummer The unique identifier of Aanvoerdercluster
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderclusters_Aanvoerdercluster_DeleteAanvoerdercluster(aanvoerderclusterNummer: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Aanvoerderclusters({aanvoerderclusterNummer})";
        if (aanvoerderclusterNummer === undefined || aanvoerderclusterNummer === null)
            throw new Error("The parameter 'aanvoerderclusterNummer' must be defined.");
        url_ = url_.replace("{aanvoerderclusterNummer}", encodeURIComponent("" + aanvoerderclusterNummer));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusters_Aanvoerdercluster_DeleteAanvoerdercluster(_response));
        });
    }

    protected processAanvoerderclusters_Aanvoerdercluster_DeleteAanvoerdercluster(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderclusters_GetCountC8ad(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Aanvoerderclusters/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusters_GetCountC8ad(_response));
        });
    }

    protected processAanvoerderclusters_GetCountC8ad(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from AanvoerderclusterViews
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderclusterViews_AanvoerderclusterView_ListAanvoerderclusterView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderclusterViewCollectionResponse> {
        let url_ = this.baseUrl + "/AanvoerderclusterViews?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusterViews_AanvoerderclusterView_ListAanvoerderclusterView(_response));
        });
    }

    protected processAanvoerderclusterViews_AanvoerderclusterView_ListAanvoerderclusterView(response: Response): Promise<AanvoerderclusterViewCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderclusterViewCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to AanvoerderclusterViews
     * @param body New entity
     * @return Created entity
     */
    aanvoerderclusterViews_AanvoerderclusterView_CreateAanvoerderclusterView(body: AanvoerderclusterView): Promise<AanvoerderclusterView> {
        let url_ = this.baseUrl + "/AanvoerderclusterViews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusterViews_AanvoerderclusterView_CreateAanvoerderclusterView(_response));
        });
    }

    protected processAanvoerderclusterViews_AanvoerderclusterView_CreateAanvoerderclusterView(response: Response): Promise<AanvoerderclusterView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AanvoerderclusterView.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from AanvoerderclusterViews by key
     * @param aanvoerderclusterNummer The unique identifier of AanvoerderclusterView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderclusterViews_AanvoerderclusterView_GetAanvoerderclusterView(aanvoerderclusterNummer: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderclusterView> {
        let url_ = this.baseUrl + "/AanvoerderclusterViews({aanvoerderclusterNummer})?";
        if (aanvoerderclusterNummer === undefined || aanvoerderclusterNummer === null)
            throw new Error("The parameter 'aanvoerderclusterNummer' must be defined.");
        url_ = url_.replace("{aanvoerderclusterNummer}", encodeURIComponent("" + aanvoerderclusterNummer));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusterViews_AanvoerderclusterView_GetAanvoerderclusterView(_response));
        });
    }

    protected processAanvoerderclusterViews_AanvoerderclusterView_GetAanvoerderclusterView(response: Response): Promise<AanvoerderclusterView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderclusterView.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in AanvoerderclusterViews
     * @param aanvoerderclusterNummer The unique identifier of AanvoerderclusterView
     * @param body New property values
     * @return Success
     */
    aanvoerderclusterViews_AanvoerderclusterView_UpdateAanvoerderclusterView(aanvoerderclusterNummer: number, body: AanvoerderclusterView): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderclusterViews({aanvoerderclusterNummer})";
        if (aanvoerderclusterNummer === undefined || aanvoerderclusterNummer === null)
            throw new Error("The parameter 'aanvoerderclusterNummer' must be defined.");
        url_ = url_.replace("{aanvoerderclusterNummer}", encodeURIComponent("" + aanvoerderclusterNummer));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusterViews_AanvoerderclusterView_UpdateAanvoerderclusterView(_response));
        });
    }

    protected processAanvoerderclusterViews_AanvoerderclusterView_UpdateAanvoerderclusterView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from AanvoerderclusterViews
     * @param aanvoerderclusterNummer The unique identifier of AanvoerderclusterView
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderclusterViews_AanvoerderclusterView_DeleteAanvoerderclusterView(aanvoerderclusterNummer: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderclusterViews({aanvoerderclusterNummer})";
        if (aanvoerderclusterNummer === undefined || aanvoerderclusterNummer === null)
            throw new Error("The parameter 'aanvoerderclusterNummer' must be defined.");
        url_ = url_.replace("{aanvoerderclusterNummer}", encodeURIComponent("" + aanvoerderclusterNummer));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusterViews_AanvoerderclusterView_DeleteAanvoerderclusterView(_response));
        });
    }

    protected processAanvoerderclusterViews_AanvoerderclusterView_DeleteAanvoerderclusterView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get aanvoerderclusterAanvoerders from AanvoerderclusterViews
     * @param aanvoerderclusterNummer The unique identifier of AanvoerderclusterView
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderclusterViews_ListAanvoerderclusterAanvoerders(aanvoerderclusterNummer: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderclusterAanvoerderCollectionResponse> {
        let url_ = this.baseUrl + "/AanvoerderclusterViews({aanvoerderclusterNummer})/aanvoerderclusterAanvoerders?";
        if (aanvoerderclusterNummer === undefined || aanvoerderclusterNummer === null)
            throw new Error("The parameter 'aanvoerderclusterNummer' must be defined.");
        url_ = url_.replace("{aanvoerderclusterNummer}", encodeURIComponent("" + aanvoerderclusterNummer));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusterViews_ListAanvoerderclusterAanvoerders(_response));
        });
    }

    protected processAanvoerderclusterViews_ListAanvoerderclusterAanvoerders(response: Response): Promise<AanvoerderclusterAanvoerderCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderclusterAanvoerderCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get aanvoerderclusterAanvoerders from AanvoerderclusterViews
     * @param aanvoerderclusterNummer The unique identifier of AanvoerderclusterView
     * @param aanvoerderclusterAanvoerderId The unique identifier of AanvoerderclusterAanvoerder
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved navigation property
     */
    aanvoerderclusterViews_GetAanvoerderclusterAanvoerders(aanvoerderclusterNummer: number, aanvoerderclusterAanvoerderId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderclusterAanvoerder> {
        let url_ = this.baseUrl + "/AanvoerderclusterViews({aanvoerderclusterNummer})/aanvoerderclusterAanvoerders({aanvoerderclusterAanvoerderId})?";
        if (aanvoerderclusterNummer === undefined || aanvoerderclusterNummer === null)
            throw new Error("The parameter 'aanvoerderclusterNummer' must be defined.");
        url_ = url_.replace("{aanvoerderclusterNummer}", encodeURIComponent("" + aanvoerderclusterNummer));
        if (aanvoerderclusterAanvoerderId === undefined || aanvoerderclusterAanvoerderId === null)
            throw new Error("The parameter 'aanvoerderclusterAanvoerderId' must be defined.");
        url_ = url_.replace("{aanvoerderclusterAanvoerderId}", encodeURIComponent("" + aanvoerderclusterAanvoerderId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusterViews_GetAanvoerderclusterAanvoerders(_response));
        });
    }

    protected processAanvoerderclusterViews_GetAanvoerderclusterAanvoerders(response: Response): Promise<AanvoerderclusterAanvoerder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderclusterAanvoerder.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param aanvoerderclusterNummer The unique identifier of AanvoerderclusterView
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderclusterViews_aanvoerderclusterAanvoerders_GetCount6b58(aanvoerderclusterNummer: number, search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/AanvoerderclusterViews({aanvoerderclusterNummer})/aanvoerderclusterAanvoerders/$count?";
        if (aanvoerderclusterNummer === undefined || aanvoerderclusterNummer === null)
            throw new Error("The parameter 'aanvoerderclusterNummer' must be defined.");
        url_ = url_.replace("{aanvoerderclusterNummer}", encodeURIComponent("" + aanvoerderclusterNummer));
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusterViews_aanvoerderclusterAanvoerders_GetCount6b58(_response));
        });
    }

    protected processAanvoerderclusterViews_aanvoerderclusterAanvoerders_GetCount6b58(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderclusterViews_GetCount4011(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/AanvoerderclusterViews/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderclusterViews_GetCount4011(_response));
        });
    }

    protected processAanvoerderclusterViews_GetCount4011(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from AanvoerderOnregelmatig
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderOnregelmatig_AanvoerderOnregelmatig_ListAanvoerderOnregelmatig(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderOnregelmatigCollectionResponse> {
        let url_ = this.baseUrl + "/AanvoerderOnregelmatig?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderOnregelmatig_AanvoerderOnregelmatig_ListAanvoerderOnregelmatig(_response));
        });
    }

    protected processAanvoerderOnregelmatig_AanvoerderOnregelmatig_ListAanvoerderOnregelmatig(response: Response): Promise<AanvoerderOnregelmatigCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderOnregelmatigCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to AanvoerderOnregelmatig
     * @param body New entity
     * @return Created entity
     */
    aanvoerderOnregelmatig_AanvoerderOnregelmatig_CreateAanvoerderOnregelmatig(body: AanvoerderOnregelmatig): Promise<AanvoerderOnregelmatig> {
        let url_ = this.baseUrl + "/AanvoerderOnregelmatig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderOnregelmatig_AanvoerderOnregelmatig_CreateAanvoerderOnregelmatig(_response));
        });
    }

    protected processAanvoerderOnregelmatig_AanvoerderOnregelmatig_CreateAanvoerderOnregelmatig(response: Response): Promise<AanvoerderOnregelmatig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AanvoerderOnregelmatig.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from AanvoerderOnregelmatig by key
     * @param aanvoerderOnregelmatigId The unique identifier of AanvoerderOnregelmatig
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderOnregelmatig_AanvoerderOnregelmatig_GetAanvoerderOnregelmatig(aanvoerderOnregelmatigId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderOnregelmatig> {
        let url_ = this.baseUrl + "/AanvoerderOnregelmatig({aanvoerderOnregelmatigId})?";
        if (aanvoerderOnregelmatigId === undefined || aanvoerderOnregelmatigId === null)
            throw new Error("The parameter 'aanvoerderOnregelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderOnregelmatigId}", encodeURIComponent("" + aanvoerderOnregelmatigId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderOnregelmatig_AanvoerderOnregelmatig_GetAanvoerderOnregelmatig(_response));
        });
    }

    protected processAanvoerderOnregelmatig_AanvoerderOnregelmatig_GetAanvoerderOnregelmatig(response: Response): Promise<AanvoerderOnregelmatig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderOnregelmatig.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in AanvoerderOnregelmatig
     * @param aanvoerderOnregelmatigId The unique identifier of AanvoerderOnregelmatig
     * @param body New property values
     * @return Success
     */
    aanvoerderOnregelmatig_AanvoerderOnregelmatig_UpdateAanvoerderOnregelmatig(aanvoerderOnregelmatigId: number, body: AanvoerderOnregelmatig): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderOnregelmatig({aanvoerderOnregelmatigId})";
        if (aanvoerderOnregelmatigId === undefined || aanvoerderOnregelmatigId === null)
            throw new Error("The parameter 'aanvoerderOnregelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderOnregelmatigId}", encodeURIComponent("" + aanvoerderOnregelmatigId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderOnregelmatig_AanvoerderOnregelmatig_UpdateAanvoerderOnregelmatig(_response));
        });
    }

    protected processAanvoerderOnregelmatig_AanvoerderOnregelmatig_UpdateAanvoerderOnregelmatig(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from AanvoerderOnregelmatig
     * @param aanvoerderOnregelmatigId The unique identifier of AanvoerderOnregelmatig
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderOnregelmatig_AanvoerderOnregelmatig_DeleteAanvoerderOnregelmatig(aanvoerderOnregelmatigId: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderOnregelmatig({aanvoerderOnregelmatigId})";
        if (aanvoerderOnregelmatigId === undefined || aanvoerderOnregelmatigId === null)
            throw new Error("The parameter 'aanvoerderOnregelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderOnregelmatigId}", encodeURIComponent("" + aanvoerderOnregelmatigId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderOnregelmatig_AanvoerderOnregelmatig_DeleteAanvoerderOnregelmatig(_response));
        });
    }

    protected processAanvoerderOnregelmatig_AanvoerderOnregelmatig_DeleteAanvoerderOnregelmatig(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke action Delete
     * @param aanvoerderOnregelmatigId The unique identifier of AanvoerderOnregelmatig
     * @param body Action parameters
     * @return Success
     */
    aanvoerderOnregelmatig_AanvoerderOnregelmatig_Delete(aanvoerderOnregelmatigId: number, body: Body): Promise<Anonymous> {
        let url_ = this.baseUrl + "/AanvoerderOnregelmatig({aanvoerderOnregelmatigId})/AanbodBeheerService.Delete";
        if (aanvoerderOnregelmatigId === undefined || aanvoerderOnregelmatigId === null)
            throw new Error("The parameter 'aanvoerderOnregelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderOnregelmatigId}", encodeURIComponent("" + aanvoerderOnregelmatigId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderOnregelmatig_AanvoerderOnregelmatig_Delete(_response));
        });
    }

    protected processAanvoerderOnregelmatig_AanvoerderOnregelmatig_Delete(response: Response): Promise<Anonymous> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderOnregelmatig_GetCountD8b3(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/AanvoerderOnregelmatig/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderOnregelmatig_GetCountD8b3(_response));
        });
    }

    protected processAanvoerderOnregelmatig_GetCountD8b3(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function GetAanvoerderOnregelmatig
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    aanvoerderOnregelmatig_GetAanvoerderOnregelmatig(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous2> {
        let url_ = this.baseUrl + "/AanvoerderOnregelmatig/AanbodBeheerService.GetAanvoerderOnregelmatig()?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderOnregelmatig_GetAanvoerderOnregelmatig(_response));
        });
    }

    protected processAanvoerderOnregelmatig_GetAanvoerderOnregelmatig(response: Response): Promise<Anonymous2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous2.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from AanvoerderProductgroepRegelmatigs
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_ListAanvoerderProductgroepRegelmatig(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatigCollectionResponse> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigs?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_ListAanvoerderProductgroepRegelmatig(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_ListAanvoerderProductgroepRegelmatig(response: Response): Promise<AanvoerderProductgroepRegelmatigCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductgroepRegelmatigCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to AanvoerderProductgroepRegelmatigs
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_CreateAanvoerderProductgroepRegelmatig(body: AanvoerderProductgroepRegelmatig): Promise<AanvoerderProductgroepRegelmatig> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_CreateAanvoerderProductgroepRegelmatig(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_CreateAanvoerderProductgroepRegelmatig(response: Response): Promise<AanvoerderProductgroepRegelmatig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AanvoerderProductgroepRegelmatig.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from AanvoerderProductgroepRegelmatigs by key
     * @param aanvoerderProductgroepRegelmatigId The unique identifier of AanvoerderProductgroepRegelmatig
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_GetAanvoerderProductgroepRegelmatig(aanvoerderProductgroepRegelmatigId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatig> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigs({aanvoerderProductgroepRegelmatigId})?";
        if (aanvoerderProductgroepRegelmatigId === undefined || aanvoerderProductgroepRegelmatigId === null)
            throw new Error("The parameter 'aanvoerderProductgroepRegelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderProductgroepRegelmatigId}", encodeURIComponent("" + aanvoerderProductgroepRegelmatigId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_GetAanvoerderProductgroepRegelmatig(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_GetAanvoerderProductgroepRegelmatig(response: Response): Promise<AanvoerderProductgroepRegelmatig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductgroepRegelmatig.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in AanvoerderProductgroepRegelmatigs
     * @param aanvoerderProductgroepRegelmatigId The unique identifier of AanvoerderProductgroepRegelmatig
     * @param body New property values
     * @return Success
     */
    aanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_UpdateAanvoerderProductgroepRegelmatig(aanvoerderProductgroepRegelmatigId: number, body: AanvoerderProductgroepRegelmatig): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigs({aanvoerderProductgroepRegelmatigId})";
        if (aanvoerderProductgroepRegelmatigId === undefined || aanvoerderProductgroepRegelmatigId === null)
            throw new Error("The parameter 'aanvoerderProductgroepRegelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderProductgroepRegelmatigId}", encodeURIComponent("" + aanvoerderProductgroepRegelmatigId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_UpdateAanvoerderProductgroepRegelmatig(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_UpdateAanvoerderProductgroepRegelmatig(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from AanvoerderProductgroepRegelmatigs
     * @param aanvoerderProductgroepRegelmatigId The unique identifier of AanvoerderProductgroepRegelmatig
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_DeleteAanvoerderProductgroepRegelmatig(aanvoerderProductgroepRegelmatigId: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigs({aanvoerderProductgroepRegelmatigId})";
        if (aanvoerderProductgroepRegelmatigId === undefined || aanvoerderProductgroepRegelmatigId === null)
            throw new Error("The parameter 'aanvoerderProductgroepRegelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderProductgroepRegelmatigId}", encodeURIComponent("" + aanvoerderProductgroepRegelmatigId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_DeleteAanvoerderProductgroepRegelmatig(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigs_AanvoerderProductgroepRegelmatig_DeleteAanvoerderProductgroepRegelmatig(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductgroepRegelmatigs_GetCountAffe(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigs/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigs_GetCountAffe(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigs_GetCountAffe(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from AanvoerderProductgroepRegelmatigUitzonderingen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_ListAanvoerderProductgroepRegelmatigUitzondering(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatigUitzonderingCollectionResponse> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigUitzonderingen?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_ListAanvoerderProductgroepRegelmatigUitzondering(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_ListAanvoerderProductgroepRegelmatigUitzondering(response: Response): Promise<AanvoerderProductgroepRegelmatigUitzonderingCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductgroepRegelmatigUitzonderingCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to AanvoerderProductgroepRegelmatigUitzonderingen
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_CreateAanvoerderProductgroepRegelmatigUitzondering(body: AanvoerderProductgroepRegelmatigUitzondering): Promise<AanvoerderProductgroepRegelmatigUitzondering> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigUitzonderingen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_CreateAanvoerderProductgroepRegelmatigUitzondering(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_CreateAanvoerderProductgroepRegelmatigUitzondering(response: Response): Promise<AanvoerderProductgroepRegelmatigUitzondering> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AanvoerderProductgroepRegelmatigUitzondering.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from AanvoerderProductgroepRegelmatigUitzonderingen by key
     * @param aanvoerderProductgroepRegelmatigUitzonderingId The unique identifier of AanvoerderProductgroepRegelmatigUitzondering
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_GetAanvoerderProductgroepRegelmatigUitzondering(aanvoerderProductgroepRegelmatigUitzonderingId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatigUitzondering> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigUitzonderingen({aanvoerderProductgroepRegelmatigUitzonderingId})?";
        if (aanvoerderProductgroepRegelmatigUitzonderingId === undefined || aanvoerderProductgroepRegelmatigUitzonderingId === null)
            throw new Error("The parameter 'aanvoerderProductgroepRegelmatigUitzonderingId' must be defined.");
        url_ = url_.replace("{aanvoerderProductgroepRegelmatigUitzonderingId}", encodeURIComponent("" + aanvoerderProductgroepRegelmatigUitzonderingId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_GetAanvoerderProductgroepRegelmatigUitzondering(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_GetAanvoerderProductgroepRegelmatigUitzondering(response: Response): Promise<AanvoerderProductgroepRegelmatigUitzondering> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductgroepRegelmatigUitzondering.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in AanvoerderProductgroepRegelmatigUitzonderingen
     * @param aanvoerderProductgroepRegelmatigUitzonderingId The unique identifier of AanvoerderProductgroepRegelmatigUitzondering
     * @param body New property values
     * @return Success
     */
    aanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_UpdateAanvoerderProductgroepRegelmatigUitzondering(aanvoerderProductgroepRegelmatigUitzonderingId: number, body: AanvoerderProductgroepRegelmatigUitzondering): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigUitzonderingen({aanvoerderProductgroepRegelmatigUitzonderingId})";
        if (aanvoerderProductgroepRegelmatigUitzonderingId === undefined || aanvoerderProductgroepRegelmatigUitzonderingId === null)
            throw new Error("The parameter 'aanvoerderProductgroepRegelmatigUitzonderingId' must be defined.");
        url_ = url_.replace("{aanvoerderProductgroepRegelmatigUitzonderingId}", encodeURIComponent("" + aanvoerderProductgroepRegelmatigUitzonderingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_UpdateAanvoerderProductgroepRegelmatigUitzondering(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_UpdateAanvoerderProductgroepRegelmatigUitzondering(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from AanvoerderProductgroepRegelmatigUitzonderingen
     * @param aanvoerderProductgroepRegelmatigUitzonderingId The unique identifier of AanvoerderProductgroepRegelmatigUitzondering
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_DeleteAanvoerderProductgroepRegelmatigUitzondering(aanvoerderProductgroepRegelmatigUitzonderingId: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigUitzonderingen({aanvoerderProductgroepRegelmatigUitzonderingId})";
        if (aanvoerderProductgroepRegelmatigUitzonderingId === undefined || aanvoerderProductgroepRegelmatigUitzonderingId === null)
            throw new Error("The parameter 'aanvoerderProductgroepRegelmatigUitzonderingId' must be defined.");
        url_ = url_.replace("{aanvoerderProductgroepRegelmatigUitzonderingId}", encodeURIComponent("" + aanvoerderProductgroepRegelmatigUitzonderingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_DeleteAanvoerderProductgroepRegelmatigUitzondering(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigUitzonderingen_AanvoerderProductgroepRegelmatigUitzondering_DeleteAanvoerderProductgroepRegelmatigUitzondering(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductgroepRegelmatigUitzonderingen_GetCountDd2b(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigUitzonderingen/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigUitzonderingen_GetCountDd2b(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigUitzonderingen_GetCountDd2b(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from AanvoerderProductgroepRegelmatigUitzonderingenViews
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_ListAanvoerderProductgroepRegelmatigUitzonderingView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatigUitzonderingViewCollectionResponse> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigUitzonderingenViews?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_ListAanvoerderProductgroepRegelmatigUitzonderingView(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_ListAanvoerderProductgroepRegelmatigUitzonderingView(response: Response): Promise<AanvoerderProductgroepRegelmatigUitzonderingViewCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductgroepRegelmatigUitzonderingViewCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to AanvoerderProductgroepRegelmatigUitzonderingenViews
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_CreateAanvoerderProductgroepRegelmatigUitzonderingView(body: AanvoerderProductgroepRegelmatigUitzonderingView): Promise<AanvoerderProductgroepRegelmatigUitzonderingView> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigUitzonderingenViews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_CreateAanvoerderProductgroepRegelmatigUitzonderingView(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_CreateAanvoerderProductgroepRegelmatigUitzonderingView(response: Response): Promise<AanvoerderProductgroepRegelmatigUitzonderingView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AanvoerderProductgroepRegelmatigUitzonderingView.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from AanvoerderProductgroepRegelmatigUitzonderingenViews by key
     * @param aanvoerderProductgroepRegelmatigUitzonderingId The unique identifier of AanvoerderProductgroepRegelmatigUitzonderingView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_GetAanvoerderProductgroepRegelmatigUitzonderingView(aanvoerderProductgroepRegelmatigUitzonderingId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatigUitzonderingView> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigUitzonderingenViews({aanvoerderProductgroepRegelmatigUitzonderingId})?";
        if (aanvoerderProductgroepRegelmatigUitzonderingId === undefined || aanvoerderProductgroepRegelmatigUitzonderingId === null)
            throw new Error("The parameter 'aanvoerderProductgroepRegelmatigUitzonderingId' must be defined.");
        url_ = url_.replace("{aanvoerderProductgroepRegelmatigUitzonderingId}", encodeURIComponent("" + aanvoerderProductgroepRegelmatigUitzonderingId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_GetAanvoerderProductgroepRegelmatigUitzonderingView(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_GetAanvoerderProductgroepRegelmatigUitzonderingView(response: Response): Promise<AanvoerderProductgroepRegelmatigUitzonderingView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductgroepRegelmatigUitzonderingView.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in AanvoerderProductgroepRegelmatigUitzonderingenViews
     * @param aanvoerderProductgroepRegelmatigUitzonderingId The unique identifier of AanvoerderProductgroepRegelmatigUitzonderingView
     * @param body New property values
     * @return Success
     */
    aanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_UpdateAanvoerderProductgroepRegelmatigUitzonderingView(aanvoerderProductgroepRegelmatigUitzonderingId: number, body: AanvoerderProductgroepRegelmatigUitzonderingView): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigUitzonderingenViews({aanvoerderProductgroepRegelmatigUitzonderingId})";
        if (aanvoerderProductgroepRegelmatigUitzonderingId === undefined || aanvoerderProductgroepRegelmatigUitzonderingId === null)
            throw new Error("The parameter 'aanvoerderProductgroepRegelmatigUitzonderingId' must be defined.");
        url_ = url_.replace("{aanvoerderProductgroepRegelmatigUitzonderingId}", encodeURIComponent("" + aanvoerderProductgroepRegelmatigUitzonderingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_UpdateAanvoerderProductgroepRegelmatigUitzonderingView(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_UpdateAanvoerderProductgroepRegelmatigUitzonderingView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from AanvoerderProductgroepRegelmatigUitzonderingenViews
     * @param aanvoerderProductgroepRegelmatigUitzonderingId The unique identifier of AanvoerderProductgroepRegelmatigUitzonderingView
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_DeleteAanvoerderProductgroepRegelmatigUitzonderingView(aanvoerderProductgroepRegelmatigUitzonderingId: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigUitzonderingenViews({aanvoerderProductgroepRegelmatigUitzonderingId})";
        if (aanvoerderProductgroepRegelmatigUitzonderingId === undefined || aanvoerderProductgroepRegelmatigUitzonderingId === null)
            throw new Error("The parameter 'aanvoerderProductgroepRegelmatigUitzonderingId' must be defined.");
        url_ = url_.replace("{aanvoerderProductgroepRegelmatigUitzonderingId}", encodeURIComponent("" + aanvoerderProductgroepRegelmatigUitzonderingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_DeleteAanvoerderProductgroepRegelmatigUitzonderingView(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigUitzonderingenViews_AanvoerderProductgroepRegelmatigUitzonderingView_DeleteAanvoerderProductgroepRegelmatigUitzonderingView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductgroepRegelmatigUitzonderingenViews_GetCount7939(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigUitzonderingenViews/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigUitzonderingenViews_GetCount7939(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigUitzonderingenViews_GetCount7939(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from AanvoerderProductgroepRegelmatigViews
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_ListAanvoerderProductgroepRegelmatigView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatigViewCollectionResponse> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigViews?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_ListAanvoerderProductgroepRegelmatigView(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_ListAanvoerderProductgroepRegelmatigView(response: Response): Promise<AanvoerderProductgroepRegelmatigViewCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductgroepRegelmatigViewCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to AanvoerderProductgroepRegelmatigViews
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_CreateAanvoerderProductgroepRegelmatigView(body: AanvoerderProductgroepRegelmatigView): Promise<AanvoerderProductgroepRegelmatigView> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigViews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_CreateAanvoerderProductgroepRegelmatigView(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_CreateAanvoerderProductgroepRegelmatigView(response: Response): Promise<AanvoerderProductgroepRegelmatigView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AanvoerderProductgroepRegelmatigView.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from AanvoerderProductgroepRegelmatigViews by key
     * @param aanvoerderProductgroepRegelmatigId The unique identifier of AanvoerderProductgroepRegelmatigView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_GetAanvoerderProductgroepRegelmatigView(aanvoerderProductgroepRegelmatigId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductgroepRegelmatigView> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigViews({aanvoerderProductgroepRegelmatigId})?";
        if (aanvoerderProductgroepRegelmatigId === undefined || aanvoerderProductgroepRegelmatigId === null)
            throw new Error("The parameter 'aanvoerderProductgroepRegelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderProductgroepRegelmatigId}", encodeURIComponent("" + aanvoerderProductgroepRegelmatigId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_GetAanvoerderProductgroepRegelmatigView(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_GetAanvoerderProductgroepRegelmatigView(response: Response): Promise<AanvoerderProductgroepRegelmatigView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductgroepRegelmatigView.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in AanvoerderProductgroepRegelmatigViews
     * @param aanvoerderProductgroepRegelmatigId The unique identifier of AanvoerderProductgroepRegelmatigView
     * @param body New property values
     * @return Success
     */
    aanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_UpdateAanvoerderProductgroepRegelmatigView(aanvoerderProductgroepRegelmatigId: number, body: AanvoerderProductgroepRegelmatigView): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigViews({aanvoerderProductgroepRegelmatigId})";
        if (aanvoerderProductgroepRegelmatigId === undefined || aanvoerderProductgroepRegelmatigId === null)
            throw new Error("The parameter 'aanvoerderProductgroepRegelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderProductgroepRegelmatigId}", encodeURIComponent("" + aanvoerderProductgroepRegelmatigId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_UpdateAanvoerderProductgroepRegelmatigView(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_UpdateAanvoerderProductgroepRegelmatigView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from AanvoerderProductgroepRegelmatigViews
     * @param aanvoerderProductgroepRegelmatigId The unique identifier of AanvoerderProductgroepRegelmatigView
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_DeleteAanvoerderProductgroepRegelmatigView(aanvoerderProductgroepRegelmatigId: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigViews({aanvoerderProductgroepRegelmatigId})";
        if (aanvoerderProductgroepRegelmatigId === undefined || aanvoerderProductgroepRegelmatigId === null)
            throw new Error("The parameter 'aanvoerderProductgroepRegelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderProductgroepRegelmatigId}", encodeURIComponent("" + aanvoerderProductgroepRegelmatigId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_DeleteAanvoerderProductgroepRegelmatigView(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigViews_AanvoerderProductgroepRegelmatigView_DeleteAanvoerderProductgroepRegelmatigView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductgroepRegelmatigViews_GetCountB8a7(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigViews/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigViews_GetCountB8a7(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigViews_GetCountB8a7(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function ZoekHistorie
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param aanvoerderNummer Usage: aanvoerderNummer={aanvoerderNummer}
     * @param productgroepCode Usage: productgroepCode={productgroepCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    aanvoerderProductgroepRegelmatigViews_ZoekHistorie(vestigingCode: number, aanvoerderNummer: number, productgroepCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous3> {
        let url_ = this.baseUrl + "/AanvoerderProductgroepRegelmatigViews/AanbodBeheerService.ZoekHistorie(vestigingCode={vestigingCode},aanvoerderNummer={aanvoerderNummer},productgroepCode={productgroepCode})?";
        if (vestigingCode === undefined || vestigingCode === null)
            throw new Error("The parameter 'vestigingCode' must be defined.");
        url_ = url_.replace("{vestigingCode}", encodeURIComponent("" + vestigingCode));
        if (aanvoerderNummer === undefined || aanvoerderNummer === null)
            throw new Error("The parameter 'aanvoerderNummer' must be defined.");
        url_ = url_.replace("{aanvoerderNummer}", encodeURIComponent("" + aanvoerderNummer));
        if (productgroepCode === undefined || productgroepCode === null)
            throw new Error("The parameter 'productgroepCode' must be defined.");
        url_ = url_.replace("{productgroepCode}", encodeURIComponent("" + productgroepCode));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductgroepRegelmatigViews_ZoekHistorie(_response));
        });
    }

    protected processAanvoerderProductgroepRegelmatigViews_ZoekHistorie(response: Response): Promise<Anonymous3> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous3.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from AanvoerderProductRegelmatigs
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_ListAanvoerderProductRegelmatig(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatigCollectionResponse> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigs?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_ListAanvoerderProductRegelmatig(_response));
        });
    }

    protected processAanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_ListAanvoerderProductRegelmatig(response: Response): Promise<AanvoerderProductRegelmatigCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductRegelmatigCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to AanvoerderProductRegelmatigs
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_CreateAanvoerderProductRegelmatig(body: AanvoerderProductRegelmatig): Promise<AanvoerderProductRegelmatig> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_CreateAanvoerderProductRegelmatig(_response));
        });
    }

    protected processAanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_CreateAanvoerderProductRegelmatig(response: Response): Promise<AanvoerderProductRegelmatig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AanvoerderProductRegelmatig.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from AanvoerderProductRegelmatigs by key
     * @param aanvoerderProductRegelmatigId The unique identifier of AanvoerderProductRegelmatig
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_GetAanvoerderProductRegelmatig(aanvoerderProductRegelmatigId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatig> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigs({aanvoerderProductRegelmatigId})?";
        if (aanvoerderProductRegelmatigId === undefined || aanvoerderProductRegelmatigId === null)
            throw new Error("The parameter 'aanvoerderProductRegelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderProductRegelmatigId}", encodeURIComponent("" + aanvoerderProductRegelmatigId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_GetAanvoerderProductRegelmatig(_response));
        });
    }

    protected processAanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_GetAanvoerderProductRegelmatig(response: Response): Promise<AanvoerderProductRegelmatig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductRegelmatig.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in AanvoerderProductRegelmatigs
     * @param aanvoerderProductRegelmatigId The unique identifier of AanvoerderProductRegelmatig
     * @param body New property values
     * @return Success
     */
    aanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_UpdateAanvoerderProductRegelmatig(aanvoerderProductRegelmatigId: number, body: AanvoerderProductRegelmatig): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigs({aanvoerderProductRegelmatigId})";
        if (aanvoerderProductRegelmatigId === undefined || aanvoerderProductRegelmatigId === null)
            throw new Error("The parameter 'aanvoerderProductRegelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderProductRegelmatigId}", encodeURIComponent("" + aanvoerderProductRegelmatigId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_UpdateAanvoerderProductRegelmatig(_response));
        });
    }

    protected processAanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_UpdateAanvoerderProductRegelmatig(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from AanvoerderProductRegelmatigs
     * @param aanvoerderProductRegelmatigId The unique identifier of AanvoerderProductRegelmatig
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_DeleteAanvoerderProductRegelmatig(aanvoerderProductRegelmatigId: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigs({aanvoerderProductRegelmatigId})";
        if (aanvoerderProductRegelmatigId === undefined || aanvoerderProductRegelmatigId === null)
            throw new Error("The parameter 'aanvoerderProductRegelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderProductRegelmatigId}", encodeURIComponent("" + aanvoerderProductRegelmatigId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_DeleteAanvoerderProductRegelmatig(_response));
        });
    }

    protected processAanvoerderProductRegelmatigs_AanvoerderProductRegelmatig_DeleteAanvoerderProductRegelmatig(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductRegelmatigs_GetCount8877(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigs/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigs_GetCount8877(_response));
        });
    }

    protected processAanvoerderProductRegelmatigs_GetCount8877(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from AanvoerderProductRegelmatigUitzonderingen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_ListAanvoerderProductRegelmatigUitzondering(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatigUitzonderingCollectionResponse> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigUitzonderingen?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_ListAanvoerderProductRegelmatigUitzondering(_response));
        });
    }

    protected processAanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_ListAanvoerderProductRegelmatigUitzondering(response: Response): Promise<AanvoerderProductRegelmatigUitzonderingCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductRegelmatigUitzonderingCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to AanvoerderProductRegelmatigUitzonderingen
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_CreateAanvoerderProductRegelmatigUitzondering(body: AanvoerderProductRegelmatigUitzondering): Promise<AanvoerderProductRegelmatigUitzondering> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigUitzonderingen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_CreateAanvoerderProductRegelmatigUitzondering(_response));
        });
    }

    protected processAanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_CreateAanvoerderProductRegelmatigUitzondering(response: Response): Promise<AanvoerderProductRegelmatigUitzondering> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AanvoerderProductRegelmatigUitzondering.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from AanvoerderProductRegelmatigUitzonderingen by key
     * @param aanvoerderProductRegelmatigUitzonderingId The unique identifier of AanvoerderProductRegelmatigUitzondering
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_GetAanvoerderProductRegelmatigUitzondering(aanvoerderProductRegelmatigUitzonderingId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatigUitzondering> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigUitzonderingen({aanvoerderProductRegelmatigUitzonderingId})?";
        if (aanvoerderProductRegelmatigUitzonderingId === undefined || aanvoerderProductRegelmatigUitzonderingId === null)
            throw new Error("The parameter 'aanvoerderProductRegelmatigUitzonderingId' must be defined.");
        url_ = url_.replace("{aanvoerderProductRegelmatigUitzonderingId}", encodeURIComponent("" + aanvoerderProductRegelmatigUitzonderingId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_GetAanvoerderProductRegelmatigUitzondering(_response));
        });
    }

    protected processAanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_GetAanvoerderProductRegelmatigUitzondering(response: Response): Promise<AanvoerderProductRegelmatigUitzondering> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductRegelmatigUitzondering.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in AanvoerderProductRegelmatigUitzonderingen
     * @param aanvoerderProductRegelmatigUitzonderingId The unique identifier of AanvoerderProductRegelmatigUitzondering
     * @param body New property values
     * @return Success
     */
    aanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_UpdateAanvoerderProductRegelmatigUitzondering(aanvoerderProductRegelmatigUitzonderingId: number, body: AanvoerderProductRegelmatigUitzondering): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigUitzonderingen({aanvoerderProductRegelmatigUitzonderingId})";
        if (aanvoerderProductRegelmatigUitzonderingId === undefined || aanvoerderProductRegelmatigUitzonderingId === null)
            throw new Error("The parameter 'aanvoerderProductRegelmatigUitzonderingId' must be defined.");
        url_ = url_.replace("{aanvoerderProductRegelmatigUitzonderingId}", encodeURIComponent("" + aanvoerderProductRegelmatigUitzonderingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_UpdateAanvoerderProductRegelmatigUitzondering(_response));
        });
    }

    protected processAanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_UpdateAanvoerderProductRegelmatigUitzondering(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from AanvoerderProductRegelmatigUitzonderingen
     * @param aanvoerderProductRegelmatigUitzonderingId The unique identifier of AanvoerderProductRegelmatigUitzondering
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_DeleteAanvoerderProductRegelmatigUitzondering(aanvoerderProductRegelmatigUitzonderingId: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigUitzonderingen({aanvoerderProductRegelmatigUitzonderingId})";
        if (aanvoerderProductRegelmatigUitzonderingId === undefined || aanvoerderProductRegelmatigUitzonderingId === null)
            throw new Error("The parameter 'aanvoerderProductRegelmatigUitzonderingId' must be defined.");
        url_ = url_.replace("{aanvoerderProductRegelmatigUitzonderingId}", encodeURIComponent("" + aanvoerderProductRegelmatigUitzonderingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_DeleteAanvoerderProductRegelmatigUitzondering(_response));
        });
    }

    protected processAanvoerderProductRegelmatigUitzonderingen_AanvoerderProductRegelmatigUitzondering_DeleteAanvoerderProductRegelmatigUitzondering(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductRegelmatigUitzonderingen_GetCount5d33(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigUitzonderingen/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigUitzonderingen_GetCount5d33(_response));
        });
    }

    protected processAanvoerderProductRegelmatigUitzonderingen_GetCount5d33(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from AanvoerderProductRegelmatigUitzonderingenViews
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_ListAanvoerderProductRegelmatigUitzonderingView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatigUitzonderingViewCollectionResponse> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigUitzonderingenViews?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_ListAanvoerderProductRegelmatigUitzonderingView(_response));
        });
    }

    protected processAanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_ListAanvoerderProductRegelmatigUitzonderingView(response: Response): Promise<AanvoerderProductRegelmatigUitzonderingViewCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductRegelmatigUitzonderingViewCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to AanvoerderProductRegelmatigUitzonderingenViews
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_CreateAanvoerderProductRegelmatigUitzonderingView(body: AanvoerderProductRegelmatigUitzonderingView): Promise<AanvoerderProductRegelmatigUitzonderingView> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigUitzonderingenViews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_CreateAanvoerderProductRegelmatigUitzonderingView(_response));
        });
    }

    protected processAanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_CreateAanvoerderProductRegelmatigUitzonderingView(response: Response): Promise<AanvoerderProductRegelmatigUitzonderingView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AanvoerderProductRegelmatigUitzonderingView.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from AanvoerderProductRegelmatigUitzonderingenViews by key
     * @param aanvoerderProductRegelmatigUitzonderingId The unique identifier of AanvoerderProductRegelmatigUitzonderingView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_GetAanvoerderProductRegelmatigUitzonderingView(aanvoerderProductRegelmatigUitzonderingId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatigUitzonderingView> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigUitzonderingenViews({aanvoerderProductRegelmatigUitzonderingId})?";
        if (aanvoerderProductRegelmatigUitzonderingId === undefined || aanvoerderProductRegelmatigUitzonderingId === null)
            throw new Error("The parameter 'aanvoerderProductRegelmatigUitzonderingId' must be defined.");
        url_ = url_.replace("{aanvoerderProductRegelmatigUitzonderingId}", encodeURIComponent("" + aanvoerderProductRegelmatigUitzonderingId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_GetAanvoerderProductRegelmatigUitzonderingView(_response));
        });
    }

    protected processAanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_GetAanvoerderProductRegelmatigUitzonderingView(response: Response): Promise<AanvoerderProductRegelmatigUitzonderingView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductRegelmatigUitzonderingView.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in AanvoerderProductRegelmatigUitzonderingenViews
     * @param aanvoerderProductRegelmatigUitzonderingId The unique identifier of AanvoerderProductRegelmatigUitzonderingView
     * @param body New property values
     * @return Success
     */
    aanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_UpdateAanvoerderProductRegelmatigUitzonderingView(aanvoerderProductRegelmatigUitzonderingId: number, body: AanvoerderProductRegelmatigUitzonderingView): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigUitzonderingenViews({aanvoerderProductRegelmatigUitzonderingId})";
        if (aanvoerderProductRegelmatigUitzonderingId === undefined || aanvoerderProductRegelmatigUitzonderingId === null)
            throw new Error("The parameter 'aanvoerderProductRegelmatigUitzonderingId' must be defined.");
        url_ = url_.replace("{aanvoerderProductRegelmatigUitzonderingId}", encodeURIComponent("" + aanvoerderProductRegelmatigUitzonderingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_UpdateAanvoerderProductRegelmatigUitzonderingView(_response));
        });
    }

    protected processAanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_UpdateAanvoerderProductRegelmatigUitzonderingView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from AanvoerderProductRegelmatigUitzonderingenViews
     * @param aanvoerderProductRegelmatigUitzonderingId The unique identifier of AanvoerderProductRegelmatigUitzonderingView
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_DeleteAanvoerderProductRegelmatigUitzonderingView(aanvoerderProductRegelmatigUitzonderingId: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigUitzonderingenViews({aanvoerderProductRegelmatigUitzonderingId})";
        if (aanvoerderProductRegelmatigUitzonderingId === undefined || aanvoerderProductRegelmatigUitzonderingId === null)
            throw new Error("The parameter 'aanvoerderProductRegelmatigUitzonderingId' must be defined.");
        url_ = url_.replace("{aanvoerderProductRegelmatigUitzonderingId}", encodeURIComponent("" + aanvoerderProductRegelmatigUitzonderingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_DeleteAanvoerderProductRegelmatigUitzonderingView(_response));
        });
    }

    protected processAanvoerderProductRegelmatigUitzonderingenViews_AanvoerderProductRegelmatigUitzonderingView_DeleteAanvoerderProductRegelmatigUitzonderingView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductRegelmatigUitzonderingenViews_GetCount9644(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigUitzonderingenViews/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigUitzonderingenViews_GetCount9644(_response));
        });
    }

    protected processAanvoerderProductRegelmatigUitzonderingenViews_GetCount9644(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from AanvoerderProductRegelmatigViews
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_ListAanvoerderProductRegelmatigView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatigViewCollectionResponse> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigViews?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_ListAanvoerderProductRegelmatigView(_response));
        });
    }

    protected processAanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_ListAanvoerderProductRegelmatigView(response: Response): Promise<AanvoerderProductRegelmatigViewCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductRegelmatigViewCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to AanvoerderProductRegelmatigViews
     * @param body New entity
     * @return Created entity
     */
    aanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_CreateAanvoerderProductRegelmatigView(body: AanvoerderProductRegelmatigView): Promise<AanvoerderProductRegelmatigView> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigViews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_CreateAanvoerderProductRegelmatigView(_response));
        });
    }

    protected processAanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_CreateAanvoerderProductRegelmatigView(response: Response): Promise<AanvoerderProductRegelmatigView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AanvoerderProductRegelmatigView.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from AanvoerderProductRegelmatigViews by key
     * @param aanvoerderProductRegelmatigId The unique identifier of AanvoerderProductRegelmatigView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_GetAanvoerderProductRegelmatigView(aanvoerderProductRegelmatigId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderProductRegelmatigView> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigViews({aanvoerderProductRegelmatigId})?";
        if (aanvoerderProductRegelmatigId === undefined || aanvoerderProductRegelmatigId === null)
            throw new Error("The parameter 'aanvoerderProductRegelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderProductRegelmatigId}", encodeURIComponent("" + aanvoerderProductRegelmatigId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_GetAanvoerderProductRegelmatigView(_response));
        });
    }

    protected processAanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_GetAanvoerderProductRegelmatigView(response: Response): Promise<AanvoerderProductRegelmatigView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderProductRegelmatigView.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in AanvoerderProductRegelmatigViews
     * @param aanvoerderProductRegelmatigId The unique identifier of AanvoerderProductRegelmatigView
     * @param body New property values
     * @return Success
     */
    aanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_UpdateAanvoerderProductRegelmatigView(aanvoerderProductRegelmatigId: number, body: AanvoerderProductRegelmatigView): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigViews({aanvoerderProductRegelmatigId})";
        if (aanvoerderProductRegelmatigId === undefined || aanvoerderProductRegelmatigId === null)
            throw new Error("The parameter 'aanvoerderProductRegelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderProductRegelmatigId}", encodeURIComponent("" + aanvoerderProductRegelmatigId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_UpdateAanvoerderProductRegelmatigView(_response));
        });
    }

    protected processAanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_UpdateAanvoerderProductRegelmatigView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from AanvoerderProductRegelmatigViews
     * @param aanvoerderProductRegelmatigId The unique identifier of AanvoerderProductRegelmatigView
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_DeleteAanvoerderProductRegelmatigView(aanvoerderProductRegelmatigId: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigViews({aanvoerderProductRegelmatigId})";
        if (aanvoerderProductRegelmatigId === undefined || aanvoerderProductRegelmatigId === null)
            throw new Error("The parameter 'aanvoerderProductRegelmatigId' must be defined.");
        url_ = url_.replace("{aanvoerderProductRegelmatigId}", encodeURIComponent("" + aanvoerderProductRegelmatigId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_DeleteAanvoerderProductRegelmatigView(_response));
        });
    }

    protected processAanvoerderProductRegelmatigViews_AanvoerderProductRegelmatigView_DeleteAanvoerderProductRegelmatigView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderProductRegelmatigViews_GetCount22af(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigViews/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigViews_GetCount22af(_response));
        });
    }

    protected processAanvoerderProductRegelmatigViews_GetCount22af(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function ZoekHistorie
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param aanvoerderNummer Usage: aanvoerderNummer={aanvoerderNummer}
     * @param productCode Usage: productCode={productCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    aanvoerderProductRegelmatigViews_ZoekHistorie(vestigingCode: number, aanvoerderNummer: number, productCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous4> {
        let url_ = this.baseUrl + "/AanvoerderProductRegelmatigViews/AanbodBeheerService.ZoekHistorie(vestigingCode={vestigingCode},aanvoerderNummer={aanvoerderNummer},productCode={productCode})?";
        if (vestigingCode === undefined || vestigingCode === null)
            throw new Error("The parameter 'vestigingCode' must be defined.");
        url_ = url_.replace("{vestigingCode}", encodeURIComponent("" + vestigingCode));
        if (aanvoerderNummer === undefined || aanvoerderNummer === null)
            throw new Error("The parameter 'aanvoerderNummer' must be defined.");
        url_ = url_.replace("{aanvoerderNummer}", encodeURIComponent("" + aanvoerderNummer));
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderProductRegelmatigViews_ZoekHistorie(_response));
        });
    }

    protected processAanvoerderProductRegelmatigViews_ZoekHistorie(response: Response): Promise<Anonymous4> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous4.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from AanvoerderPromotieKenmerk
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_ListAanvoerderPromotieKenmerk(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderPromotieKenmerkCollectionResponse> {
        let url_ = this.baseUrl + "/AanvoerderPromotieKenmerk?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_ListAanvoerderPromotieKenmerk(_response));
        });
    }

    protected processAanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_ListAanvoerderPromotieKenmerk(response: Response): Promise<AanvoerderPromotieKenmerkCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderPromotieKenmerkCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to AanvoerderPromotieKenmerk
     * @param body New entity
     * @return Created entity
     */
    aanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_CreateAanvoerderPromotieKenmerk(body: AanvoerderPromotieKenmerk): Promise<AanvoerderPromotieKenmerk> {
        let url_ = this.baseUrl + "/AanvoerderPromotieKenmerk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_CreateAanvoerderPromotieKenmerk(_response));
        });
    }

    protected processAanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_CreateAanvoerderPromotieKenmerk(response: Response): Promise<AanvoerderPromotieKenmerk> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AanvoerderPromotieKenmerk.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from AanvoerderPromotieKenmerk by key
     * @param aanvoerderPromotieKenmerkId The unique identifier of AanvoerderPromotieKenmerk
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_GetAanvoerderPromotieKenmerk(aanvoerderPromotieKenmerkId: number, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderPromotieKenmerk> {
        let url_ = this.baseUrl + "/AanvoerderPromotieKenmerk({aanvoerderPromotieKenmerkId})?";
        if (aanvoerderPromotieKenmerkId === undefined || aanvoerderPromotieKenmerkId === null)
            throw new Error("The parameter 'aanvoerderPromotieKenmerkId' must be defined.");
        url_ = url_.replace("{aanvoerderPromotieKenmerkId}", encodeURIComponent("" + aanvoerderPromotieKenmerkId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_GetAanvoerderPromotieKenmerk(_response));
        });
    }

    protected processAanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_GetAanvoerderPromotieKenmerk(response: Response): Promise<AanvoerderPromotieKenmerk> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderPromotieKenmerk.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in AanvoerderPromotieKenmerk
     * @param aanvoerderPromotieKenmerkId The unique identifier of AanvoerderPromotieKenmerk
     * @param body New property values
     * @return Success
     */
    aanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_UpdateAanvoerderPromotieKenmerk(aanvoerderPromotieKenmerkId: number, body: AanvoerderPromotieKenmerk): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderPromotieKenmerk({aanvoerderPromotieKenmerkId})";
        if (aanvoerderPromotieKenmerkId === undefined || aanvoerderPromotieKenmerkId === null)
            throw new Error("The parameter 'aanvoerderPromotieKenmerkId' must be defined.");
        url_ = url_.replace("{aanvoerderPromotieKenmerkId}", encodeURIComponent("" + aanvoerderPromotieKenmerkId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_UpdateAanvoerderPromotieKenmerk(_response));
        });
    }

    protected processAanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_UpdateAanvoerderPromotieKenmerk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from AanvoerderPromotieKenmerk
     * @param aanvoerderPromotieKenmerkId The unique identifier of AanvoerderPromotieKenmerk
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_DeleteAanvoerderPromotieKenmerk(aanvoerderPromotieKenmerkId: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/AanvoerderPromotieKenmerk({aanvoerderPromotieKenmerkId})";
        if (aanvoerderPromotieKenmerkId === undefined || aanvoerderPromotieKenmerkId === null)
            throw new Error("The parameter 'aanvoerderPromotieKenmerkId' must be defined.");
        url_ = url_.replace("{aanvoerderPromotieKenmerkId}", encodeURIComponent("" + aanvoerderPromotieKenmerkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_DeleteAanvoerderPromotieKenmerk(_response));
        });
    }

    protected processAanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_DeleteAanvoerderPromotieKenmerk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke action Delete
     * @param aanvoerderPromotieKenmerkId The unique identifier of AanvoerderPromotieKenmerk
     * @param body Action parameters
     * @return Success
     */
    aanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_Delete(aanvoerderPromotieKenmerkId: number, body: Body2): Promise<Anonymous5> {
        let url_ = this.baseUrl + "/AanvoerderPromotieKenmerk({aanvoerderPromotieKenmerkId})/AanbodBeheerService.Delete";
        if (aanvoerderPromotieKenmerkId === undefined || aanvoerderPromotieKenmerkId === null)
            throw new Error("The parameter 'aanvoerderPromotieKenmerkId' must be defined.");
        url_ = url_.replace("{aanvoerderPromotieKenmerkId}", encodeURIComponent("" + aanvoerderPromotieKenmerkId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_Delete(_response));
        });
    }

    protected processAanvoerderPromotieKenmerk_AanvoerderPromotieKenmerk_Delete(response: Response): Promise<Anonymous5> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerderPromotieKenmerk_GetCount47dd(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/AanvoerderPromotieKenmerk/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderPromotieKenmerk_GetCount47dd(_response));
        });
    }

    protected processAanvoerderPromotieKenmerk_GetCount47dd(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke action AddPromotieKenmerk
     * @return Success
     */
    aanvoerderPromotieKenmerk_AddPromotieKenmerk(): Promise<Anonymous6> {
        let url_ = this.baseUrl + "/AanvoerderPromotieKenmerk/AanbodBeheerService.AddPromotieKenmerk";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderPromotieKenmerk_AddPromotieKenmerk(_response));
        });
    }

    protected processAanvoerderPromotieKenmerk_AddPromotieKenmerk(response: Response): Promise<Anonymous6> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function GetByAanvoerderProductVervallen
     * @param aanvoerdernummer Usage: aanvoerdernummer={aanvoerdernummer}
     * @param productcode Usage: productcode={productcode}
     * @param inclusiefVervallen Usage: inclusiefVervallen={inclusiefVervallen}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    aanvoerderPromotieKenmerk_GetByAanvoerderProductVervallen(aanvoerdernummer: number, productcode: number, inclusiefVervallen: boolean, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous7> {
        let url_ = this.baseUrl + "/AanvoerderPromotieKenmerk/AanbodBeheerService.GetByAanvoerderProductVervallen(aanvoerdernummer={aanvoerdernummer},productcode={productcode},inclusiefVervallen={inclusiefVervallen})?";
        if (aanvoerdernummer === undefined || aanvoerdernummer === null)
            throw new Error("The parameter 'aanvoerdernummer' must be defined.");
        url_ = url_.replace("{aanvoerdernummer}", encodeURIComponent("" + aanvoerdernummer));
        if (productcode === undefined || productcode === null)
            throw new Error("The parameter 'productcode' must be defined.");
        url_ = url_.replace("{productcode}", encodeURIComponent("" + productcode));
        if (inclusiefVervallen === undefined || inclusiefVervallen === null)
            throw new Error("The parameter 'inclusiefVervallen' must be defined.");
        url_ = url_.replace("{inclusiefVervallen}", encodeURIComponent("" + inclusiefVervallen));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderPromotieKenmerk_GetByAanvoerderProductVervallen(_response));
        });
    }

    protected processAanvoerderPromotieKenmerk_GetByAanvoerderProductVervallen(response: Response): Promise<Anonymous7> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous7.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke action UpdatePromotieKenmerk
     * @return Success
     */
    aanvoerderPromotieKenmerk_UpdatePromotieKenmerk(): Promise<Anonymous8> {
        let url_ = this.baseUrl + "/AanvoerderPromotieKenmerk/AanbodBeheerService.UpdatePromotieKenmerk";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerderPromotieKenmerk_UpdatePromotieKenmerk(_response));
        });
    }

    protected processAanvoerderPromotieKenmerk_UpdatePromotieKenmerk(response: Response): Promise<Anonymous8> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from Aanvoerders
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    aanvoerders_Aanvoerder_ListAanvoerder(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<AanvoerderCollectionResponse> {
        let url_ = this.baseUrl + "/Aanvoerders?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerders_Aanvoerder_ListAanvoerder(_response));
        });
    }

    protected processAanvoerders_Aanvoerder_ListAanvoerder(response: Response): Promise<AanvoerderCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AanvoerderCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to Aanvoerders
     * @param body New entity
     * @return Created entity
     */
    aanvoerders_Aanvoerder_CreateAanvoerder(body: Aanvoerder): Promise<Aanvoerder> {
        let url_ = this.baseUrl + "/Aanvoerders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerders_Aanvoerder_CreateAanvoerder(_response));
        });
    }

    protected processAanvoerders_Aanvoerder_CreateAanvoerder(response: Response): Promise<Aanvoerder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Aanvoerder.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from Aanvoerders by key
     * @param aanvoerderNummer The unique identifier of Aanvoerder
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    aanvoerders_Aanvoerder_GetAanvoerder(aanvoerderNummer: number, select: string[] | undefined, expand: string[] | undefined): Promise<Aanvoerder> {
        let url_ = this.baseUrl + "/Aanvoerders({aanvoerderNummer})?";
        if (aanvoerderNummer === undefined || aanvoerderNummer === null)
            throw new Error("The parameter 'aanvoerderNummer' must be defined.");
        url_ = url_.replace("{aanvoerderNummer}", encodeURIComponent("" + aanvoerderNummer));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerders_Aanvoerder_GetAanvoerder(_response));
        });
    }

    protected processAanvoerders_Aanvoerder_GetAanvoerder(response: Response): Promise<Aanvoerder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Aanvoerder.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in Aanvoerders
     * @param aanvoerderNummer The unique identifier of Aanvoerder
     * @param body New property values
     * @return Success
     */
    aanvoerders_Aanvoerder_UpdateAanvoerder(aanvoerderNummer: number, body: Aanvoerder): Promise<void> {
        let url_ = this.baseUrl + "/Aanvoerders({aanvoerderNummer})";
        if (aanvoerderNummer === undefined || aanvoerderNummer === null)
            throw new Error("The parameter 'aanvoerderNummer' must be defined.");
        url_ = url_.replace("{aanvoerderNummer}", encodeURIComponent("" + aanvoerderNummer));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerders_Aanvoerder_UpdateAanvoerder(_response));
        });
    }

    protected processAanvoerders_Aanvoerder_UpdateAanvoerder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from Aanvoerders
     * @param aanvoerderNummer The unique identifier of Aanvoerder
     * @param if_Match (optional) ETag
     * @return Success
     */
    aanvoerders_Aanvoerder_DeleteAanvoerder(aanvoerderNummer: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Aanvoerders({aanvoerderNummer})";
        if (aanvoerderNummer === undefined || aanvoerderNummer === null)
            throw new Error("The parameter 'aanvoerderNummer' must be defined.");
        url_ = url_.replace("{aanvoerderNummer}", encodeURIComponent("" + aanvoerderNummer));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerders_Aanvoerder_DeleteAanvoerder(_response));
        });
    }

    protected processAanvoerders_Aanvoerder_DeleteAanvoerder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    aanvoerders_GetCount7590(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Aanvoerders/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAanvoerders_GetCount7590(_response));
        });
    }

    protected processAanvoerders_GetCount7590(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from Kenmerken
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    kenmerken_Kenmerk_ListKenmerk(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<KenmerkCollectionResponse> {
        let url_ = this.baseUrl + "/Kenmerken?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processKenmerken_Kenmerk_ListKenmerk(_response));
        });
    }

    protected processKenmerken_Kenmerk_ListKenmerk(response: Response): Promise<KenmerkCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KenmerkCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to Kenmerken
     * @param body New entity
     * @return Created entity
     */
    kenmerken_Kenmerk_CreateKenmerk(body: Kenmerk): Promise<Kenmerk> {
        let url_ = this.baseUrl + "/Kenmerken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processKenmerken_Kenmerk_CreateKenmerk(_response));
        });
    }

    protected processKenmerken_Kenmerk_CreateKenmerk(response: Response): Promise<Kenmerk> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Kenmerk.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from Kenmerken by key
     * @param kenmerkCode The unique identifier of Kenmerk
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    kenmerken_Kenmerk_GetKenmerk(kenmerkCode: string, select: string[] | undefined, expand: string[] | undefined): Promise<Kenmerk> {
        let url_ = this.baseUrl + "/Kenmerken({kenmerkCode})?";
        if (kenmerkCode === undefined || kenmerkCode === null)
            throw new Error("The parameter 'kenmerkCode' must be defined.");
        url_ = url_.replace("{kenmerkCode}", encodeURIComponent("" + kenmerkCode));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processKenmerken_Kenmerk_GetKenmerk(_response));
        });
    }

    protected processKenmerken_Kenmerk_GetKenmerk(response: Response): Promise<Kenmerk> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Kenmerk.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in Kenmerken
     * @param kenmerkCode The unique identifier of Kenmerk
     * @param body New property values
     * @return Success
     */
    kenmerken_Kenmerk_UpdateKenmerk(kenmerkCode: string, body: Kenmerk): Promise<void> {
        let url_ = this.baseUrl + "/Kenmerken({kenmerkCode})";
        if (kenmerkCode === undefined || kenmerkCode === null)
            throw new Error("The parameter 'kenmerkCode' must be defined.");
        url_ = url_.replace("{kenmerkCode}", encodeURIComponent("" + kenmerkCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processKenmerken_Kenmerk_UpdateKenmerk(_response));
        });
    }

    protected processKenmerken_Kenmerk_UpdateKenmerk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from Kenmerken
     * @param kenmerkCode The unique identifier of Kenmerk
     * @param if_Match (optional) ETag
     * @return Success
     */
    kenmerken_Kenmerk_DeleteKenmerk(kenmerkCode: string, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Kenmerken({kenmerkCode})";
        if (kenmerkCode === undefined || kenmerkCode === null)
            throw new Error("The parameter 'kenmerkCode' must be defined.");
        url_ = url_.replace("{kenmerkCode}", encodeURIComponent("" + kenmerkCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processKenmerken_Kenmerk_DeleteKenmerk(_response));
        });
    }

    protected processKenmerken_Kenmerk_DeleteKenmerk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    kenmerken_GetCountEbe7(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Kenmerken/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processKenmerken_GetCountEbe7(_response));
        });
    }

    protected processKenmerken_GetCountEbe7(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from KenmerkWaardes
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    kenmerkWaardes_KenmerkWaarde_ListKenmerkWaarde(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<KenmerkWaardeCollectionResponse> {
        let url_ = this.baseUrl + "/KenmerkWaardes?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processKenmerkWaardes_KenmerkWaarde_ListKenmerkWaarde(_response));
        });
    }

    protected processKenmerkWaardes_KenmerkWaarde_ListKenmerkWaarde(response: Response): Promise<KenmerkWaardeCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KenmerkWaardeCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to KenmerkWaardes
     * @param body New entity
     * @return Created entity
     */
    kenmerkWaardes_KenmerkWaarde_CreateKenmerkWaarde(body: KenmerkWaarde): Promise<KenmerkWaarde> {
        let url_ = this.baseUrl + "/KenmerkWaardes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processKenmerkWaardes_KenmerkWaarde_CreateKenmerkWaarde(_response));
        });
    }

    protected processKenmerkWaardes_KenmerkWaarde_CreateKenmerkWaarde(response: Response): Promise<KenmerkWaarde> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = KenmerkWaarde.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from KenmerkWaardes by key
     * @param refSysIdf The unique identifier of KenmerkWaarde
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    kenmerkWaardes_KenmerkWaarde_GetKenmerkWaarde(refSysIdf: number, select: string[] | undefined, expand: string[] | undefined): Promise<KenmerkWaarde> {
        let url_ = this.baseUrl + "/KenmerkWaardes({refSysIdf})?";
        if (refSysIdf === undefined || refSysIdf === null)
            throw new Error("The parameter 'refSysIdf' must be defined.");
        url_ = url_.replace("{refSysIdf}", encodeURIComponent("" + refSysIdf));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processKenmerkWaardes_KenmerkWaarde_GetKenmerkWaarde(_response));
        });
    }

    protected processKenmerkWaardes_KenmerkWaarde_GetKenmerkWaarde(response: Response): Promise<KenmerkWaarde> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KenmerkWaarde.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in KenmerkWaardes
     * @param refSysIdf The unique identifier of KenmerkWaarde
     * @param body New property values
     * @return Success
     */
    kenmerkWaardes_KenmerkWaarde_UpdateKenmerkWaarde(refSysIdf: number, body: KenmerkWaarde): Promise<void> {
        let url_ = this.baseUrl + "/KenmerkWaardes({refSysIdf})";
        if (refSysIdf === undefined || refSysIdf === null)
            throw new Error("The parameter 'refSysIdf' must be defined.");
        url_ = url_.replace("{refSysIdf}", encodeURIComponent("" + refSysIdf));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processKenmerkWaardes_KenmerkWaarde_UpdateKenmerkWaarde(_response));
        });
    }

    protected processKenmerkWaardes_KenmerkWaarde_UpdateKenmerkWaarde(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from KenmerkWaardes
     * @param refSysIdf The unique identifier of KenmerkWaarde
     * @param if_Match (optional) ETag
     * @return Success
     */
    kenmerkWaardes_KenmerkWaarde_DeleteKenmerkWaarde(refSysIdf: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/KenmerkWaardes({refSysIdf})";
        if (refSysIdf === undefined || refSysIdf === null)
            throw new Error("The parameter 'refSysIdf' must be defined.");
        url_ = url_.replace("{refSysIdf}", encodeURIComponent("" + refSysIdf));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processKenmerkWaardes_KenmerkWaarde_DeleteKenmerkWaarde(_response));
        });
    }

    protected processKenmerkWaardes_KenmerkWaarde_DeleteKenmerkWaarde(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    kenmerkWaardes_GetCount307d(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/KenmerkWaardes/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processKenmerkWaardes_GetCount307d(_response));
        });
    }

    protected processKenmerkWaardes_GetCount307d(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from PartijStatussen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    partijStatussen_PartijStatusReport_ListPartijStatusReport(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<PartijStatusReportCollectionResponse> {
        let url_ = this.baseUrl + "/PartijStatussen?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPartijStatussen_PartijStatusReport_ListPartijStatusReport(_response));
        });
    }

    protected processPartijStatussen_PartijStatusReport_ListPartijStatusReport(response: Response): Promise<PartijStatusReportCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartijStatusReportCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to PartijStatussen
     * @param body New entity
     * @return Created entity
     */
    partijStatussen_PartijStatusReport_CreatePartijStatusReport(body: PartijStatusReport): Promise<PartijStatusReport> {
        let url_ = this.baseUrl + "/PartijStatussen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPartijStatussen_PartijStatusReport_CreatePartijStatusReport(_response));
        });
    }

    protected processPartijStatussen_PartijStatusReport_CreatePartijStatusReport(response: Response): Promise<PartijStatusReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PartijStatusReport.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from PartijStatussen by key
     * @param aantalBronHerkeur The unique identifier of PartijStatusReport
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    partijStatussen_PartijStatusReport_GetPartijStatusReport(aantalBronHerkeur: number, select: string[] | undefined, expand: string[] | undefined): Promise<PartijStatusReport> {
        let url_ = this.baseUrl + "/PartijStatussen({aantalBronHerkeur})?";
        if (aantalBronHerkeur === undefined || aantalBronHerkeur === null)
            throw new Error("The parameter 'aantalBronHerkeur' must be defined.");
        url_ = url_.replace("{aantalBronHerkeur}", encodeURIComponent("" + aantalBronHerkeur));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPartijStatussen_PartijStatusReport_GetPartijStatusReport(_response));
        });
    }

    protected processPartijStatussen_PartijStatusReport_GetPartijStatusReport(response: Response): Promise<PartijStatusReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartijStatusReport.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in PartijStatussen
     * @param aantalBronHerkeur The unique identifier of PartijStatusReport
     * @param body New property values
     * @return Success
     */
    partijStatussen_PartijStatusReport_UpdatePartijStatusReport(aantalBronHerkeur: number, body: PartijStatusReport): Promise<void> {
        let url_ = this.baseUrl + "/PartijStatussen({aantalBronHerkeur})";
        if (aantalBronHerkeur === undefined || aantalBronHerkeur === null)
            throw new Error("The parameter 'aantalBronHerkeur' must be defined.");
        url_ = url_.replace("{aantalBronHerkeur}", encodeURIComponent("" + aantalBronHerkeur));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPartijStatussen_PartijStatusReport_UpdatePartijStatusReport(_response));
        });
    }

    protected processPartijStatussen_PartijStatusReport_UpdatePartijStatusReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from PartijStatussen
     * @param aantalBronHerkeur The unique identifier of PartijStatusReport
     * @param if_Match (optional) ETag
     * @return Success
     */
    partijStatussen_PartijStatusReport_DeletePartijStatusReport(aantalBronHerkeur: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/PartijStatussen({aantalBronHerkeur})";
        if (aantalBronHerkeur === undefined || aantalBronHerkeur === null)
            throw new Error("The parameter 'aantalBronHerkeur' must be defined.");
        url_ = url_.replace("{aantalBronHerkeur}", encodeURIComponent("" + aantalBronHerkeur));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPartijStatussen_PartijStatusReport_DeletePartijStatusReport(_response));
        });
    }

    protected processPartijStatussen_PartijStatusReport_DeletePartijStatusReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    partijStatussen_GetCount119d(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/PartijStatussen/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPartijStatussen_GetCount119d(_response));
        });
    }

    protected processPartijStatussen_GetCount119d(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function GetVeildatum
     * @param veilDatum Usage: veilDatum={veilDatum}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    partijStatussen_GetVeildatum(veilDatum: Date, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous9> {
        let url_ = this.baseUrl + "/PartijStatussen/AanbodBeheerService.GetVeildatum(veilDatum={veilDatum})?";
        if (veilDatum === undefined || veilDatum === null)
            throw new Error("The parameter 'veilDatum' must be defined.");
        url_ = url_.replace("{veilDatum}", encodeURIComponent(veilDatum ? "" + veilDatum.toISOString() : "null"));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPartijStatussen_GetVeildatum(_response));
        });
    }

    protected processPartijStatussen_GetVeildatum(response: Response): Promise<Anonymous9> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous9.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function GetVeildatumVestiging
     * @param veilDatum Usage: veilDatum={veilDatum}
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    partijStatussen_GetVeildatumVestiging(veilDatum: Date, vestigingCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous10> {
        let url_ = this.baseUrl + "/PartijStatussen/AanbodBeheerService.GetVeildatumVestiging(veilDatum={veilDatum},vestigingCode={vestigingCode})?";
        if (veilDatum === undefined || veilDatum === null)
            throw new Error("The parameter 'veilDatum' must be defined.");
        url_ = url_.replace("{veilDatum}", encodeURIComponent(veilDatum ? "" + veilDatum.toISOString() : "null"));
        if (vestigingCode === undefined || vestigingCode === null)
            throw new Error("The parameter 'vestigingCode' must be defined.");
        url_ = url_.replace("{vestigingCode}", encodeURIComponent("" + vestigingCode));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPartijStatussen_GetVeildatumVestiging(_response));
        });
    }

    protected processPartijStatussen_GetVeildatumVestiging(response: Response): Promise<Anonymous10> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous10.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from ProductclusterProductgroepen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productclusterProductgroepen_ProductclusterProductgroep_ListProductclusterProductgroep(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterProductgroepCollectionResponse> {
        let url_ = this.baseUrl + "/ProductclusterProductgroepen?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterProductgroepen_ProductclusterProductgroep_ListProductclusterProductgroep(_response));
        });
    }

    protected processProductclusterProductgroepen_ProductclusterProductgroep_ListProductclusterProductgroep(response: Response): Promise<ProductclusterProductgroepCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductclusterProductgroepCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to ProductclusterProductgroepen
     * @param body New entity
     * @return Created entity
     */
    productclusterProductgroepen_ProductclusterProductgroep_CreateProductclusterProductgroep(body: ProductclusterProductgroep): Promise<ProductclusterProductgroep> {
        let url_ = this.baseUrl + "/ProductclusterProductgroepen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterProductgroepen_ProductclusterProductgroep_CreateProductclusterProductgroep(_response));
        });
    }

    protected processProductclusterProductgroepen_ProductclusterProductgroep_CreateProductclusterProductgroep(response: Response): Promise<ProductclusterProductgroep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ProductclusterProductgroep.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from ProductclusterProductgroepen by key
     * @param productclusterProductgroepID The unique identifier of ProductclusterProductgroep
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    productclusterProductgroepen_ProductclusterProductgroep_GetProductclusterProductgroep(productclusterProductgroepID: number, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterProductgroep> {
        let url_ = this.baseUrl + "/ProductclusterProductgroepen({productclusterProductgroepID})?";
        if (productclusterProductgroepID === undefined || productclusterProductgroepID === null)
            throw new Error("The parameter 'productclusterProductgroepID' must be defined.");
        url_ = url_.replace("{productclusterProductgroepID}", encodeURIComponent("" + productclusterProductgroepID));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterProductgroepen_ProductclusterProductgroep_GetProductclusterProductgroep(_response));
        });
    }

    protected processProductclusterProductgroepen_ProductclusterProductgroep_GetProductclusterProductgroep(response: Response): Promise<ProductclusterProductgroep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductclusterProductgroep.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in ProductclusterProductgroepen
     * @param productclusterProductgroepID The unique identifier of ProductclusterProductgroep
     * @param body New property values
     * @return Success
     */
    productclusterProductgroepen_ProductclusterProductgroep_UpdateProductclusterProductgroep(productclusterProductgroepID: number, body: ProductclusterProductgroep): Promise<void> {
        let url_ = this.baseUrl + "/ProductclusterProductgroepen({productclusterProductgroepID})";
        if (productclusterProductgroepID === undefined || productclusterProductgroepID === null)
            throw new Error("The parameter 'productclusterProductgroepID' must be defined.");
        url_ = url_.replace("{productclusterProductgroepID}", encodeURIComponent("" + productclusterProductgroepID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterProductgroepen_ProductclusterProductgroep_UpdateProductclusterProductgroep(_response));
        });
    }

    protected processProductclusterProductgroepen_ProductclusterProductgroep_UpdateProductclusterProductgroep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from ProductclusterProductgroepen
     * @param productclusterProductgroepID The unique identifier of ProductclusterProductgroep
     * @param if_Match (optional) ETag
     * @return Success
     */
    productclusterProductgroepen_ProductclusterProductgroep_DeleteProductclusterProductgroep(productclusterProductgroepID: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ProductclusterProductgroepen({productclusterProductgroepID})";
        if (productclusterProductgroepID === undefined || productclusterProductgroepID === null)
            throw new Error("The parameter 'productclusterProductgroepID' must be defined.");
        url_ = url_.replace("{productclusterProductgroepID}", encodeURIComponent("" + productclusterProductgroepID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterProductgroepen_ProductclusterProductgroep_DeleteProductclusterProductgroep(_response));
        });
    }

    protected processProductclusterProductgroepen_ProductclusterProductgroep_DeleteProductclusterProductgroep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get productcluster from ProductclusterProductgroepen
     * @param productclusterProductgroepID The unique identifier of ProductclusterProductgroep
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved navigation property
     */
    productclusterProductgroepen_GetProductcluster(productclusterProductgroepID: number, select: string[] | undefined, expand: string[] | undefined): Promise<Productcluster> {
        let url_ = this.baseUrl + "/ProductclusterProductgroepen({productclusterProductgroepID})/productcluster?";
        if (productclusterProductgroepID === undefined || productclusterProductgroepID === null)
            throw new Error("The parameter 'productclusterProductgroepID' must be defined.");
        url_ = url_.replace("{productclusterProductgroepID}", encodeURIComponent("" + productclusterProductgroepID));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterProductgroepen_GetProductcluster(_response));
        });
    }

    protected processProductclusterProductgroepen_GetProductcluster(response: Response): Promise<Productcluster> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Productcluster.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productclusterProductgroepen_GetCountA27c(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/ProductclusterProductgroepen/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterProductgroepen_GetCountA27c(_response));
        });
    }

    protected processProductclusterProductgroepen_GetCountA27c(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from Productclusters
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productclusters_Productcluster_ListProductcluster(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterCollectionResponse> {
        let url_ = this.baseUrl + "/Productclusters?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusters_Productcluster_ListProductcluster(_response));
        });
    }

    protected processProductclusters_Productcluster_ListProductcluster(response: Response): Promise<ProductclusterCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductclusterCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to Productclusters
     * @param body New entity
     * @return Created entity
     */
    productclusters_Productcluster_CreateProductcluster(body: Productcluster): Promise<Productcluster> {
        let url_ = this.baseUrl + "/Productclusters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusters_Productcluster_CreateProductcluster(_response));
        });
    }

    protected processProductclusters_Productcluster_CreateProductcluster(response: Response): Promise<Productcluster> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Productcluster.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from Productclusters by key
     * @param productclusterID The unique identifier of Productcluster
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    productclusters_Productcluster_GetProductcluster(productclusterID: number, select: string[] | undefined, expand: string[] | undefined): Promise<Productcluster> {
        let url_ = this.baseUrl + "/Productclusters({productclusterID})?";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusters_Productcluster_GetProductcluster(_response));
        });
    }

    protected processProductclusters_Productcluster_GetProductcluster(response: Response): Promise<Productcluster> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Productcluster.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in Productclusters
     * @param productclusterID The unique identifier of Productcluster
     * @param body New property values
     * @return Success
     */
    productclusters_Productcluster_UpdateProductclusterPATCH(productclusterID: number, body: Productcluster): Promise<void> {
        let url_ = this.baseUrl + "/Productclusters({productclusterID})";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusters_Productcluster_UpdateProductclusterPATCH(_response));
        });
    }

    protected processProductclusters_Productcluster_UpdateProductclusterPATCH(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from Productclusters
     * @param productclusterID The unique identifier of Productcluster
     * @param if_Match (optional) ETag
     * @return Success
     */
    productclusters_Productcluster_DeleteProductcluster(productclusterID: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Productclusters({productclusterID})";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusters_Productcluster_DeleteProductcluster(_response));
        });
    }

    protected processProductclusters_Productcluster_DeleteProductcluster(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke action UpdateProductcluster
     * @param productclusterID The unique identifier of Productcluster
     * @return Success
     */
    productclusters_Productcluster_UpdateProductclusterPOST(productclusterID: number): Promise<Anonymous11> {
        let url_ = this.baseUrl + "/Productclusters({productclusterID})/AanbodBeheerService.UpdateProductcluster";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusters_Productcluster_UpdateProductclusterPOST(_response));
        });
    }

    protected processProductclusters_Productcluster_UpdateProductclusterPOST(response: Response): Promise<Anonymous11> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get productclusterProductgroepen from Productclusters
     * @param productclusterID The unique identifier of Productcluster
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productclusters_ListProductclusterProductgroepen(productclusterID: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterProductgroepCollectionResponse> {
        let url_ = this.baseUrl + "/Productclusters({productclusterID})/productclusterProductgroepen?";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusters_ListProductclusterProductgroepen(_response));
        });
    }

    protected processProductclusters_ListProductclusterProductgroepen(response: Response): Promise<ProductclusterProductgroepCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductclusterProductgroepCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get productclusterProductgroepen from Productclusters
     * @param productclusterID The unique identifier of Productcluster
     * @param productclusterProductgroepID The unique identifier of ProductclusterProductgroep
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved navigation property
     */
    productclusters_GetProductclusterProductgroepen(productclusterID: number, productclusterProductgroepID: number, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterProductgroep> {
        let url_ = this.baseUrl + "/Productclusters({productclusterID})/productclusterProductgroepen({productclusterProductgroepID})?";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        if (productclusterProductgroepID === undefined || productclusterProductgroepID === null)
            throw new Error("The parameter 'productclusterProductgroepID' must be defined.");
        url_ = url_.replace("{productclusterProductgroepID}", encodeURIComponent("" + productclusterProductgroepID));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusters_GetProductclusterProductgroepen(_response));
        });
    }

    protected processProductclusters_GetProductclusterProductgroepen(response: Response): Promise<ProductclusterProductgroep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductclusterProductgroep.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param productclusterID The unique identifier of Productcluster
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productclusters_productclusterProductgroepen_GetCountD7fe(productclusterID: number, search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Productclusters({productclusterID})/productclusterProductgroepen/$count?";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusters_productclusterProductgroepen_GetCountD7fe(_response));
        });
    }

    protected processProductclusters_productclusterProductgroepen_GetCountD7fe(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get veilgroepRegels from Productclusters
     * @param productclusterID The unique identifier of Productcluster
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productclusters_ListVeilgroepRegels(productclusterID: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepRegelCollectionResponse> {
        let url_ = this.baseUrl + "/Productclusters({productclusterID})/veilgroepRegels?";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusters_ListVeilgroepRegels(_response));
        });
    }

    protected processProductclusters_ListVeilgroepRegels(response: Response): Promise<VeilgroepRegelCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VeilgroepRegelCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get veilgroepRegels from Productclusters
     * @param productclusterID The unique identifier of Productcluster
     * @param veilgroepRegelId The unique identifier of VeilgroepRegel
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved navigation property
     */
    productclusters_GetVeilgroepRegels(productclusterID: number, veilgroepRegelId: number, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepRegel> {
        let url_ = this.baseUrl + "/Productclusters({productclusterID})/veilgroepRegels({veilgroepRegelId})?";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        if (veilgroepRegelId === undefined || veilgroepRegelId === null)
            throw new Error("The parameter 'veilgroepRegelId' must be defined.");
        url_ = url_.replace("{veilgroepRegelId}", encodeURIComponent("" + veilgroepRegelId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusters_GetVeilgroepRegels(_response));
        });
    }

    protected processProductclusters_GetVeilgroepRegels(response: Response): Promise<VeilgroepRegel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VeilgroepRegel.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param productclusterID The unique identifier of Productcluster
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productclusters_veilgroepRegels_GetCount9043(productclusterID: number, search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Productclusters({productclusterID})/veilgroepRegels/$count?";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusters_veilgroepRegels_GetCount9043(_response));
        });
    }

    protected processProductclusters_veilgroepRegels_GetCount9043(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productclusters_GetCount527c(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Productclusters/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusters_GetCount527c(_response));
        });
    }

    protected processProductclusters_GetCount527c(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function GetToegestaneProductgroepen
     * @param bloemenPlantenCode Usage: bloemenPlantenCode={bloemenPlantenCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @return Success
     */
    productclusters_GetToegestaneProductgroepen(bloemenPlantenCode: string | null, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined): Promise<Anonymous12> {
        let url_ = this.baseUrl + "/Productclusters/AanbodBeheerService.GetToegestaneProductgroepen(bloemenPlantenCode={bloemenPlantenCode})?";
        if (bloemenPlantenCode === undefined || bloemenPlantenCode === null)
            throw new Error("The parameter 'bloemenPlantenCode' must be defined.");
        url_ = url_.replace("{bloemenPlantenCode}", encodeURIComponent("" + bloemenPlantenCode));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusters_GetToegestaneProductgroepen(_response));
        });
    }

    protected processProductclusters_GetToegestaneProductgroepen(response: Response): Promise<Anonymous12> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous12.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function MagProductgroepWordenVerwijderd
     * @param productclusterId Usage: productclusterId={productclusterId}
     * @param productgroepCode Usage: productgroepCode={productgroepCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @return Success
     */
    productclusters_MagProductgroepWordenVerwijderd(productclusterId: number, productgroepCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined): Promise<Anonymous13> {
        let url_ = this.baseUrl + "/Productclusters/AanbodBeheerService.MagProductgroepWordenVerwijderd(productclusterId={productclusterId},productgroepCode={productgroepCode})?";
        if (productclusterId === undefined || productclusterId === null)
            throw new Error("The parameter 'productclusterId' must be defined.");
        url_ = url_.replace("{productclusterId}", encodeURIComponent("" + productclusterId));
        if (productgroepCode === undefined || productgroepCode === null)
            throw new Error("The parameter 'productgroepCode' must be defined.");
        url_ = url_.replace("{productgroepCode}", encodeURIComponent("" + productgroepCode));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusters_MagProductgroepWordenVerwijderd(_response));
        });
    }

    protected processProductclusters_MagProductgroepWordenVerwijderd(response: Response): Promise<Anonymous13> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous13.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from ProductclusterViews
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productclusterViews_ProductclusterView_ListProductclusterView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterViewCollectionResponse> {
        let url_ = this.baseUrl + "/ProductclusterViews?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterViews_ProductclusterView_ListProductclusterView(_response));
        });
    }

    protected processProductclusterViews_ProductclusterView_ListProductclusterView(response: Response): Promise<ProductclusterViewCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductclusterViewCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to ProductclusterViews
     * @param body New entity
     * @return Created entity
     */
    productclusterViews_ProductclusterView_CreateProductclusterView(body: ProductclusterView): Promise<ProductclusterView> {
        let url_ = this.baseUrl + "/ProductclusterViews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterViews_ProductclusterView_CreateProductclusterView(_response));
        });
    }

    protected processProductclusterViews_ProductclusterView_CreateProductclusterView(response: Response): Promise<ProductclusterView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ProductclusterView.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from ProductclusterViews by key
     * @param productclusterID The unique identifier of ProductclusterView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    productclusterViews_ProductclusterView_GetProductclusterView(productclusterID: number, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterView> {
        let url_ = this.baseUrl + "/ProductclusterViews({productclusterID})?";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterViews_ProductclusterView_GetProductclusterView(_response));
        });
    }

    protected processProductclusterViews_ProductclusterView_GetProductclusterView(response: Response): Promise<ProductclusterView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductclusterView.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in ProductclusterViews
     * @param productclusterID The unique identifier of ProductclusterView
     * @param body New property values
     * @return Success
     */
    productclusterViews_ProductclusterView_UpdateProductclusterView(productclusterID: number, body: ProductclusterView): Promise<void> {
        let url_ = this.baseUrl + "/ProductclusterViews({productclusterID})";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterViews_ProductclusterView_UpdateProductclusterView(_response));
        });
    }

    protected processProductclusterViews_ProductclusterView_UpdateProductclusterView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from ProductclusterViews
     * @param productclusterID The unique identifier of ProductclusterView
     * @param if_Match (optional) ETag
     * @return Success
     */
    productclusterViews_ProductclusterView_DeleteProductclusterView(productclusterID: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ProductclusterViews({productclusterID})";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterViews_ProductclusterView_DeleteProductclusterView(_response));
        });
    }

    protected processProductclusterViews_ProductclusterView_DeleteProductclusterView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get productclusterProductgroepen from ProductclusterViews
     * @param productclusterID The unique identifier of ProductclusterView
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productclusterViews_ListProductclusterProductgroepen(productclusterID: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterProductgroepCollectionResponse> {
        let url_ = this.baseUrl + "/ProductclusterViews({productclusterID})/productclusterProductgroepen?";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterViews_ListProductclusterProductgroepen(_response));
        });
    }

    protected processProductclusterViews_ListProductclusterProductgroepen(response: Response): Promise<ProductclusterProductgroepCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductclusterProductgroepCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get productclusterProductgroepen from ProductclusterViews
     * @param productclusterID The unique identifier of ProductclusterView
     * @param productclusterProductgroepID The unique identifier of ProductclusterProductgroep
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved navigation property
     */
    productclusterViews_GetProductclusterProductgroepen(productclusterID: number, productclusterProductgroepID: number, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterProductgroep> {
        let url_ = this.baseUrl + "/ProductclusterViews({productclusterID})/productclusterProductgroepen({productclusterProductgroepID})?";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        if (productclusterProductgroepID === undefined || productclusterProductgroepID === null)
            throw new Error("The parameter 'productclusterProductgroepID' must be defined.");
        url_ = url_.replace("{productclusterProductgroepID}", encodeURIComponent("" + productclusterProductgroepID));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterViews_GetProductclusterProductgroepen(_response));
        });
    }

    protected processProductclusterViews_GetProductclusterProductgroepen(response: Response): Promise<ProductclusterProductgroep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductclusterProductgroep.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param productclusterID The unique identifier of ProductclusterView
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productclusterViews_productclusterProductgroepen_GetCountCb26(productclusterID: number, search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/ProductclusterViews({productclusterID})/productclusterProductgroepen/$count?";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterViews_productclusterProductgroepen_GetCountCb26(_response));
        });
    }

    protected processProductclusterViews_productclusterProductgroepen_GetCountCb26(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get veilgroepRegels from ProductclusterViews
     * @param productclusterID The unique identifier of ProductclusterView
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productclusterViews_ListVeilgroepRegels(productclusterID: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterVeilgroepRegelCollectionResponse> {
        let url_ = this.baseUrl + "/ProductclusterViews({productclusterID})/veilgroepRegels?";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterViews_ListVeilgroepRegels(_response));
        });
    }

    protected processProductclusterViews_ListVeilgroepRegels(response: Response): Promise<ProductclusterVeilgroepRegelCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductclusterVeilgroepRegelCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get veilgroepRegels from ProductclusterViews
     * @param productclusterID The unique identifier of ProductclusterView
     * @param productclusterVeilgroepRegelId The unique identifier of ProductclusterVeilgroepRegel
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved navigation property
     */
    productclusterViews_GetVeilgroepRegels(productclusterID: number, productclusterVeilgroepRegelId: number, select: string[] | undefined, expand: string[] | undefined): Promise<ProductclusterVeilgroepRegel> {
        let url_ = this.baseUrl + "/ProductclusterViews({productclusterID})/veilgroepRegels({productclusterVeilgroepRegelId})?";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        if (productclusterVeilgroepRegelId === undefined || productclusterVeilgroepRegelId === null)
            throw new Error("The parameter 'productclusterVeilgroepRegelId' must be defined.");
        url_ = url_.replace("{productclusterVeilgroepRegelId}", encodeURIComponent("" + productclusterVeilgroepRegelId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterViews_GetVeilgroepRegels(_response));
        });
    }

    protected processProductclusterViews_GetVeilgroepRegels(response: Response): Promise<ProductclusterVeilgroepRegel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductclusterVeilgroepRegel.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param productclusterID The unique identifier of ProductclusterView
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productclusterViews_veilgroepRegels_GetCount37d4(productclusterID: number, search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/ProductclusterViews({productclusterID})/veilgroepRegels/$count?";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterViews_veilgroepRegels_GetCount37d4(_response));
        });
    }

    protected processProductclusterViews_veilgroepRegels_GetCount37d4(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productclusterViews_GetCount8446(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/ProductclusterViews/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductclusterViews_GetCount8446(_response));
        });
    }

    protected processProductclusterViews_GetCount8446(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from Producten
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    producten_Product_ListProduct(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductCollectionResponse> {
        let url_ = this.baseUrl + "/Producten?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProducten_Product_ListProduct(_response));
        });
    }

    protected processProducten_Product_ListProduct(response: Response): Promise<ProductCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to Producten
     * @param body New entity
     * @return Created entity
     */
    producten_Product_CreateProduct(body: Product): Promise<Product> {
        let url_ = this.baseUrl + "/Producten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProducten_Product_CreateProduct(_response));
        });
    }

    protected processProducten_Product_CreateProduct(response: Response): Promise<Product> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Product.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from Producten by key
     * @param productCode The unique identifier of Product
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    producten_Product_GetProduct(productCode: number, select: string[] | undefined, expand: string[] | undefined): Promise<Product> {
        let url_ = this.baseUrl + "/Producten({productCode})?";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProducten_Product_GetProduct(_response));
        });
    }

    protected processProducten_Product_GetProduct(response: Response): Promise<Product> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Product.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in Producten
     * @param productCode The unique identifier of Product
     * @param body New property values
     * @return Success
     */
    producten_Product_UpdateProduct(productCode: number, body: Product): Promise<void> {
        let url_ = this.baseUrl + "/Producten({productCode})";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProducten_Product_UpdateProduct(_response));
        });
    }

    protected processProducten_Product_UpdateProduct(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from Producten
     * @param productCode The unique identifier of Product
     * @param if_Match (optional) ETag
     * @return Success
     */
    producten_Product_DeleteProduct(productCode: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Producten({productCode})";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProducten_Product_DeleteProduct(_response));
        });
    }

    protected processProducten_Product_DeleteProduct(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    producten_GetCount7f36(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Producten/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProducten_GetCount7f36(_response));
        });
    }

    protected processProducten_GetCount7f36(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from Productgroepen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productgroepen_Productgroep_ListProductgroep(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductgroepCollectionResponse> {
        let url_ = this.baseUrl + "/Productgroepen?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductgroepen_Productgroep_ListProductgroep(_response));
        });
    }

    protected processProductgroepen_Productgroep_ListProductgroep(response: Response): Promise<ProductgroepCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductgroepCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to Productgroepen
     * @param body New entity
     * @return Created entity
     */
    productgroepen_Productgroep_CreateProductgroep(body: Productgroep): Promise<Productgroep> {
        let url_ = this.baseUrl + "/Productgroepen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductgroepen_Productgroep_CreateProductgroep(_response));
        });
    }

    protected processProductgroepen_Productgroep_CreateProductgroep(response: Response): Promise<Productgroep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Productgroep.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from Productgroepen by key
     * @param productgroepCode The unique identifier of Productgroep
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    productgroepen_Productgroep_GetProductgroep(productgroepCode: number, select: string[] | undefined, expand: string[] | undefined): Promise<Productgroep> {
        let url_ = this.baseUrl + "/Productgroepen({productgroepCode})?";
        if (productgroepCode === undefined || productgroepCode === null)
            throw new Error("The parameter 'productgroepCode' must be defined.");
        url_ = url_.replace("{productgroepCode}", encodeURIComponent("" + productgroepCode));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductgroepen_Productgroep_GetProductgroep(_response));
        });
    }

    protected processProductgroepen_Productgroep_GetProductgroep(response: Response): Promise<Productgroep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Productgroep.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in Productgroepen
     * @param productgroepCode The unique identifier of Productgroep
     * @param body New property values
     * @return Success
     */
    productgroepen_Productgroep_UpdateProductgroep(productgroepCode: number, body: Productgroep): Promise<void> {
        let url_ = this.baseUrl + "/Productgroepen({productgroepCode})";
        if (productgroepCode === undefined || productgroepCode === null)
            throw new Error("The parameter 'productgroepCode' must be defined.");
        url_ = url_.replace("{productgroepCode}", encodeURIComponent("" + productgroepCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductgroepen_Productgroep_UpdateProductgroep(_response));
        });
    }

    protected processProductgroepen_Productgroep_UpdateProductgroep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from Productgroepen
     * @param productgroepCode The unique identifier of Productgroep
     * @param if_Match (optional) ETag
     * @return Success
     */
    productgroepen_Productgroep_DeleteProductgroep(productgroepCode: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Productgroepen({productgroepCode})";
        if (productgroepCode === undefined || productgroepCode === null)
            throw new Error("The parameter 'productgroepCode' must be defined.");
        url_ = url_.replace("{productgroepCode}", encodeURIComponent("" + productgroepCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductgroepen_Productgroep_DeleteProductgroep(_response));
        });
    }

    protected processProductgroepen_Productgroep_DeleteProductgroep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productgroepen_GetCount313e(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Productgroepen/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductgroepen_GetCount313e(_response));
        });
    }

    protected processProductgroepen_GetCount313e(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from ProductVeilgroepen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    productVeilgroepen_ProductVeilgroep_ListProductVeilgroep(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<ProductVeilgroepCollectionResponse> {
        let url_ = this.baseUrl + "/ProductVeilgroepen?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductVeilgroepen_ProductVeilgroep_ListProductVeilgroep(_response));
        });
    }

    protected processProductVeilgroepen_ProductVeilgroep_ListProductVeilgroep(response: Response): Promise<ProductVeilgroepCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductVeilgroepCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to ProductVeilgroepen
     * @param body New entity
     * @return Created entity
     */
    productVeilgroepen_ProductVeilgroep_CreateProductVeilgroep(body: ProductVeilgroep): Promise<ProductVeilgroep> {
        let url_ = this.baseUrl + "/ProductVeilgroepen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductVeilgroepen_ProductVeilgroep_CreateProductVeilgroep(_response));
        });
    }

    protected processProductVeilgroepen_ProductVeilgroep_CreateProductVeilgroep(response: Response): Promise<ProductVeilgroep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ProductVeilgroep.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from ProductVeilgroepen by key
     * @param productVeilgroepAisID The unique identifier of ProductVeilgroep
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    productVeilgroepen_ProductVeilgroep_GetProductVeilgroep(productVeilgroepAisID: number, select: string[] | undefined, expand: string[] | undefined): Promise<ProductVeilgroep> {
        let url_ = this.baseUrl + "/ProductVeilgroepen({productVeilgroepAisID})?";
        if (productVeilgroepAisID === undefined || productVeilgroepAisID === null)
            throw new Error("The parameter 'productVeilgroepAisID' must be defined.");
        url_ = url_.replace("{productVeilgroepAisID}", encodeURIComponent("" + productVeilgroepAisID));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductVeilgroepen_ProductVeilgroep_GetProductVeilgroep(_response));
        });
    }

    protected processProductVeilgroepen_ProductVeilgroep_GetProductVeilgroep(response: Response): Promise<ProductVeilgroep> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductVeilgroep.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in ProductVeilgroepen
     * @param productVeilgroepAisID The unique identifier of ProductVeilgroep
     * @param body New property values
     * @return Success
     */
    productVeilgroepen_ProductVeilgroep_UpdateProductVeilgroep(productVeilgroepAisID: number, body: ProductVeilgroep): Promise<void> {
        let url_ = this.baseUrl + "/ProductVeilgroepen({productVeilgroepAisID})";
        if (productVeilgroepAisID === undefined || productVeilgroepAisID === null)
            throw new Error("The parameter 'productVeilgroepAisID' must be defined.");
        url_ = url_.replace("{productVeilgroepAisID}", encodeURIComponent("" + productVeilgroepAisID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductVeilgroepen_ProductVeilgroep_UpdateProductVeilgroep(_response));
        });
    }

    protected processProductVeilgroepen_ProductVeilgroep_UpdateProductVeilgroep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from ProductVeilgroepen
     * @param productVeilgroepAisID The unique identifier of ProductVeilgroep
     * @param if_Match (optional) ETag
     * @return Success
     */
    productVeilgroepen_ProductVeilgroep_DeleteProductVeilgroep(productVeilgroepAisID: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ProductVeilgroepen({productVeilgroepAisID})";
        if (productVeilgroepAisID === undefined || productVeilgroepAisID === null)
            throw new Error("The parameter 'productVeilgroepAisID' must be defined.");
        url_ = url_.replace("{productVeilgroepAisID}", encodeURIComponent("" + productVeilgroepAisID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductVeilgroepen_ProductVeilgroep_DeleteProductVeilgroep(_response));
        });
    }

    protected processProductVeilgroepen_ProductVeilgroep_DeleteProductVeilgroep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    productVeilgroepen_GetCount8340(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/ProductVeilgroepen/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductVeilgroepen_GetCount8340(_response));
        });
    }

    protected processProductVeilgroepen_GetCount8340(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function GetVeilgroep
     * @param veilgroepCode Usage: veilgroepCode={veilgroepCode}
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    productVeilgroepen_GetVeilgroep(veilgroepCode: number, vestigingCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous14> {
        let url_ = this.baseUrl + "/ProductVeilgroepen/AanbodBeheerService.GetVeilgroep(veilgroepCode={veilgroepCode},vestigingCode={vestigingCode})?";
        if (veilgroepCode === undefined || veilgroepCode === null)
            throw new Error("The parameter 'veilgroepCode' must be defined.");
        url_ = url_.replace("{veilgroepCode}", encodeURIComponent("" + veilgroepCode));
        if (vestigingCode === undefined || vestigingCode === null)
            throw new Error("The parameter 'vestigingCode' must be defined.");
        url_ = url_.replace("{vestigingCode}", encodeURIComponent("" + vestigingCode));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductVeilgroepen_GetVeilgroep(_response));
        });
    }

    protected processProductVeilgroepen_GetVeilgroep(response: Response): Promise<Anonymous14> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous14.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function ZoekProductVeilgroepen
     * @param bloemenPlantenCode Usage: bloemenPlantenCode={bloemenPlantenCode}
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    productVeilgroepen_ZoekProductVeilgroepen(bloemenPlantenCode: string | null, vestigingCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous15> {
        let url_ = this.baseUrl + "/ProductVeilgroepen/AanbodBeheerService.ZoekProductVeilgroepen(bloemenPlantenCode={bloemenPlantenCode},vestigingCode={vestigingCode})?";
        if (bloemenPlantenCode === undefined || bloemenPlantenCode === null)
            throw new Error("The parameter 'bloemenPlantenCode' must be defined.");
        url_ = url_.replace("{bloemenPlantenCode}", encodeURIComponent("" + bloemenPlantenCode));
        if (vestigingCode === undefined || vestigingCode === null)
            throw new Error("The parameter 'vestigingCode' must be defined.");
        url_ = url_.replace("{vestigingCode}", encodeURIComponent("" + vestigingCode));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductVeilgroepen_ZoekProductVeilgroepen(_response));
        });
    }

    protected processProductVeilgroepen_ZoekProductVeilgroepen(response: Response): Promise<Anonymous15> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous15.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from TribuneKlokken
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    tribuneKlokken_TribuneKlok_ListTribuneKlok(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<TribuneKlokCollectionResponse> {
        let url_ = this.baseUrl + "/TribuneKlokken?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTribuneKlokken_TribuneKlok_ListTribuneKlok(_response));
        });
    }

    protected processTribuneKlokken_TribuneKlok_ListTribuneKlok(response: Response): Promise<TribuneKlokCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TribuneKlokCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to TribuneKlokken
     * @param body New entity
     * @return Created entity
     */
    tribuneKlokken_TribuneKlok_CreateTribuneKlok(body: TribuneKlok): Promise<TribuneKlok> {
        let url_ = this.baseUrl + "/TribuneKlokken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTribuneKlokken_TribuneKlok_CreateTribuneKlok(_response));
        });
    }

    protected processTribuneKlokken_TribuneKlok_CreateTribuneKlok(response: Response): Promise<TribuneKlok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TribuneKlok.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from TribuneKlokken by key
     * @param klokNummer The unique identifier of TribuneKlok
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    tribuneKlokken_TribuneKlok_GetTribuneKlok(klokNummer: number, select: string[] | undefined, expand: string[] | undefined): Promise<TribuneKlok> {
        let url_ = this.baseUrl + "/TribuneKlokken({klokNummer})?";
        if (klokNummer === undefined || klokNummer === null)
            throw new Error("The parameter 'klokNummer' must be defined.");
        url_ = url_.replace("{klokNummer}", encodeURIComponent("" + klokNummer));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTribuneKlokken_TribuneKlok_GetTribuneKlok(_response));
        });
    }

    protected processTribuneKlokken_TribuneKlok_GetTribuneKlok(response: Response): Promise<TribuneKlok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TribuneKlok.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in TribuneKlokken
     * @param klokNummer The unique identifier of TribuneKlok
     * @param body New property values
     * @return Success
     */
    tribuneKlokken_TribuneKlok_UpdateTribuneKlok(klokNummer: number, body: TribuneKlok): Promise<void> {
        let url_ = this.baseUrl + "/TribuneKlokken({klokNummer})";
        if (klokNummer === undefined || klokNummer === null)
            throw new Error("The parameter 'klokNummer' must be defined.");
        url_ = url_.replace("{klokNummer}", encodeURIComponent("" + klokNummer));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTribuneKlokken_TribuneKlok_UpdateTribuneKlok(_response));
        });
    }

    protected processTribuneKlokken_TribuneKlok_UpdateTribuneKlok(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from TribuneKlokken
     * @param klokNummer The unique identifier of TribuneKlok
     * @param if_Match (optional) ETag
     * @return Success
     */
    tribuneKlokken_TribuneKlok_DeleteTribuneKlok(klokNummer: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/TribuneKlokken({klokNummer})";
        if (klokNummer === undefined || klokNummer === null)
            throw new Error("The parameter 'klokNummer' must be defined.");
        url_ = url_.replace("{klokNummer}", encodeURIComponent("" + klokNummer));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTribuneKlokken_TribuneKlok_DeleteTribuneKlok(_response));
        });
    }

    protected processTribuneKlokken_TribuneKlok_DeleteTribuneKlok(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    tribuneKlokken_GetCount19e6(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/TribuneKlokken/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTribuneKlokken_GetCount19e6(_response));
        });
    }

    protected processTribuneKlokken_GetCount19e6(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from UitzonderingRedenen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    uitzonderingRedenen_UitzonderingReden_ListUitzonderingReden(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<UitzonderingRedenCollectionResponse> {
        let url_ = this.baseUrl + "/UitzonderingRedenen?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUitzonderingRedenen_UitzonderingReden_ListUitzonderingReden(_response));
        });
    }

    protected processUitzonderingRedenen_UitzonderingReden_ListUitzonderingReden(response: Response): Promise<UitzonderingRedenCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UitzonderingRedenCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to UitzonderingRedenen
     * @param body New entity
     * @return Created entity
     */
    uitzonderingRedenen_UitzonderingReden_CreateUitzonderingReden(body: UitzonderingReden): Promise<UitzonderingReden> {
        let url_ = this.baseUrl + "/UitzonderingRedenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUitzonderingRedenen_UitzonderingReden_CreateUitzonderingReden(_response));
        });
    }

    protected processUitzonderingRedenen_UitzonderingReden_CreateUitzonderingReden(response: Response): Promise<UitzonderingReden> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = UitzonderingReden.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from UitzonderingRedenen by key
     * @param uitzonderingRedenCode The unique identifier of UitzonderingReden
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    uitzonderingRedenen_UitzonderingReden_GetUitzonderingReden(uitzonderingRedenCode: number, select: string[] | undefined, expand: string[] | undefined): Promise<UitzonderingReden> {
        let url_ = this.baseUrl + "/UitzonderingRedenen({uitzonderingRedenCode})?";
        if (uitzonderingRedenCode === undefined || uitzonderingRedenCode === null)
            throw new Error("The parameter 'uitzonderingRedenCode' must be defined.");
        url_ = url_.replace("{uitzonderingRedenCode}", encodeURIComponent("" + uitzonderingRedenCode));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUitzonderingRedenen_UitzonderingReden_GetUitzonderingReden(_response));
        });
    }

    protected processUitzonderingRedenen_UitzonderingReden_GetUitzonderingReden(response: Response): Promise<UitzonderingReden> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UitzonderingReden.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in UitzonderingRedenen
     * @param uitzonderingRedenCode The unique identifier of UitzonderingReden
     * @param body New property values
     * @return Success
     */
    uitzonderingRedenen_UitzonderingReden_UpdateUitzonderingReden(uitzonderingRedenCode: number, body: UitzonderingReden): Promise<void> {
        let url_ = this.baseUrl + "/UitzonderingRedenen({uitzonderingRedenCode})";
        if (uitzonderingRedenCode === undefined || uitzonderingRedenCode === null)
            throw new Error("The parameter 'uitzonderingRedenCode' must be defined.");
        url_ = url_.replace("{uitzonderingRedenCode}", encodeURIComponent("" + uitzonderingRedenCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUitzonderingRedenen_UitzonderingReden_UpdateUitzonderingReden(_response));
        });
    }

    protected processUitzonderingRedenen_UitzonderingReden_UpdateUitzonderingReden(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from UitzonderingRedenen
     * @param uitzonderingRedenCode The unique identifier of UitzonderingReden
     * @param if_Match (optional) ETag
     * @return Success
     */
    uitzonderingRedenen_UitzonderingReden_DeleteUitzonderingReden(uitzonderingRedenCode: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/UitzonderingRedenen({uitzonderingRedenCode})";
        if (uitzonderingRedenCode === undefined || uitzonderingRedenCode === null)
            throw new Error("The parameter 'uitzonderingRedenCode' must be defined.");
        url_ = url_.replace("{uitzonderingRedenCode}", encodeURIComponent("" + uitzonderingRedenCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUitzonderingRedenen_UitzonderingReden_DeleteUitzonderingReden(_response));
        });
    }

    protected processUitzonderingRedenen_UitzonderingReden_DeleteUitzonderingReden(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    uitzonderingRedenen_GetCountD40e(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/UitzonderingRedenen/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUitzonderingRedenen_GetCountD40e(_response));
        });
    }

    protected processUitzonderingRedenen_GetCountD40e(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from VeilgroepIndelingen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    veilgroepIndelingen_VeilgroepIndelingOverview_ListVeilgroepIndelingOverview(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepIndelingOverviewCollectionResponse> {
        let url_ = this.baseUrl + "/VeilgroepIndelingen?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingen_VeilgroepIndelingOverview_ListVeilgroepIndelingOverview(_response));
        });
    }

    protected processVeilgroepIndelingen_VeilgroepIndelingOverview_ListVeilgroepIndelingOverview(response: Response): Promise<VeilgroepIndelingOverviewCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VeilgroepIndelingOverviewCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to VeilgroepIndelingen
     * @param body New entity
     * @return Created entity
     */
    veilgroepIndelingen_VeilgroepIndelingOverview_CreateVeilgroepIndelingOverview(body: VeilgroepIndelingOverview): Promise<VeilgroepIndelingOverview> {
        let url_ = this.baseUrl + "/VeilgroepIndelingen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingen_VeilgroepIndelingOverview_CreateVeilgroepIndelingOverview(_response));
        });
    }

    protected processVeilgroepIndelingen_VeilgroepIndelingOverview_CreateVeilgroepIndelingOverview(response: Response): Promise<VeilgroepIndelingOverview> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = VeilgroepIndelingOverview.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from VeilgroepIndelingen by key
     * @param productclusterID The unique identifier of VeilgroepIndelingOverview
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    veilgroepIndelingen_VeilgroepIndelingOverview_GetVeilgroepIndelingOverview(productclusterID: number, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepIndelingOverview> {
        let url_ = this.baseUrl + "/VeilgroepIndelingen({productclusterID})?";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingen_VeilgroepIndelingOverview_GetVeilgroepIndelingOverview(_response));
        });
    }

    protected processVeilgroepIndelingen_VeilgroepIndelingOverview_GetVeilgroepIndelingOverview(response: Response): Promise<VeilgroepIndelingOverview> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VeilgroepIndelingOverview.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in VeilgroepIndelingen
     * @param productclusterID The unique identifier of VeilgroepIndelingOverview
     * @param body New property values
     * @return Success
     */
    veilgroepIndelingen_VeilgroepIndelingOverview_UpdateVeilgroepIndelingOverview(productclusterID: number, body: VeilgroepIndelingOverview): Promise<void> {
        let url_ = this.baseUrl + "/VeilgroepIndelingen({productclusterID})";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingen_VeilgroepIndelingOverview_UpdateVeilgroepIndelingOverview(_response));
        });
    }

    protected processVeilgroepIndelingen_VeilgroepIndelingOverview_UpdateVeilgroepIndelingOverview(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from VeilgroepIndelingen
     * @param productclusterID The unique identifier of VeilgroepIndelingOverview
     * @param if_Match (optional) ETag
     * @return Success
     */
    veilgroepIndelingen_VeilgroepIndelingOverview_DeleteVeilgroepIndelingOverview(productclusterID: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/VeilgroepIndelingen({productclusterID})";
        if (productclusterID === undefined || productclusterID === null)
            throw new Error("The parameter 'productclusterID' must be defined.");
        url_ = url_.replace("{productclusterID}", encodeURIComponent("" + productclusterID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingen_VeilgroepIndelingOverview_DeleteVeilgroepIndelingOverview(_response));
        });
    }

    protected processVeilgroepIndelingen_VeilgroepIndelingOverview_DeleteVeilgroepIndelingOverview(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    veilgroepIndelingen_GetCountCd00(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/VeilgroepIndelingen/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingen_GetCountCd00(_response));
        });
    }

    protected processVeilgroepIndelingen_GetCountCd00(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function GetByBloemenPlantenVestiging
     * @param bloemenPlantenCode Usage: bloemenPlantenCode={bloemenPlantenCode}
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    veilgroepIndelingen_GetByBloemenPlantenVestiging(bloemenPlantenCode: string | null, vestigingCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous16> {
        let url_ = this.baseUrl + "/VeilgroepIndelingen/AanbodBeheerService.GetByBloemenPlantenVestiging(bloemenPlantenCode={bloemenPlantenCode},vestigingCode={vestigingCode})?";
        if (bloemenPlantenCode === undefined || bloemenPlantenCode === null)
            throw new Error("The parameter 'bloemenPlantenCode' must be defined.");
        url_ = url_.replace("{bloemenPlantenCode}", encodeURIComponent("" + bloemenPlantenCode));
        if (vestigingCode === undefined || vestigingCode === null)
            throw new Error("The parameter 'vestigingCode' must be defined.");
        url_ = url_.replace("{vestigingCode}", encodeURIComponent("" + vestigingCode));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingen_GetByBloemenPlantenVestiging(_response));
        });
    }

    protected processVeilgroepIndelingen_GetByBloemenPlantenVestiging(response: Response): Promise<Anonymous16> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous16.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from VeilgroepIndelingRegelViews
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    veilgroepIndelingRegelViews_VeilgroepIndelingRegelView_ListVeilgroepIndelingRegelView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepIndelingRegelViewCollectionResponse> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelViews?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelViews_VeilgroepIndelingRegelView_ListVeilgroepIndelingRegelView(_response));
        });
    }

    protected processVeilgroepIndelingRegelViews_VeilgroepIndelingRegelView_ListVeilgroepIndelingRegelView(response: Response): Promise<VeilgroepIndelingRegelViewCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VeilgroepIndelingRegelViewCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to VeilgroepIndelingRegelViews
     * @param body New entity
     * @return Created entity
     */
    veilgroepIndelingRegelViews_VeilgroepIndelingRegelView_CreateVeilgroepIndelingRegelView(body: VeilgroepIndelingRegelView): Promise<VeilgroepIndelingRegelView> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelViews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelViews_VeilgroepIndelingRegelView_CreateVeilgroepIndelingRegelView(_response));
        });
    }

    protected processVeilgroepIndelingRegelViews_VeilgroepIndelingRegelView_CreateVeilgroepIndelingRegelView(response: Response): Promise<VeilgroepIndelingRegelView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = VeilgroepIndelingRegelView.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from VeilgroepIndelingRegelViews by key
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    veilgroepIndelingRegelViews_VeilgroepIndelingRegelView_GetVeilgroepIndelingRegelView(productclusterVeilgroepRegelId: number, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepIndelingRegelView> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelViews({productclusterVeilgroepRegelId})?";
        if (productclusterVeilgroepRegelId === undefined || productclusterVeilgroepRegelId === null)
            throw new Error("The parameter 'productclusterVeilgroepRegelId' must be defined.");
        url_ = url_.replace("{productclusterVeilgroepRegelId}", encodeURIComponent("" + productclusterVeilgroepRegelId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelViews_VeilgroepIndelingRegelView_GetVeilgroepIndelingRegelView(_response));
        });
    }

    protected processVeilgroepIndelingRegelViews_VeilgroepIndelingRegelView_GetVeilgroepIndelingRegelView(response: Response): Promise<VeilgroepIndelingRegelView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VeilgroepIndelingRegelView.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in VeilgroepIndelingRegelViews
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelView
     * @param body New property values
     * @return Success
     */
    veilgroepIndelingRegelViews_VeilgroepIndelingRegelView_UpdateVeilgroepIndelingRegelView(productclusterVeilgroepRegelId: number, body: VeilgroepIndelingRegelView): Promise<void> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelViews({productclusterVeilgroepRegelId})";
        if (productclusterVeilgroepRegelId === undefined || productclusterVeilgroepRegelId === null)
            throw new Error("The parameter 'productclusterVeilgroepRegelId' must be defined.");
        url_ = url_.replace("{productclusterVeilgroepRegelId}", encodeURIComponent("" + productclusterVeilgroepRegelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelViews_VeilgroepIndelingRegelView_UpdateVeilgroepIndelingRegelView(_response));
        });
    }

    protected processVeilgroepIndelingRegelViews_VeilgroepIndelingRegelView_UpdateVeilgroepIndelingRegelView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from VeilgroepIndelingRegelViews
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelView
     * @param if_Match (optional) ETag
     * @return Success
     */
    veilgroepIndelingRegelViews_VeilgroepIndelingRegelView_DeleteVeilgroepIndelingRegelView(productclusterVeilgroepRegelId: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelViews({productclusterVeilgroepRegelId})";
        if (productclusterVeilgroepRegelId === undefined || productclusterVeilgroepRegelId === null)
            throw new Error("The parameter 'productclusterVeilgroepRegelId' must be defined.");
        url_ = url_.replace("{productclusterVeilgroepRegelId}", encodeURIComponent("" + productclusterVeilgroepRegelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelViews_VeilgroepIndelingRegelView_DeleteVeilgroepIndelingRegelView(_response));
        });
    }

    protected processVeilgroepIndelingRegelViews_VeilgroepIndelingRegelView_DeleteVeilgroepIndelingRegelView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke action Delete
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelView
     * @param body Action parameters
     * @return Success
     */
    veilgroepIndelingRegelViews_VeilgroepIndelingRegelView_Delete(productclusterVeilgroepRegelId: number, body: Body3): Promise<Anonymous17> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelViews({productclusterVeilgroepRegelId})/AanbodBeheerService.Delete";
        if (productclusterVeilgroepRegelId === undefined || productclusterVeilgroepRegelId === null)
            throw new Error("The parameter 'productclusterVeilgroepRegelId' must be defined.");
        url_ = url_.replace("{productclusterVeilgroepRegelId}", encodeURIComponent("" + productclusterVeilgroepRegelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelViews_VeilgroepIndelingRegelView_Delete(_response));
        });
    }

    protected processVeilgroepIndelingRegelViews_VeilgroepIndelingRegelView_Delete(response: Response): Promise<Anonymous17> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke action UpdateMultiple
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelView
     * @return Success
     */
    veilgroepIndelingRegelViews_VeilgroepIndelingRegelView_UpdateMultiple(productclusterVeilgroepRegelId: number): Promise<Anonymous18> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelViews({productclusterVeilgroepRegelId})/AanbodBeheerService.UpdateMultiple";
        if (productclusterVeilgroepRegelId === undefined || productclusterVeilgroepRegelId === null)
            throw new Error("The parameter 'productclusterVeilgroepRegelId' must be defined.");
        url_ = url_.replace("{productclusterVeilgroepRegelId}", encodeURIComponent("" + productclusterVeilgroepRegelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelViews_VeilgroepIndelingRegelView_UpdateMultiple(_response));
        });
    }

    protected processVeilgroepIndelingRegelViews_VeilgroepIndelingRegelView_UpdateMultiple(response: Response): Promise<Anonymous18> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    veilgroepIndelingRegelViews_GetCountCd69(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelViews/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelViews_GetCountCd69(_response));
        });
    }

    protected processVeilgroepIndelingRegelViews_GetCountCd69(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function GetByProductclusterVestiging
     * @param productclusterId Usage: productclusterId={productclusterId}
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    veilgroepIndelingRegelViews_GetByProductclusterVestiging(productclusterId: number, vestigingCode: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous19> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelViews/AanbodBeheerService.GetByProductclusterVestiging(productclusterId={productclusterId},vestigingCode={vestigingCode})?";
        if (productclusterId === undefined || productclusterId === null)
            throw new Error("The parameter 'productclusterId' must be defined.");
        url_ = url_.replace("{productclusterId}", encodeURIComponent("" + productclusterId));
        if (vestigingCode === undefined || vestigingCode === null)
            throw new Error("The parameter 'vestigingCode' must be defined.");
        url_ = url_.replace("{vestigingCode}", encodeURIComponent("" + vestigingCode));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelViews_GetByProductclusterVestiging(_response));
        });
    }

    protected processVeilgroepIndelingRegelViews_GetByProductclusterVestiging(response: Response): Promise<Anonymous19> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous19.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function ZoekFustcodes
     * @param productclusterVeilgroepRegelId Usage: productclusterVeilgroepRegelId={productclusterVeilgroepRegelId}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @return Success
     */
    veilgroepIndelingRegelViews_ZoekFustcodes(productclusterVeilgroepRegelId: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined): Promise<Anonymous20> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelViews/AanbodBeheerService.ZoekFustcodes(productclusterVeilgroepRegelId={productclusterVeilgroepRegelId})?";
        if (productclusterVeilgroepRegelId === undefined || productclusterVeilgroepRegelId === null)
            throw new Error("The parameter 'productclusterVeilgroepRegelId' must be defined.");
        url_ = url_.replace("{productclusterVeilgroepRegelId}", encodeURIComponent("" + productclusterVeilgroepRegelId));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelViews_ZoekFustcodes(_response));
        });
    }

    protected processVeilgroepIndelingRegelViews_ZoekFustcodes(response: Response): Promise<Anonymous20> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous20.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function ZoekProducten
     * @param productclusterId Usage: productclusterId={productclusterId}
     * @param productclusterVeilgroepRegelId Usage: productclusterVeilgroepRegelId={productclusterVeilgroepRegelId}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @return Success
     */
    veilgroepIndelingRegelViews_ZoekProducten(productclusterId: number, productclusterVeilgroepRegelId: number | null, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined): Promise<Anonymous21> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelViews/AanbodBeheerService.ZoekProducten(productclusterId={productclusterId},productclusterVeilgroepRegelId={productclusterVeilgroepRegelId})?";
        if (productclusterId === undefined || productclusterId === null)
            throw new Error("The parameter 'productclusterId' must be defined.");
        url_ = url_.replace("{productclusterId}", encodeURIComponent("" + productclusterId));
        if (productclusterVeilgroepRegelId === undefined || productclusterVeilgroepRegelId === null)
            throw new Error("The parameter 'productclusterVeilgroepRegelId' must be defined.");
        url_ = url_.replace("{productclusterVeilgroepRegelId}", encodeURIComponent("" + productclusterVeilgroepRegelId));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelViews_ZoekProducten(_response));
        });
    }

    protected processVeilgroepIndelingRegelViews_ZoekProducten(response: Response): Promise<Anonymous21> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous21.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function ZoekProductgroepen
     * @param productclusterId Usage: productclusterId={productclusterId}
     * @param productclusterVeilgroepRegelId Usage: productclusterVeilgroepRegelId={productclusterVeilgroepRegelId}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @return Success
     */
    veilgroepIndelingRegelViews_ZoekProductgroepen(productclusterId: number, productclusterVeilgroepRegelId: number | null, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined): Promise<Anonymous22> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelViews/AanbodBeheerService.ZoekProductgroepen(productclusterId={productclusterId},productclusterVeilgroepRegelId={productclusterVeilgroepRegelId})?";
        if (productclusterId === undefined || productclusterId === null)
            throw new Error("The parameter 'productclusterId' must be defined.");
        url_ = url_.replace("{productclusterId}", encodeURIComponent("" + productclusterId));
        if (productclusterVeilgroepRegelId === undefined || productclusterVeilgroepRegelId === null)
            throw new Error("The parameter 'productclusterVeilgroepRegelId' must be defined.");
        url_ = url_.replace("{productclusterVeilgroepRegelId}", encodeURIComponent("" + productclusterVeilgroepRegelId));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelViews_ZoekProductgroepen(_response));
        });
    }

    protected processVeilgroepIndelingRegelViews_ZoekProductgroepen(response: Response): Promise<Anonymous22> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous22.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from VeilgroepIndelingRegelWithCodesView
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    veilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_ListVeilgroepIndelingRegelWithCodesView(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepIndelingRegelWithCodesViewCollectionResponse> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelWithCodesView?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_ListVeilgroepIndelingRegelWithCodesView(_response));
        });
    }

    protected processVeilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_ListVeilgroepIndelingRegelWithCodesView(response: Response): Promise<VeilgroepIndelingRegelWithCodesViewCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VeilgroepIndelingRegelWithCodesViewCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to VeilgroepIndelingRegelWithCodesView
     * @param body New entity
     * @return Created entity
     */
    veilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_CreateVeilgroepIndelingRegelWithCodesView(body: VeilgroepIndelingRegelWithCodesView): Promise<VeilgroepIndelingRegelWithCodesView> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelWithCodesView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_CreateVeilgroepIndelingRegelWithCodesView(_response));
        });
    }

    protected processVeilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_CreateVeilgroepIndelingRegelWithCodesView(response: Response): Promise<VeilgroepIndelingRegelWithCodesView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = VeilgroepIndelingRegelWithCodesView.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from VeilgroepIndelingRegelWithCodesView by key
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelWithCodesView
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    veilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_GetVeilgroepIndelingRegelWithCodesView(productclusterVeilgroepRegelId: number, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepIndelingRegelWithCodesView> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelWithCodesView({productclusterVeilgroepRegelId})?";
        if (productclusterVeilgroepRegelId === undefined || productclusterVeilgroepRegelId === null)
            throw new Error("The parameter 'productclusterVeilgroepRegelId' must be defined.");
        url_ = url_.replace("{productclusterVeilgroepRegelId}", encodeURIComponent("" + productclusterVeilgroepRegelId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_GetVeilgroepIndelingRegelWithCodesView(_response));
        });
    }

    protected processVeilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_GetVeilgroepIndelingRegelWithCodesView(response: Response): Promise<VeilgroepIndelingRegelWithCodesView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VeilgroepIndelingRegelWithCodesView.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in VeilgroepIndelingRegelWithCodesView
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelWithCodesView
     * @param body New property values
     * @return Success
     */
    veilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_UpdateVeilgroepIndelingRegelWithCodesView(productclusterVeilgroepRegelId: number, body: VeilgroepIndelingRegelWithCodesView): Promise<void> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelWithCodesView({productclusterVeilgroepRegelId})";
        if (productclusterVeilgroepRegelId === undefined || productclusterVeilgroepRegelId === null)
            throw new Error("The parameter 'productclusterVeilgroepRegelId' must be defined.");
        url_ = url_.replace("{productclusterVeilgroepRegelId}", encodeURIComponent("" + productclusterVeilgroepRegelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_UpdateVeilgroepIndelingRegelWithCodesView(_response));
        });
    }

    protected processVeilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_UpdateVeilgroepIndelingRegelWithCodesView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from VeilgroepIndelingRegelWithCodesView
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelWithCodesView
     * @param if_Match (optional) ETag
     * @return Success
     */
    veilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_DeleteVeilgroepIndelingRegelWithCodesView(productclusterVeilgroepRegelId: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelWithCodesView({productclusterVeilgroepRegelId})";
        if (productclusterVeilgroepRegelId === undefined || productclusterVeilgroepRegelId === null)
            throw new Error("The parameter 'productclusterVeilgroepRegelId' must be defined.");
        url_ = url_.replace("{productclusterVeilgroepRegelId}", encodeURIComponent("" + productclusterVeilgroepRegelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_DeleteVeilgroepIndelingRegelWithCodesView(_response));
        });
    }

    protected processVeilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_DeleteVeilgroepIndelingRegelWithCodesView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke action UpsertSingleWithCodes
     * @param productclusterVeilgroepRegelId The unique identifier of VeilgroepIndelingRegelWithCodesView
     * @return Success
     */
    veilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_UpsertSingleWithCodes(productclusterVeilgroepRegelId: number): Promise<Anonymous23> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelWithCodesView({productclusterVeilgroepRegelId})/AanbodBeheerService.UpsertSingleWithCodes";
        if (productclusterVeilgroepRegelId === undefined || productclusterVeilgroepRegelId === null)
            throw new Error("The parameter 'productclusterVeilgroepRegelId' must be defined.");
        url_ = url_.replace("{productclusterVeilgroepRegelId}", encodeURIComponent("" + productclusterVeilgroepRegelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_UpsertSingleWithCodes(_response));
        });
    }

    protected processVeilgroepIndelingRegelWithCodesView_VeilgroepIndelingRegelWithCodesView_UpsertSingleWithCodes(response: Response): Promise<Anonymous23> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    veilgroepIndelingRegelWithCodesView_GetCount2fdd(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/VeilgroepIndelingRegelWithCodesView/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepIndelingRegelWithCodesView_GetCount2fdd(_response));
        });
    }

    protected processVeilgroepIndelingRegelWithCodesView_GetCount2fdd(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from VeilgroepRegelKenmerken
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    veilgroepRegelKenmerken_VeilgroepRegelKenmerk_ListVeilgroepRegelKenmerk(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepRegelKenmerkCollectionResponse> {
        let url_ = this.baseUrl + "/VeilgroepRegelKenmerken?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegelKenmerken_VeilgroepRegelKenmerk_ListVeilgroepRegelKenmerk(_response));
        });
    }

    protected processVeilgroepRegelKenmerken_VeilgroepRegelKenmerk_ListVeilgroepRegelKenmerk(response: Response): Promise<VeilgroepRegelKenmerkCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VeilgroepRegelKenmerkCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to VeilgroepRegelKenmerken
     * @param body New entity
     * @return Created entity
     */
    veilgroepRegelKenmerken_VeilgroepRegelKenmerk_CreateVeilgroepRegelKenmerk(body: VeilgroepRegelKenmerk): Promise<VeilgroepRegelKenmerk> {
        let url_ = this.baseUrl + "/VeilgroepRegelKenmerken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegelKenmerken_VeilgroepRegelKenmerk_CreateVeilgroepRegelKenmerk(_response));
        });
    }

    protected processVeilgroepRegelKenmerken_VeilgroepRegelKenmerk_CreateVeilgroepRegelKenmerk(response: Response): Promise<VeilgroepRegelKenmerk> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = VeilgroepRegelKenmerk.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from VeilgroepRegelKenmerken by key
     * @param veilgroepRegelKenmerkId The unique identifier of VeilgroepRegelKenmerk
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    veilgroepRegelKenmerken_VeilgroepRegelKenmerk_GetVeilgroepRegelKenmerk(veilgroepRegelKenmerkId: number, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepRegelKenmerk> {
        let url_ = this.baseUrl + "/VeilgroepRegelKenmerken({veilgroepRegelKenmerkId})?";
        if (veilgroepRegelKenmerkId === undefined || veilgroepRegelKenmerkId === null)
            throw new Error("The parameter 'veilgroepRegelKenmerkId' must be defined.");
        url_ = url_.replace("{veilgroepRegelKenmerkId}", encodeURIComponent("" + veilgroepRegelKenmerkId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegelKenmerken_VeilgroepRegelKenmerk_GetVeilgroepRegelKenmerk(_response));
        });
    }

    protected processVeilgroepRegelKenmerken_VeilgroepRegelKenmerk_GetVeilgroepRegelKenmerk(response: Response): Promise<VeilgroepRegelKenmerk> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VeilgroepRegelKenmerk.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in VeilgroepRegelKenmerken
     * @param veilgroepRegelKenmerkId The unique identifier of VeilgroepRegelKenmerk
     * @param body New property values
     * @return Success
     */
    veilgroepRegelKenmerken_VeilgroepRegelKenmerk_UpdateVeilgroepRegelKenmerk(veilgroepRegelKenmerkId: number, body: VeilgroepRegelKenmerk): Promise<void> {
        let url_ = this.baseUrl + "/VeilgroepRegelKenmerken({veilgroepRegelKenmerkId})";
        if (veilgroepRegelKenmerkId === undefined || veilgroepRegelKenmerkId === null)
            throw new Error("The parameter 'veilgroepRegelKenmerkId' must be defined.");
        url_ = url_.replace("{veilgroepRegelKenmerkId}", encodeURIComponent("" + veilgroepRegelKenmerkId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegelKenmerken_VeilgroepRegelKenmerk_UpdateVeilgroepRegelKenmerk(_response));
        });
    }

    protected processVeilgroepRegelKenmerken_VeilgroepRegelKenmerk_UpdateVeilgroepRegelKenmerk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from VeilgroepRegelKenmerken
     * @param veilgroepRegelKenmerkId The unique identifier of VeilgroepRegelKenmerk
     * @param if_Match (optional) ETag
     * @return Success
     */
    veilgroepRegelKenmerken_VeilgroepRegelKenmerk_DeleteVeilgroepRegelKenmerk(veilgroepRegelKenmerkId: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/VeilgroepRegelKenmerken({veilgroepRegelKenmerkId})";
        if (veilgroepRegelKenmerkId === undefined || veilgroepRegelKenmerkId === null)
            throw new Error("The parameter 'veilgroepRegelKenmerkId' must be defined.");
        url_ = url_.replace("{veilgroepRegelKenmerkId}", encodeURIComponent("" + veilgroepRegelKenmerkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegelKenmerken_VeilgroepRegelKenmerk_DeleteVeilgroepRegelKenmerk(_response));
        });
    }

    protected processVeilgroepRegelKenmerken_VeilgroepRegelKenmerk_DeleteVeilgroepRegelKenmerk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    veilgroepRegelKenmerken_GetCount046b(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/VeilgroepRegelKenmerken/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegelKenmerken_GetCount046b(_response));
        });
    }

    protected processVeilgroepRegelKenmerken_GetCount046b(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from VeilgroepRegels
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    veilgroepRegels_VeilgroepRegel_ListVeilgroepRegel(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepRegelCollectionResponse> {
        let url_ = this.baseUrl + "/VeilgroepRegels?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegels_VeilgroepRegel_ListVeilgroepRegel(_response));
        });
    }

    protected processVeilgroepRegels_VeilgroepRegel_ListVeilgroepRegel(response: Response): Promise<VeilgroepRegelCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VeilgroepRegelCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to VeilgroepRegels
     * @param body New entity
     * @return Created entity
     */
    veilgroepRegels_VeilgroepRegel_CreateVeilgroepRegel(body: VeilgroepRegel): Promise<VeilgroepRegel> {
        let url_ = this.baseUrl + "/VeilgroepRegels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegels_VeilgroepRegel_CreateVeilgroepRegel(_response));
        });
    }

    protected processVeilgroepRegels_VeilgroepRegel_CreateVeilgroepRegel(response: Response): Promise<VeilgroepRegel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = VeilgroepRegel.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from VeilgroepRegels by key
     * @param veilgroepRegelId The unique identifier of VeilgroepRegel
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    veilgroepRegels_VeilgroepRegel_GetVeilgroepRegel(veilgroepRegelId: number, select: string[] | undefined, expand: string[] | undefined): Promise<VeilgroepRegel> {
        let url_ = this.baseUrl + "/VeilgroepRegels({veilgroepRegelId})?";
        if (veilgroepRegelId === undefined || veilgroepRegelId === null)
            throw new Error("The parameter 'veilgroepRegelId' must be defined.");
        url_ = url_.replace("{veilgroepRegelId}", encodeURIComponent("" + veilgroepRegelId));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegels_VeilgroepRegel_GetVeilgroepRegel(_response));
        });
    }

    protected processVeilgroepRegels_VeilgroepRegel_GetVeilgroepRegel(response: Response): Promise<VeilgroepRegel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VeilgroepRegel.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in VeilgroepRegels
     * @param veilgroepRegelId The unique identifier of VeilgroepRegel
     * @param body New property values
     * @return Success
     */
    veilgroepRegels_VeilgroepRegel_UpdateVeilgroepRegel(veilgroepRegelId: number, body: VeilgroepRegel): Promise<void> {
        let url_ = this.baseUrl + "/VeilgroepRegels({veilgroepRegelId})";
        if (veilgroepRegelId === undefined || veilgroepRegelId === null)
            throw new Error("The parameter 'veilgroepRegelId' must be defined.");
        url_ = url_.replace("{veilgroepRegelId}", encodeURIComponent("" + veilgroepRegelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegels_VeilgroepRegel_UpdateVeilgroepRegel(_response));
        });
    }

    protected processVeilgroepRegels_VeilgroepRegel_UpdateVeilgroepRegel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from VeilgroepRegels
     * @param veilgroepRegelId The unique identifier of VeilgroepRegel
     * @param if_Match (optional) ETag
     * @return Success
     */
    veilgroepRegels_VeilgroepRegel_DeleteVeilgroepRegel(veilgroepRegelId: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/VeilgroepRegels({veilgroepRegelId})";
        if (veilgroepRegelId === undefined || veilgroepRegelId === null)
            throw new Error("The parameter 'veilgroepRegelId' must be defined.");
        url_ = url_.replace("{veilgroepRegelId}", encodeURIComponent("" + veilgroepRegelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegels_VeilgroepRegel_DeleteVeilgroepRegel(_response));
        });
    }

    protected processVeilgroepRegels_VeilgroepRegel_DeleteVeilgroepRegel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    veilgroepRegels_GetCount9095(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/VeilgroepRegels/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegels_GetCount9095(_response));
        });
    }

    protected processVeilgroepRegels_GetCount9095(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function GetByRegelnummer
     * @param veilgroepRegelNummer Usage: veilgroepRegelNummer={veilgroepRegelNummer}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    veilgroepRegels_GetByRegelnummer(veilgroepRegelNummer: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous24> {
        let url_ = this.baseUrl + "/VeilgroepRegels/AanbodBeheerService.GetByRegelnummer(veilgroepRegelNummer={veilgroepRegelNummer})?";
        if (veilgroepRegelNummer === undefined || veilgroepRegelNummer === null)
            throw new Error("The parameter 'veilgroepRegelNummer' must be defined.");
        url_ = url_.replace("{veilgroepRegelNummer}", encodeURIComponent("" + veilgroepRegelNummer));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegels_GetByRegelnummer(_response));
        });
    }

    protected processVeilgroepRegels_GetByRegelnummer(response: Response): Promise<Anonymous24> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous24.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function GetClusterEnRegels
     * @param productCode Usage: productCode={productCode}
     * @return Success
     */
    veilgroepRegels_GetClusterEnRegelsDfe1(productCode: number | null): Promise<Anonymous25> {
        let url_ = this.baseUrl + "/VeilgroepRegels/AanbodBeheerService.GetClusterEnRegels(productCode={productCode})";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegels_GetClusterEnRegelsDfe1(_response));
        });
    }

    protected processVeilgroepRegels_GetClusterEnRegelsDfe1(response: Response): Promise<Anonymous25> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function GetClusterEnRegels
     * @param productgroepCode Usage: productgroepCode={productgroepCode}
     * @return Success
     */
    veilgroepRegels_GetClusterEnRegels4adc(productgroepCode: number | null): Promise<Anonymous26> {
        let url_ = this.baseUrl + "/VeilgroepRegels/AanbodBeheerService.GetClusterEnRegels(productgroepCode={productgroepCode})";
        if (productgroepCode === undefined || productgroepCode === null)
            throw new Error("The parameter 'productgroepCode' must be defined.");
        url_ = url_.replace("{productgroepCode}", encodeURIComponent("" + productgroepCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegels_GetClusterEnRegels4adc(_response));
        });
    }

    protected processVeilgroepRegels_GetClusterEnRegels4adc(response: Response): Promise<Anonymous26> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function ZoekVeilgroepRegels
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @return Success
     */
    veilgroepRegels_ZoekVeilgroepRegels(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined): Promise<Anonymous27> {
        let url_ = this.baseUrl + "/VeilgroepRegels/AanbodBeheerService.ZoekVeilgroepRegels()?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepRegels_ZoekVeilgroepRegels(_response));
        });
    }

    protected processVeilgroepRegels_ZoekVeilgroepRegels(response: Response): Promise<Anonymous27> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous27.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entities from VeilgroepTellingen
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param orderby (optional) Order items by property values
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved collection
     */
    veilgroepTellingen_VeildagVeilgroepTellingReport_ListVeildagVeilgroepTellingReport(top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, orderby: string[] | undefined, select: string[] | undefined, expand: string[] | undefined): Promise<VeildagVeilgroepTellingReportCollectionResponse> {
        let url_ = this.baseUrl + "/VeilgroepTellingen?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepTellingen_VeildagVeilgroepTellingReport_ListVeildagVeilgroepTellingReport(_response));
        });
    }

    protected processVeilgroepTellingen_VeildagVeilgroepTellingReport_ListVeildagVeilgroepTellingReport(response: Response): Promise<VeildagVeilgroepTellingReportCollectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VeildagVeilgroepTellingReportCollectionResponse.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Add new entity to VeilgroepTellingen
     * @param body New entity
     * @return Created entity
     */
    veilgroepTellingen_VeildagVeilgroepTellingReport_CreateVeildagVeilgroepTellingReport(body: VeildagVeilgroepTellingReport): Promise<VeildagVeilgroepTellingReport> {
        let url_ = this.baseUrl + "/VeilgroepTellingen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepTellingen_VeildagVeilgroepTellingReport_CreateVeildagVeilgroepTellingReport(_response));
        });
    }

    protected processVeilgroepTellingen_VeildagVeilgroepTellingReport_CreateVeildagVeilgroepTellingReport(response: Response): Promise<VeildagVeilgroepTellingReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = VeildagVeilgroepTellingReport.fromJS(resultData201);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get entity from VeilgroepTellingen by key
     * @param vestigingCode The unique identifier of VeildagVeilgroepTellingReport
     * @param select (optional) Select properties to be returned
     * @param expand (optional) Expand related entities
     * @return Retrieved entity
     */
    veilgroepTellingen_VeildagVeilgroepTellingReport_GetVeildagVeilgroepTellingReport(vestigingCode: number, select: string[] | undefined, expand: string[] | undefined): Promise<VeildagVeilgroepTellingReport> {
        let url_ = this.baseUrl + "/VeilgroepTellingen({vestigingCode})?";
        if (vestigingCode === undefined || vestigingCode === null)
            throw new Error("The parameter 'vestigingCode' must be defined.");
        url_ = url_.replace("{vestigingCode}", encodeURIComponent("" + vestigingCode));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepTellingen_VeildagVeilgroepTellingReport_GetVeildagVeilgroepTellingReport(_response));
        });
    }

    protected processVeilgroepTellingen_VeildagVeilgroepTellingReport_GetVeildagVeilgroepTellingReport(response: Response): Promise<VeildagVeilgroepTellingReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VeildagVeilgroepTellingReport.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update entity in VeilgroepTellingen
     * @param vestigingCode The unique identifier of VeildagVeilgroepTellingReport
     * @param body New property values
     * @return Success
     */
    veilgroepTellingen_VeildagVeilgroepTellingReport_UpdateVeildagVeilgroepTellingReport(vestigingCode: number, body: VeildagVeilgroepTellingReport): Promise<void> {
        let url_ = this.baseUrl + "/VeilgroepTellingen({vestigingCode})";
        if (vestigingCode === undefined || vestigingCode === null)
            throw new Error("The parameter 'vestigingCode' must be defined.");
        url_ = url_.replace("{vestigingCode}", encodeURIComponent("" + vestigingCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepTellingen_VeildagVeilgroepTellingReport_UpdateVeildagVeilgroepTellingReport(_response));
        });
    }

    protected processVeilgroepTellingen_VeildagVeilgroepTellingReport_UpdateVeildagVeilgroepTellingReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Delete entity from VeilgroepTellingen
     * @param vestigingCode The unique identifier of VeildagVeilgroepTellingReport
     * @param if_Match (optional) ETag
     * @return Success
     */
    veilgroepTellingen_VeildagVeilgroepTellingReport_DeleteVeildagVeilgroepTellingReport(vestigingCode: number, if_Match: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/VeilgroepTellingen({vestigingCode})";
        if (vestigingCode === undefined || vestigingCode === null)
            throw new Error("The parameter 'vestigingCode' must be defined.");
        url_ = url_.replace("{vestigingCode}", encodeURIComponent("" + vestigingCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "If-Match": if_Match !== undefined && if_Match !== null ? "" + if_Match : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepTellingen_VeildagVeilgroepTellingReport_DeleteVeildagVeilgroepTellingReport(_response));
        });
    }

    protected processVeilgroepTellingen_VeildagVeilgroepTellingReport_DeleteVeildagVeilgroepTellingReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get the number of the resource
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @return The count of the resource
     */
    veilgroepTellingen_GetCount5f59(search: string | undefined, filter: string | undefined): Promise<number> {
        let url_ = this.baseUrl + "/VeilgroepTellingen/$count?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepTellingen_GetCount5f59(_response));
        });
    }

    protected processVeilgroepTellingen_GetCount5f59(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function GetPerVeildatumKlokrange
     * @param veilDatum Usage: veilDatum={veilDatum}
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param klokNummerVan Usage: klokNummerVan={klokNummerVan}
     * @param klokNummerTotEnMet Usage: klokNummerTotEnMet={klokNummerTotEnMet}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    veilgroepTellingen_GetPerVeildatumKlokrange(veilDatum: Date, vestigingCode: number | null, klokNummerVan: number, klokNummerTotEnMet: number, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous28> {
        let url_ = this.baseUrl + "/VeilgroepTellingen/AanbodBeheerService.GetPerVeildatumKlokrange(veilDatum={veilDatum},vestigingCode={vestigingCode},klokNummerVan={klokNummerVan},klokNummerTotEnMet={klokNummerTotEnMet})?";
        if (veilDatum === undefined || veilDatum === null)
            throw new Error("The parameter 'veilDatum' must be defined.");
        url_ = url_.replace("{veilDatum}", encodeURIComponent(veilDatum ? "" + veilDatum.toISOString() : "null"));
        if (vestigingCode === undefined || vestigingCode === null)
            throw new Error("The parameter 'vestigingCode' must be defined.");
        url_ = url_.replace("{vestigingCode}", encodeURIComponent("" + vestigingCode));
        if (klokNummerVan === undefined || klokNummerVan === null)
            throw new Error("The parameter 'klokNummerVan' must be defined.");
        url_ = url_.replace("{klokNummerVan}", encodeURIComponent("" + klokNummerVan));
        if (klokNummerTotEnMet === undefined || klokNummerTotEnMet === null)
            throw new Error("The parameter 'klokNummerTotEnMet' must be defined.");
        url_ = url_.replace("{klokNummerTotEnMet}", encodeURIComponent("" + klokNummerTotEnMet));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepTellingen_GetPerVeildatumKlokrange(_response));
        });
    }

    protected processVeilgroepTellingen_GetPerVeildatumKlokrange(response: Response): Promise<Anonymous28> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous28.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Invoke function GetPerVeildatumVestiging
     * @param veilDatum Usage: veilDatum={veilDatum}
     * @param vestigingCode Usage: vestigingCode={vestigingCode}
     * @param top (optional) Show only the first n items
     * @param skip (optional) Skip the first n items
     * @param search (optional) Search items by search phrases
     * @param filter (optional) Filter items by property values
     * @param count (optional) Include count of items
     * @param select (optional) Select properties to be returned
     * @param orderby (optional) Order items by property values
     * @param expand (optional) Expand related entities
     * @return Success
     */
    veilgroepTellingen_GetPerVeildatumVestiging(veilDatum: Date, vestigingCode: number | null, top: number | undefined, skip: number | undefined, search: string | undefined, filter: string | undefined, count: boolean | undefined, select: string[] | undefined, orderby: string[] | undefined, expand: string[] | undefined): Promise<Anonymous29> {
        let url_ = this.baseUrl + "/VeilgroepTellingen/AanbodBeheerService.GetPerVeildatumVestiging(veilDatum={veilDatum},vestigingCode={vestigingCode})?";
        if (veilDatum === undefined || veilDatum === null)
            throw new Error("The parameter 'veilDatum' must be defined.");
        url_ = url_.replace("{veilDatum}", encodeURIComponent(veilDatum ? "" + veilDatum.toISOString() : "null"));
        if (vestigingCode === undefined || vestigingCode === null)
            throw new Error("The parameter 'vestigingCode' must be defined.");
        url_ = url_.replace("{vestigingCode}", encodeURIComponent("" + vestigingCode));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            select && select.forEach(item => { url_ += "$select=" + encodeURIComponent("" + item) + "&"; });
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            orderby && orderby.forEach(item => { url_ += "$orderby=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            expand && expand.forEach(item => { url_ += "$expand=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVeilgroepTellingen_GetPerVeildatumVestiging(_response));
        });
    }

    protected processVeilgroepTellingen_GetPerVeildatumVestiging(response: Response): Promise<Anonymous29> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous29.fromJS(resultData200);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ODataError.fromJS(resultDatadefault);
            return throwException("error", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export class Feature implements IFeature {
    key?: string;
    description?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: IFeature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): Feature {
        data = typeof data === 'object' ? data : {};
        let result = new Feature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        return data;
    }

    clone(): Feature {
        const json = this.toJSON();
        let result = new Feature();
        result.init(json);
        return result;
    }
}

export interface IFeature {
    key?: string;
    description?: string | undefined;
    isEnabled?: boolean;
}

export class Aanvoerder implements IAanvoerder {
    aanvoerderNummer?: number;
    aanvoerderNaam?: string | undefined;

    constructor(data?: IAanvoerder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aanvoerderNummer = _data["aanvoerderNummer"];
            this.aanvoerderNaam = _data["aanvoerderNaam"];
        }
    }

    static fromJS(data: any): Aanvoerder {
        data = typeof data === 'object' ? data : {};
        let result = new Aanvoerder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aanvoerderNummer"] = this.aanvoerderNummer;
        data["aanvoerderNaam"] = this.aanvoerderNaam;
        return data;
    }

    clone(): Aanvoerder {
        const json = this.toJSON();
        let result = new Aanvoerder();
        result.init(json);
        return result;
    }
}

export interface IAanvoerder {
    aanvoerderNummer?: number;
    aanvoerderNaam?: string | undefined;
}

export class Aanvoerdercluster implements IAanvoerdercluster {
    aanvoerderclusterID?: number;
    aanvoerderclusterNummer?: number;
    aanvoerderclusterOmschrijving?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;

    constructor(data?: IAanvoerdercluster) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aanvoerderclusterID = _data["aanvoerderclusterID"];
            this.aanvoerderclusterNummer = _data["aanvoerderclusterNummer"];
            this.aanvoerderclusterOmschrijving = _data["aanvoerderclusterOmschrijving"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
        }
    }

    static fromJS(data: any): Aanvoerdercluster {
        data = typeof data === 'object' ? data : {};
        let result = new Aanvoerdercluster();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aanvoerderclusterID"] = this.aanvoerderclusterID;
        data["aanvoerderclusterNummer"] = this.aanvoerderclusterNummer;
        data["aanvoerderclusterOmschrijving"] = this.aanvoerderclusterOmschrijving;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        return data;
    }

    clone(): Aanvoerdercluster {
        const json = this.toJSON();
        let result = new Aanvoerdercluster();
        result.init(json);
        return result;
    }
}

export interface IAanvoerdercluster {
    aanvoerderclusterID?: number;
    aanvoerderclusterNummer?: number;
    aanvoerderclusterOmschrijving?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
}

export class AanvoerderclusterAanvoerder implements IAanvoerderclusterAanvoerder {
    aanvoerderclusterAanvoerderId?: number;
    aanvoerderclusterID?: number;
    aanvoerderNummer?: number;
    aanvoerderNaam?: string | undefined;
    aanvoerderKlokNaam?: string | undefined;
    volgordeNummer?: number | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;

    constructor(data?: IAanvoerderclusterAanvoerder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aanvoerderclusterAanvoerderId = _data["aanvoerderclusterAanvoerderId"];
            this.aanvoerderclusterID = _data["aanvoerderclusterID"];
            this.aanvoerderNummer = _data["aanvoerderNummer"];
            this.aanvoerderNaam = _data["aanvoerderNaam"];
            this.aanvoerderKlokNaam = _data["aanvoerderKlokNaam"];
            this.volgordeNummer = _data["volgordeNummer"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
        }
    }

    static fromJS(data: any): AanvoerderclusterAanvoerder {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderclusterAanvoerder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aanvoerderclusterAanvoerderId"] = this.aanvoerderclusterAanvoerderId;
        data["aanvoerderclusterID"] = this.aanvoerderclusterID;
        data["aanvoerderNummer"] = this.aanvoerderNummer;
        data["aanvoerderNaam"] = this.aanvoerderNaam;
        data["aanvoerderKlokNaam"] = this.aanvoerderKlokNaam;
        data["volgordeNummer"] = this.volgordeNummer;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        return data;
    }

    clone(): AanvoerderclusterAanvoerder {
        const json = this.toJSON();
        let result = new AanvoerderclusterAanvoerder();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderclusterAanvoerder {
    aanvoerderclusterAanvoerderId?: number;
    aanvoerderclusterID?: number;
    aanvoerderNummer?: number;
    aanvoerderNaam?: string | undefined;
    aanvoerderKlokNaam?: string | undefined;
    volgordeNummer?: number | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
}

export class AanvoerderclusterView implements IAanvoerderclusterView {
    aanvoerderclusterID?: number;
    aanvoerderclusterNummer?: number;
    aanvoerderclusterOmschrijving?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    aanvoerderclusterAanvoerders?: AanvoerderclusterAanvoerder[];

    constructor(data?: IAanvoerderclusterView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aanvoerderclusterID = _data["aanvoerderclusterID"];
            this.aanvoerderclusterNummer = _data["aanvoerderclusterNummer"];
            this.aanvoerderclusterOmschrijving = _data["aanvoerderclusterOmschrijving"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
            if (Array.isArray(_data["aanvoerderclusterAanvoerders"])) {
                this.aanvoerderclusterAanvoerders = [] as any;
                for (let item of _data["aanvoerderclusterAanvoerders"])
                    this.aanvoerderclusterAanvoerders!.push(AanvoerderclusterAanvoerder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AanvoerderclusterView {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderclusterView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aanvoerderclusterID"] = this.aanvoerderclusterID;
        data["aanvoerderclusterNummer"] = this.aanvoerderclusterNummer;
        data["aanvoerderclusterOmschrijving"] = this.aanvoerderclusterOmschrijving;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        if (Array.isArray(this.aanvoerderclusterAanvoerders)) {
            data["aanvoerderclusterAanvoerders"] = [];
            for (let item of this.aanvoerderclusterAanvoerders)
                data["aanvoerderclusterAanvoerders"].push(item.toJSON());
        }
        return data;
    }

    clone(): AanvoerderclusterView {
        const json = this.toJSON();
        let result = new AanvoerderclusterView();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderclusterView {
    aanvoerderclusterID?: number;
    aanvoerderclusterNummer?: number;
    aanvoerderclusterOmschrijving?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    aanvoerderclusterAanvoerders?: AanvoerderclusterAanvoerder[];
}

export class AanvoerderOnregelmatig implements IAanvoerderOnregelmatig {
    aanvoerderOnregelmatigId?: number;
    aanvoerderNummer?: number;
    aanvoerderNaam?: string | undefined;
    aanvoerderKlokNaam?: string | undefined;
    vestigingCode?: number;
    vestigingNaam?: string | undefined;

    constructor(data?: IAanvoerderOnregelmatig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aanvoerderOnregelmatigId = _data["aanvoerderOnregelmatigId"];
            this.aanvoerderNummer = _data["aanvoerderNummer"];
            this.aanvoerderNaam = _data["aanvoerderNaam"];
            this.aanvoerderKlokNaam = _data["aanvoerderKlokNaam"];
            this.vestigingCode = _data["vestigingCode"];
            this.vestigingNaam = _data["vestigingNaam"];
        }
    }

    static fromJS(data: any): AanvoerderOnregelmatig {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderOnregelmatig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aanvoerderOnregelmatigId"] = this.aanvoerderOnregelmatigId;
        data["aanvoerderNummer"] = this.aanvoerderNummer;
        data["aanvoerderNaam"] = this.aanvoerderNaam;
        data["aanvoerderKlokNaam"] = this.aanvoerderKlokNaam;
        data["vestigingCode"] = this.vestigingCode;
        data["vestigingNaam"] = this.vestigingNaam;
        return data;
    }

    clone(): AanvoerderOnregelmatig {
        const json = this.toJSON();
        let result = new AanvoerderOnregelmatig();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderOnregelmatig {
    aanvoerderOnregelmatigId?: number;
    aanvoerderNummer?: number;
    aanvoerderNaam?: string | undefined;
    aanvoerderKlokNaam?: string | undefined;
    vestigingCode?: number;
    vestigingNaam?: string | undefined;
}

export class AanvoerderProductgroepRegelmatig implements IAanvoerderProductgroepRegelmatig {
    aanvoerderProductgroepRegelmatigId?: number;
    datumEindeWeek?: Date;
    vestigingCode?: number;
    aanvoerderNummer?: number;
    productgroepCode?: number;
    aantalDagenGeveild?: number;
    aantalDagenGeveildWeek?: number;
    aantalWekenLimiet?: number;
    regelmatig?: boolean;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    aantalWekenUitzondering?: number | undefined;
    aantalDagenUitzondering?: number;
    aantalDagenUitzonderingWeek?: number;
    vestigingNaam?: Vestiging;

    constructor(data?: IAanvoerderProductgroepRegelmatig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aanvoerderProductgroepRegelmatigId = _data["aanvoerderProductgroepRegelmatigId"];
            this.datumEindeWeek = _data["datumEindeWeek"] ? new Date(_data["datumEindeWeek"].toString()) : <any>undefined;
            this.vestigingCode = _data["vestigingCode"];
            this.aanvoerderNummer = _data["aanvoerderNummer"];
            this.productgroepCode = _data["productgroepCode"];
            this.aantalDagenGeveild = _data["aantalDagenGeveild"];
            this.aantalDagenGeveildWeek = _data["aantalDagenGeveildWeek"];
            this.aantalWekenLimiet = _data["aantalWekenLimiet"];
            this.regelmatig = _data["regelmatig"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
            this.aantalWekenUitzondering = _data["aantalWekenUitzondering"];
            this.aantalDagenUitzondering = _data["aantalDagenUitzondering"];
            this.aantalDagenUitzonderingWeek = _data["aantalDagenUitzonderingWeek"];
            this.vestigingNaam = _data["vestigingNaam"];
        }
    }

    static fromJS(data: any): AanvoerderProductgroepRegelmatig {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductgroepRegelmatig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aanvoerderProductgroepRegelmatigId"] = this.aanvoerderProductgroepRegelmatigId;
        data["datumEindeWeek"] = this.datumEindeWeek ? this.datumEindeWeek.toISOString() : <any>undefined;
        data["vestigingCode"] = this.vestigingCode;
        data["aanvoerderNummer"] = this.aanvoerderNummer;
        data["productgroepCode"] = this.productgroepCode;
        data["aantalDagenGeveild"] = this.aantalDagenGeveild;
        data["aantalDagenGeveildWeek"] = this.aantalDagenGeveildWeek;
        data["aantalWekenLimiet"] = this.aantalWekenLimiet;
        data["regelmatig"] = this.regelmatig;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        data["aantalWekenUitzondering"] = this.aantalWekenUitzondering;
        data["aantalDagenUitzondering"] = this.aantalDagenUitzondering;
        data["aantalDagenUitzonderingWeek"] = this.aantalDagenUitzonderingWeek;
        data["vestigingNaam"] = this.vestigingNaam;
        return data;
    }

    clone(): AanvoerderProductgroepRegelmatig {
        const json = this.toJSON();
        let result = new AanvoerderProductgroepRegelmatig();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductgroepRegelmatig {
    aanvoerderProductgroepRegelmatigId?: number;
    datumEindeWeek?: Date;
    vestigingCode?: number;
    aanvoerderNummer?: number;
    productgroepCode?: number;
    aantalDagenGeveild?: number;
    aantalDagenGeveildWeek?: number;
    aantalWekenLimiet?: number;
    regelmatig?: boolean;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    aantalWekenUitzondering?: number | undefined;
    aantalDagenUitzondering?: number;
    aantalDagenUitzonderingWeek?: number;
    vestigingNaam?: Vestiging;
}

export class AanvoerderProductgroepRegelmatigUitzondering implements IAanvoerderProductgroepRegelmatigUitzondering {
    aanvoerderProductgroepRegelmatigUitzonderingId?: number;
    vestigingCode?: number;
    aanvoerderNummer?: number;
    productgroepCode?: number;
    uitzonderingDatumVanaf?: Date;
    uitzonderingDatumTtm?: Date;
    uitzonderingRedenCode?: number;
    uitzonderingRedenTekst?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    mutatieOmschrijving?: string | undefined;

    constructor(data?: IAanvoerderProductgroepRegelmatigUitzondering) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aanvoerderProductgroepRegelmatigUitzonderingId = _data["aanvoerderProductgroepRegelmatigUitzonderingId"];
            this.vestigingCode = _data["vestigingCode"];
            this.aanvoerderNummer = _data["aanvoerderNummer"];
            this.productgroepCode = _data["productgroepCode"];
            this.uitzonderingDatumVanaf = _data["uitzonderingDatumVanaf"] ? new Date(_data["uitzonderingDatumVanaf"].toString()) : <any>undefined;
            this.uitzonderingDatumTtm = _data["uitzonderingDatumTtm"] ? new Date(_data["uitzonderingDatumTtm"].toString()) : <any>undefined;
            this.uitzonderingRedenCode = _data["uitzonderingRedenCode"];
            this.uitzonderingRedenTekst = _data["uitzonderingRedenTekst"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
            this.mutatieOmschrijving = _data["mutatieOmschrijving"];
        }
    }

    static fromJS(data: any): AanvoerderProductgroepRegelmatigUitzondering {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductgroepRegelmatigUitzondering();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aanvoerderProductgroepRegelmatigUitzonderingId"] = this.aanvoerderProductgroepRegelmatigUitzonderingId;
        data["vestigingCode"] = this.vestigingCode;
        data["aanvoerderNummer"] = this.aanvoerderNummer;
        data["productgroepCode"] = this.productgroepCode;
        data["uitzonderingDatumVanaf"] = this.uitzonderingDatumVanaf ? this.uitzonderingDatumVanaf.toISOString() : <any>undefined;
        data["uitzonderingDatumTtm"] = this.uitzonderingDatumTtm ? this.uitzonderingDatumTtm.toISOString() : <any>undefined;
        data["uitzonderingRedenCode"] = this.uitzonderingRedenCode;
        data["uitzonderingRedenTekst"] = this.uitzonderingRedenTekst;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        data["mutatieOmschrijving"] = this.mutatieOmschrijving;
        return data;
    }

    clone(): AanvoerderProductgroepRegelmatigUitzondering {
        const json = this.toJSON();
        let result = new AanvoerderProductgroepRegelmatigUitzondering();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductgroepRegelmatigUitzondering {
    aanvoerderProductgroepRegelmatigUitzonderingId?: number;
    vestigingCode?: number;
    aanvoerderNummer?: number;
    productgroepCode?: number;
    uitzonderingDatumVanaf?: Date;
    uitzonderingDatumTtm?: Date;
    uitzonderingRedenCode?: number;
    uitzonderingRedenTekst?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    mutatieOmschrijving?: string | undefined;
}

export class AanvoerderProductgroepRegelmatigUitzonderingView implements IAanvoerderProductgroepRegelmatigUitzonderingView {
    aanvoerderProductgroepRegelmatigUitzonderingId?: number;
    vestigingCode?: number;
    vestigingNaam?: Vestiging;
    aanvoerderNummer?: number;
    aanvoerderNaam?: string | undefined;
    productgroepCode?: number;
    productgroepNaam?: string | undefined;
    uitzonderingDatumVanaf?: Date;
    uitzonderingDatumTtm?: Date;
    uitzonderingRedenCode?: number;
    uitzonderingRedenOmschrijving?: string | undefined;
    uitzonderingRedenTekst?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    mutatieOmschrijving?: string | undefined;

    constructor(data?: IAanvoerderProductgroepRegelmatigUitzonderingView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aanvoerderProductgroepRegelmatigUitzonderingId = _data["aanvoerderProductgroepRegelmatigUitzonderingId"];
            this.vestigingCode = _data["vestigingCode"];
            this.vestigingNaam = _data["vestigingNaam"];
            this.aanvoerderNummer = _data["aanvoerderNummer"];
            this.aanvoerderNaam = _data["aanvoerderNaam"];
            this.productgroepCode = _data["productgroepCode"];
            this.productgroepNaam = _data["productgroepNaam"];
            this.uitzonderingDatumVanaf = _data["uitzonderingDatumVanaf"] ? new Date(_data["uitzonderingDatumVanaf"].toString()) : <any>undefined;
            this.uitzonderingDatumTtm = _data["uitzonderingDatumTtm"] ? new Date(_data["uitzonderingDatumTtm"].toString()) : <any>undefined;
            this.uitzonderingRedenCode = _data["uitzonderingRedenCode"];
            this.uitzonderingRedenOmschrijving = _data["uitzonderingRedenOmschrijving"];
            this.uitzonderingRedenTekst = _data["uitzonderingRedenTekst"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
            this.mutatieOmschrijving = _data["mutatieOmschrijving"];
        }
    }

    static fromJS(data: any): AanvoerderProductgroepRegelmatigUitzonderingView {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductgroepRegelmatigUitzonderingView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aanvoerderProductgroepRegelmatigUitzonderingId"] = this.aanvoerderProductgroepRegelmatigUitzonderingId;
        data["vestigingCode"] = this.vestigingCode;
        data["vestigingNaam"] = this.vestigingNaam;
        data["aanvoerderNummer"] = this.aanvoerderNummer;
        data["aanvoerderNaam"] = this.aanvoerderNaam;
        data["productgroepCode"] = this.productgroepCode;
        data["productgroepNaam"] = this.productgroepNaam;
        data["uitzonderingDatumVanaf"] = this.uitzonderingDatumVanaf ? this.uitzonderingDatumVanaf.toISOString() : <any>undefined;
        data["uitzonderingDatumTtm"] = this.uitzonderingDatumTtm ? this.uitzonderingDatumTtm.toISOString() : <any>undefined;
        data["uitzonderingRedenCode"] = this.uitzonderingRedenCode;
        data["uitzonderingRedenOmschrijving"] = this.uitzonderingRedenOmschrijving;
        data["uitzonderingRedenTekst"] = this.uitzonderingRedenTekst;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        data["mutatieOmschrijving"] = this.mutatieOmschrijving;
        return data;
    }

    clone(): AanvoerderProductgroepRegelmatigUitzonderingView {
        const json = this.toJSON();
        let result = new AanvoerderProductgroepRegelmatigUitzonderingView();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductgroepRegelmatigUitzonderingView {
    aanvoerderProductgroepRegelmatigUitzonderingId?: number;
    vestigingCode?: number;
    vestigingNaam?: Vestiging;
    aanvoerderNummer?: number;
    aanvoerderNaam?: string | undefined;
    productgroepCode?: number;
    productgroepNaam?: string | undefined;
    uitzonderingDatumVanaf?: Date;
    uitzonderingDatumTtm?: Date;
    uitzonderingRedenCode?: number;
    uitzonderingRedenOmschrijving?: string | undefined;
    uitzonderingRedenTekst?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    mutatieOmschrijving?: string | undefined;
}

export class AanvoerderProductgroepRegelmatigView implements IAanvoerderProductgroepRegelmatigView {
    aanvoerderProductgroepRegelmatigId?: number;
    datumEindeWeek?: Date;
    vestigingCode?: number;
    aanvoerderNummer?: number;
    productgroepCode?: number;
    aantalDagenGeveild?: number;
    aantalDagenGeveildWeek?: number;
    aantalWekenLimiet?: number;
    regelmatig?: boolean;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    aantalWekenUitzondering?: number | undefined;
    aantalDagenUitzondering?: number;
    aantalDagenUitzonderingWeek?: number;
    productgroepNaam?: string | undefined;
    aanvoerderNaam?: string | undefined;
    uitzonderingRedenOmschrijving?: string | undefined;
    uitzonderingRedenTekst?: string | undefined;
    vestigingNaam?: Vestiging;

    constructor(data?: IAanvoerderProductgroepRegelmatigView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aanvoerderProductgroepRegelmatigId = _data["aanvoerderProductgroepRegelmatigId"];
            this.datumEindeWeek = _data["datumEindeWeek"] ? new Date(_data["datumEindeWeek"].toString()) : <any>undefined;
            this.vestigingCode = _data["vestigingCode"];
            this.aanvoerderNummer = _data["aanvoerderNummer"];
            this.productgroepCode = _data["productgroepCode"];
            this.aantalDagenGeveild = _data["aantalDagenGeveild"];
            this.aantalDagenGeveildWeek = _data["aantalDagenGeveildWeek"];
            this.aantalWekenLimiet = _data["aantalWekenLimiet"];
            this.regelmatig = _data["regelmatig"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
            this.aantalWekenUitzondering = _data["aantalWekenUitzondering"];
            this.aantalDagenUitzondering = _data["aantalDagenUitzondering"];
            this.aantalDagenUitzonderingWeek = _data["aantalDagenUitzonderingWeek"];
            this.productgroepNaam = _data["productgroepNaam"];
            this.aanvoerderNaam = _data["aanvoerderNaam"];
            this.uitzonderingRedenOmschrijving = _data["uitzonderingRedenOmschrijving"];
            this.uitzonderingRedenTekst = _data["uitzonderingRedenTekst"];
            this.vestigingNaam = _data["vestigingNaam"];
        }
    }

    static fromJS(data: any): AanvoerderProductgroepRegelmatigView {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductgroepRegelmatigView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aanvoerderProductgroepRegelmatigId"] = this.aanvoerderProductgroepRegelmatigId;
        data["datumEindeWeek"] = this.datumEindeWeek ? this.datumEindeWeek.toISOString() : <any>undefined;
        data["vestigingCode"] = this.vestigingCode;
        data["aanvoerderNummer"] = this.aanvoerderNummer;
        data["productgroepCode"] = this.productgroepCode;
        data["aantalDagenGeveild"] = this.aantalDagenGeveild;
        data["aantalDagenGeveildWeek"] = this.aantalDagenGeveildWeek;
        data["aantalWekenLimiet"] = this.aantalWekenLimiet;
        data["regelmatig"] = this.regelmatig;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        data["aantalWekenUitzondering"] = this.aantalWekenUitzondering;
        data["aantalDagenUitzondering"] = this.aantalDagenUitzondering;
        data["aantalDagenUitzonderingWeek"] = this.aantalDagenUitzonderingWeek;
        data["productgroepNaam"] = this.productgroepNaam;
        data["aanvoerderNaam"] = this.aanvoerderNaam;
        data["uitzonderingRedenOmschrijving"] = this.uitzonderingRedenOmschrijving;
        data["uitzonderingRedenTekst"] = this.uitzonderingRedenTekst;
        data["vestigingNaam"] = this.vestigingNaam;
        return data;
    }

    clone(): AanvoerderProductgroepRegelmatigView {
        const json = this.toJSON();
        let result = new AanvoerderProductgroepRegelmatigView();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductgroepRegelmatigView {
    aanvoerderProductgroepRegelmatigId?: number;
    datumEindeWeek?: Date;
    vestigingCode?: number;
    aanvoerderNummer?: number;
    productgroepCode?: number;
    aantalDagenGeveild?: number;
    aantalDagenGeveildWeek?: number;
    aantalWekenLimiet?: number;
    regelmatig?: boolean;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    aantalWekenUitzondering?: number | undefined;
    aantalDagenUitzondering?: number;
    aantalDagenUitzonderingWeek?: number;
    productgroepNaam?: string | undefined;
    aanvoerderNaam?: string | undefined;
    uitzonderingRedenOmschrijving?: string | undefined;
    uitzonderingRedenTekst?: string | undefined;
    vestigingNaam?: Vestiging;
}

export class AanvoerderProductRegelmatig implements IAanvoerderProductRegelmatig {
    aanvoerderProductRegelmatigId?: number;
    datumEindeWeek?: Date;
    vestigingCode?: number;
    aanvoerderNummer?: number;
    productCode?: number;
    aantalDagenGeveild?: number;
    aantalDagenGeveildWeek?: number;
    aantalWekenLimiet?: number;
    regelmatig?: boolean;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    aantalWekenUitzondering?: number | undefined;
    vestigingNaam?: Vestiging;

    constructor(data?: IAanvoerderProductRegelmatig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aanvoerderProductRegelmatigId = _data["aanvoerderProductRegelmatigId"];
            this.datumEindeWeek = _data["datumEindeWeek"] ? new Date(_data["datumEindeWeek"].toString()) : <any>undefined;
            this.vestigingCode = _data["vestigingCode"];
            this.aanvoerderNummer = _data["aanvoerderNummer"];
            this.productCode = _data["productCode"];
            this.aantalDagenGeveild = _data["aantalDagenGeveild"];
            this.aantalDagenGeveildWeek = _data["aantalDagenGeveildWeek"];
            this.aantalWekenLimiet = _data["aantalWekenLimiet"];
            this.regelmatig = _data["regelmatig"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
            this.aantalWekenUitzondering = _data["aantalWekenUitzondering"];
            this.vestigingNaam = _data["vestigingNaam"];
        }
    }

    static fromJS(data: any): AanvoerderProductRegelmatig {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductRegelmatig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aanvoerderProductRegelmatigId"] = this.aanvoerderProductRegelmatigId;
        data["datumEindeWeek"] = this.datumEindeWeek ? this.datumEindeWeek.toISOString() : <any>undefined;
        data["vestigingCode"] = this.vestigingCode;
        data["aanvoerderNummer"] = this.aanvoerderNummer;
        data["productCode"] = this.productCode;
        data["aantalDagenGeveild"] = this.aantalDagenGeveild;
        data["aantalDagenGeveildWeek"] = this.aantalDagenGeveildWeek;
        data["aantalWekenLimiet"] = this.aantalWekenLimiet;
        data["regelmatig"] = this.regelmatig;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        data["aantalWekenUitzondering"] = this.aantalWekenUitzondering;
        data["vestigingNaam"] = this.vestigingNaam;
        return data;
    }

    clone(): AanvoerderProductRegelmatig {
        const json = this.toJSON();
        let result = new AanvoerderProductRegelmatig();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductRegelmatig {
    aanvoerderProductRegelmatigId?: number;
    datumEindeWeek?: Date;
    vestigingCode?: number;
    aanvoerderNummer?: number;
    productCode?: number;
    aantalDagenGeveild?: number;
    aantalDagenGeveildWeek?: number;
    aantalWekenLimiet?: number;
    regelmatig?: boolean;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    aantalWekenUitzondering?: number | undefined;
    vestigingNaam?: Vestiging;
}

export class AanvoerderProductRegelmatigUitzondering implements IAanvoerderProductRegelmatigUitzondering {
    aanvoerderProductRegelmatigUitzonderingId?: number;
    vestigingCode?: number;
    aanvoerderNummer?: number;
    productCode?: number;
    uitzonderingDatumVanaf?: Date;
    uitzonderingDatumTtm?: Date;
    uitzonderingRedenCode?: number;
    uitzonderingRedenTekst?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    mutatieOmschrijving?: string | undefined;

    constructor(data?: IAanvoerderProductRegelmatigUitzondering) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aanvoerderProductRegelmatigUitzonderingId = _data["aanvoerderProductRegelmatigUitzonderingId"];
            this.vestigingCode = _data["vestigingCode"];
            this.aanvoerderNummer = _data["aanvoerderNummer"];
            this.productCode = _data["productCode"];
            this.uitzonderingDatumVanaf = _data["uitzonderingDatumVanaf"] ? new Date(_data["uitzonderingDatumVanaf"].toString()) : <any>undefined;
            this.uitzonderingDatumTtm = _data["uitzonderingDatumTtm"] ? new Date(_data["uitzonderingDatumTtm"].toString()) : <any>undefined;
            this.uitzonderingRedenCode = _data["uitzonderingRedenCode"];
            this.uitzonderingRedenTekst = _data["uitzonderingRedenTekst"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
            this.mutatieOmschrijving = _data["mutatieOmschrijving"];
        }
    }

    static fromJS(data: any): AanvoerderProductRegelmatigUitzondering {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductRegelmatigUitzondering();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aanvoerderProductRegelmatigUitzonderingId"] = this.aanvoerderProductRegelmatigUitzonderingId;
        data["vestigingCode"] = this.vestigingCode;
        data["aanvoerderNummer"] = this.aanvoerderNummer;
        data["productCode"] = this.productCode;
        data["uitzonderingDatumVanaf"] = this.uitzonderingDatumVanaf ? this.uitzonderingDatumVanaf.toISOString() : <any>undefined;
        data["uitzonderingDatumTtm"] = this.uitzonderingDatumTtm ? this.uitzonderingDatumTtm.toISOString() : <any>undefined;
        data["uitzonderingRedenCode"] = this.uitzonderingRedenCode;
        data["uitzonderingRedenTekst"] = this.uitzonderingRedenTekst;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        data["mutatieOmschrijving"] = this.mutatieOmschrijving;
        return data;
    }

    clone(): AanvoerderProductRegelmatigUitzondering {
        const json = this.toJSON();
        let result = new AanvoerderProductRegelmatigUitzondering();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductRegelmatigUitzondering {
    aanvoerderProductRegelmatigUitzonderingId?: number;
    vestigingCode?: number;
    aanvoerderNummer?: number;
    productCode?: number;
    uitzonderingDatumVanaf?: Date;
    uitzonderingDatumTtm?: Date;
    uitzonderingRedenCode?: number;
    uitzonderingRedenTekst?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    mutatieOmschrijving?: string | undefined;
}

export class AanvoerderProductRegelmatigUitzonderingView implements IAanvoerderProductRegelmatigUitzonderingView {
    aanvoerderProductRegelmatigUitzonderingId?: number;
    vestigingCode?: number;
    vestigingNaam?: Vestiging;
    aanvoerderNummer?: number;
    aanvoerderNaam?: string | undefined;
    productCode?: number;
    productNaam?: string | undefined;
    uitzonderingDatumVanaf?: Date;
    uitzonderingDatumTtm?: Date;
    uitzonderingRedenCode?: number;
    uitzonderingRedenOmschrijving?: string | undefined;
    uitzonderingRedenTekst?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    mutatieOmschrijving?: string | undefined;

    constructor(data?: IAanvoerderProductRegelmatigUitzonderingView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aanvoerderProductRegelmatigUitzonderingId = _data["aanvoerderProductRegelmatigUitzonderingId"];
            this.vestigingCode = _data["vestigingCode"];
            this.vestigingNaam = _data["vestigingNaam"];
            this.aanvoerderNummer = _data["aanvoerderNummer"];
            this.aanvoerderNaam = _data["aanvoerderNaam"];
            this.productCode = _data["productCode"];
            this.productNaam = _data["productNaam"];
            this.uitzonderingDatumVanaf = _data["uitzonderingDatumVanaf"] ? new Date(_data["uitzonderingDatumVanaf"].toString()) : <any>undefined;
            this.uitzonderingDatumTtm = _data["uitzonderingDatumTtm"] ? new Date(_data["uitzonderingDatumTtm"].toString()) : <any>undefined;
            this.uitzonderingRedenCode = _data["uitzonderingRedenCode"];
            this.uitzonderingRedenOmschrijving = _data["uitzonderingRedenOmschrijving"];
            this.uitzonderingRedenTekst = _data["uitzonderingRedenTekst"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
            this.mutatieOmschrijving = _data["mutatieOmschrijving"];
        }
    }

    static fromJS(data: any): AanvoerderProductRegelmatigUitzonderingView {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductRegelmatigUitzonderingView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aanvoerderProductRegelmatigUitzonderingId"] = this.aanvoerderProductRegelmatigUitzonderingId;
        data["vestigingCode"] = this.vestigingCode;
        data["vestigingNaam"] = this.vestigingNaam;
        data["aanvoerderNummer"] = this.aanvoerderNummer;
        data["aanvoerderNaam"] = this.aanvoerderNaam;
        data["productCode"] = this.productCode;
        data["productNaam"] = this.productNaam;
        data["uitzonderingDatumVanaf"] = this.uitzonderingDatumVanaf ? this.uitzonderingDatumVanaf.toISOString() : <any>undefined;
        data["uitzonderingDatumTtm"] = this.uitzonderingDatumTtm ? this.uitzonderingDatumTtm.toISOString() : <any>undefined;
        data["uitzonderingRedenCode"] = this.uitzonderingRedenCode;
        data["uitzonderingRedenOmschrijving"] = this.uitzonderingRedenOmschrijving;
        data["uitzonderingRedenTekst"] = this.uitzonderingRedenTekst;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        data["mutatieOmschrijving"] = this.mutatieOmschrijving;
        return data;
    }

    clone(): AanvoerderProductRegelmatigUitzonderingView {
        const json = this.toJSON();
        let result = new AanvoerderProductRegelmatigUitzonderingView();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductRegelmatigUitzonderingView {
    aanvoerderProductRegelmatigUitzonderingId?: number;
    vestigingCode?: number;
    vestigingNaam?: Vestiging;
    aanvoerderNummer?: number;
    aanvoerderNaam?: string | undefined;
    productCode?: number;
    productNaam?: string | undefined;
    uitzonderingDatumVanaf?: Date;
    uitzonderingDatumTtm?: Date;
    uitzonderingRedenCode?: number;
    uitzonderingRedenOmschrijving?: string | undefined;
    uitzonderingRedenTekst?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    mutatieOmschrijving?: string | undefined;
}

export class AanvoerderProductRegelmatigView implements IAanvoerderProductRegelmatigView {
    aanvoerderProductRegelmatigId?: number;
    datumEindeWeek?: Date;
    vestigingCode?: number;
    aanvoerderNummer?: number;
    productCode?: number;
    aantalDagenGeveild?: number;
    aantalDagenGeveildWeek?: number;
    aantalWekenLimiet?: number;
    regelmatig?: boolean;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    aantalWekenUitzondering?: number | undefined;
    productNaam?: string | undefined;
    aanvoerderNaam?: string | undefined;
    uitzonderingRedenOmschrijving?: string | undefined;
    uitzonderingRedenTekst?: string | undefined;
    vestigingNaam?: Vestiging;

    constructor(data?: IAanvoerderProductRegelmatigView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aanvoerderProductRegelmatigId = _data["aanvoerderProductRegelmatigId"];
            this.datumEindeWeek = _data["datumEindeWeek"] ? new Date(_data["datumEindeWeek"].toString()) : <any>undefined;
            this.vestigingCode = _data["vestigingCode"];
            this.aanvoerderNummer = _data["aanvoerderNummer"];
            this.productCode = _data["productCode"];
            this.aantalDagenGeveild = _data["aantalDagenGeveild"];
            this.aantalDagenGeveildWeek = _data["aantalDagenGeveildWeek"];
            this.aantalWekenLimiet = _data["aantalWekenLimiet"];
            this.regelmatig = _data["regelmatig"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
            this.aantalWekenUitzondering = _data["aantalWekenUitzondering"];
            this.productNaam = _data["productNaam"];
            this.aanvoerderNaam = _data["aanvoerderNaam"];
            this.uitzonderingRedenOmschrijving = _data["uitzonderingRedenOmschrijving"];
            this.uitzonderingRedenTekst = _data["uitzonderingRedenTekst"];
            this.vestigingNaam = _data["vestigingNaam"];
        }
    }

    static fromJS(data: any): AanvoerderProductRegelmatigView {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductRegelmatigView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aanvoerderProductRegelmatigId"] = this.aanvoerderProductRegelmatigId;
        data["datumEindeWeek"] = this.datumEindeWeek ? this.datumEindeWeek.toISOString() : <any>undefined;
        data["vestigingCode"] = this.vestigingCode;
        data["aanvoerderNummer"] = this.aanvoerderNummer;
        data["productCode"] = this.productCode;
        data["aantalDagenGeveild"] = this.aantalDagenGeveild;
        data["aantalDagenGeveildWeek"] = this.aantalDagenGeveildWeek;
        data["aantalWekenLimiet"] = this.aantalWekenLimiet;
        data["regelmatig"] = this.regelmatig;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        data["aantalWekenUitzondering"] = this.aantalWekenUitzondering;
        data["productNaam"] = this.productNaam;
        data["aanvoerderNaam"] = this.aanvoerderNaam;
        data["uitzonderingRedenOmschrijving"] = this.uitzonderingRedenOmschrijving;
        data["uitzonderingRedenTekst"] = this.uitzonderingRedenTekst;
        data["vestigingNaam"] = this.vestigingNaam;
        return data;
    }

    clone(): AanvoerderProductRegelmatigView {
        const json = this.toJSON();
        let result = new AanvoerderProductRegelmatigView();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductRegelmatigView {
    aanvoerderProductRegelmatigId?: number;
    datumEindeWeek?: Date;
    vestigingCode?: number;
    aanvoerderNummer?: number;
    productCode?: number;
    aantalDagenGeveild?: number;
    aantalDagenGeveildWeek?: number;
    aantalWekenLimiet?: number;
    regelmatig?: boolean;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    aantalWekenUitzondering?: number | undefined;
    productNaam?: string | undefined;
    aanvoerderNaam?: string | undefined;
    uitzonderingRedenOmschrijving?: string | undefined;
    uitzonderingRedenTekst?: string | undefined;
    vestigingNaam?: Vestiging;
}

export class AanvoerderPromotieKenmerk implements IAanvoerderPromotieKenmerk {
    aanvoerderPromotieKenmerkId?: number;
    aanvoerderNummer?: number;
    productCode?: number;
    kenmerkCode?: string | undefined;
    kenmerkWaarde?: string | undefined;
    kenmerkWaardeOmschrijving?: string | undefined;
    ingangsDatum?: Date;
    eindDatum?: Date;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;

    constructor(data?: IAanvoerderPromotieKenmerk) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aanvoerderPromotieKenmerkId = _data["aanvoerderPromotieKenmerkId"];
            this.aanvoerderNummer = _data["aanvoerderNummer"];
            this.productCode = _data["productCode"];
            this.kenmerkCode = _data["kenmerkCode"];
            this.kenmerkWaarde = _data["kenmerkWaarde"];
            this.kenmerkWaardeOmschrijving = _data["kenmerkWaardeOmschrijving"];
            this.ingangsDatum = _data["ingangsDatum"] ? new Date(_data["ingangsDatum"].toString()) : <any>undefined;
            this.eindDatum = _data["eindDatum"] ? new Date(_data["eindDatum"].toString()) : <any>undefined;
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
        }
    }

    static fromJS(data: any): AanvoerderPromotieKenmerk {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderPromotieKenmerk();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aanvoerderPromotieKenmerkId"] = this.aanvoerderPromotieKenmerkId;
        data["aanvoerderNummer"] = this.aanvoerderNummer;
        data["productCode"] = this.productCode;
        data["kenmerkCode"] = this.kenmerkCode;
        data["kenmerkWaarde"] = this.kenmerkWaarde;
        data["kenmerkWaardeOmschrijving"] = this.kenmerkWaardeOmschrijving;
        data["ingangsDatum"] = this.ingangsDatum ? this.ingangsDatum.toISOString() : <any>undefined;
        data["eindDatum"] = this.eindDatum ? this.eindDatum.toISOString() : <any>undefined;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        return data;
    }

    clone(): AanvoerderPromotieKenmerk {
        const json = this.toJSON();
        let result = new AanvoerderPromotieKenmerk();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderPromotieKenmerk {
    aanvoerderPromotieKenmerkId?: number;
    aanvoerderNummer?: number;
    productCode?: number;
    kenmerkCode?: string | undefined;
    kenmerkWaarde?: string | undefined;
    kenmerkWaardeOmschrijving?: string | undefined;
    ingangsDatum?: Date;
    eindDatum?: Date;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
}

export class Kenmerk implements IKenmerk {
    kenmerkCode?: string;
    kenmerkOmschrijving?: string | undefined;
    kenmerkGroepCode?: number;
    vasInd?: boolean;
    ingangDatum?: Date;
    eindDatum?: Date;

    constructor(data?: IKenmerk) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kenmerkCode = _data["kenmerkCode"];
            this.kenmerkOmschrijving = _data["kenmerkOmschrijving"];
            this.kenmerkGroepCode = _data["kenmerkGroepCode"];
            this.vasInd = _data["vasInd"];
            this.ingangDatum = _data["ingangDatum"] ? new Date(_data["ingangDatum"].toString()) : <any>undefined;
            this.eindDatum = _data["eindDatum"] ? new Date(_data["eindDatum"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Kenmerk {
        data = typeof data === 'object' ? data : {};
        let result = new Kenmerk();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kenmerkCode"] = this.kenmerkCode;
        data["kenmerkOmschrijving"] = this.kenmerkOmschrijving;
        data["kenmerkGroepCode"] = this.kenmerkGroepCode;
        data["vasInd"] = this.vasInd;
        data["ingangDatum"] = this.ingangDatum ? this.ingangDatum.toISOString() : <any>undefined;
        data["eindDatum"] = this.eindDatum ? this.eindDatum.toISOString() : <any>undefined;
        return data;
    }

    clone(): Kenmerk {
        const json = this.toJSON();
        let result = new Kenmerk();
        result.init(json);
        return result;
    }
}

export interface IKenmerk {
    kenmerkCode?: string;
    kenmerkOmschrijving?: string | undefined;
    kenmerkGroepCode?: number;
    vasInd?: boolean;
    ingangDatum?: Date;
    eindDatum?: Date;
}

export class KenmerkWaarde implements IKenmerkWaarde {
    refSysIdf?: number;
    kenmerkCode?: string | undefined;
    kenmerkWaardeCode?: string | undefined;
    kenmerkWaardeOmschrijving?: string | undefined;
    ingangDatum?: Date;
    eindDatum?: Date;

    constructor(data?: IKenmerkWaarde) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refSysIdf = _data["refSysIdf"];
            this.kenmerkCode = _data["kenmerkCode"];
            this.kenmerkWaardeCode = _data["kenmerkWaardeCode"];
            this.kenmerkWaardeOmschrijving = _data["kenmerkWaardeOmschrijving"];
            this.ingangDatum = _data["ingangDatum"] ? new Date(_data["ingangDatum"].toString()) : <any>undefined;
            this.eindDatum = _data["eindDatum"] ? new Date(_data["eindDatum"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): KenmerkWaarde {
        data = typeof data === 'object' ? data : {};
        let result = new KenmerkWaarde();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refSysIdf"] = this.refSysIdf;
        data["kenmerkCode"] = this.kenmerkCode;
        data["kenmerkWaardeCode"] = this.kenmerkWaardeCode;
        data["kenmerkWaardeOmschrijving"] = this.kenmerkWaardeOmschrijving;
        data["ingangDatum"] = this.ingangDatum ? this.ingangDatum.toISOString() : <any>undefined;
        data["eindDatum"] = this.eindDatum ? this.eindDatum.toISOString() : <any>undefined;
        return data;
    }

    clone(): KenmerkWaarde {
        const json = this.toJSON();
        let result = new KenmerkWaarde();
        result.init(json);
        return result;
    }
}

export interface IKenmerkWaarde {
    refSysIdf?: number;
    kenmerkCode?: string | undefined;
    kenmerkWaardeCode?: string | undefined;
    kenmerkWaardeOmschrijving?: string | undefined;
    ingangDatum?: Date;
    eindDatum?: Date;
}

export class PartijStatusReport implements IPartijStatusReport {
    partijStatusOmschrijving?: string | undefined;
    aantalBronHerkeur?: number;
    aantalBronEab?: number | undefined;
    aantalBronHandmatig?: number | undefined;
    aantalBronQrCode?: number | undefined;
    aantalBronArabicum?: number | undefined;
    aantalBronFloriday?: number | undefined;
    aantalKvvAangeboden?: number | undefined;
    aantalKvvTransacties?: number | undefined;

    constructor(data?: IPartijStatusReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partijStatusOmschrijving = _data["partijStatusOmschrijving"];
            this.aantalBronHerkeur = _data["aantalBronHerkeur"];
            this.aantalBronEab = _data["aantalBronEab"];
            this.aantalBronHandmatig = _data["aantalBronHandmatig"];
            this.aantalBronQrCode = _data["aantalBronQrCode"];
            this.aantalBronArabicum = _data["aantalBronArabicum"];
            this.aantalBronFloriday = _data["aantalBronFloriday"];
            this.aantalKvvAangeboden = _data["aantalKvvAangeboden"];
            this.aantalKvvTransacties = _data["aantalKvvTransacties"];
        }
    }

    static fromJS(data: any): PartijStatusReport {
        data = typeof data === 'object' ? data : {};
        let result = new PartijStatusReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partijStatusOmschrijving"] = this.partijStatusOmschrijving;
        data["aantalBronHerkeur"] = this.aantalBronHerkeur;
        data["aantalBronEab"] = this.aantalBronEab;
        data["aantalBronHandmatig"] = this.aantalBronHandmatig;
        data["aantalBronQrCode"] = this.aantalBronQrCode;
        data["aantalBronArabicum"] = this.aantalBronArabicum;
        data["aantalBronFloriday"] = this.aantalBronFloriday;
        data["aantalKvvAangeboden"] = this.aantalKvvAangeboden;
        data["aantalKvvTransacties"] = this.aantalKvvTransacties;
        return data;
    }

    clone(): PartijStatusReport {
        const json = this.toJSON();
        let result = new PartijStatusReport();
        result.init(json);
        return result;
    }
}

export interface IPartijStatusReport {
    partijStatusOmschrijving?: string | undefined;
    aantalBronHerkeur?: number;
    aantalBronEab?: number | undefined;
    aantalBronHandmatig?: number | undefined;
    aantalBronQrCode?: number | undefined;
    aantalBronArabicum?: number | undefined;
    aantalBronFloriday?: number | undefined;
    aantalKvvAangeboden?: number | undefined;
    aantalKvvTransacties?: number | undefined;
}

export class Product implements IProduct {
    productCode?: number;
    productNaam?: string | undefined;
    isVervallen?: boolean;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productNaam = _data["productNaam"];
            this.isVervallen = _data["isVervallen"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productNaam"] = this.productNaam;
        data["isVervallen"] = this.isVervallen;
        return data;
    }

    clone(): Product {
        const json = this.toJSON();
        let result = new Product();
        result.init(json);
        return result;
    }
}

export interface IProduct {
    productCode?: number;
    productNaam?: string | undefined;
    isVervallen?: boolean;
}

export class Productcluster implements IProductcluster {
    productclusterID?: number;
    productclusterOmschrijving?: string | undefined;
    bloemenPlantenCode?: string | undefined;
    eersteProductgroepen?: string | undefined;
    eersteVeilgroepen?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    veilgroepRegels?: VeilgroepRegel[];
    productclusterProductgroepen?: ProductclusterProductgroep[];

    constructor(data?: IProductcluster) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productclusterID = _data["productclusterID"];
            this.productclusterOmschrijving = _data["productclusterOmschrijving"];
            this.bloemenPlantenCode = _data["bloemenPlantenCode"];
            this.eersteProductgroepen = _data["eersteProductgroepen"];
            this.eersteVeilgroepen = _data["eersteVeilgroepen"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
            if (Array.isArray(_data["veilgroepRegels"])) {
                this.veilgroepRegels = [] as any;
                for (let item of _data["veilgroepRegels"])
                    this.veilgroepRegels!.push(VeilgroepRegel.fromJS(item));
            }
            if (Array.isArray(_data["productclusterProductgroepen"])) {
                this.productclusterProductgroepen = [] as any;
                for (let item of _data["productclusterProductgroepen"])
                    this.productclusterProductgroepen!.push(ProductclusterProductgroep.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Productcluster {
        data = typeof data === 'object' ? data : {};
        let result = new Productcluster();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productclusterID"] = this.productclusterID;
        data["productclusterOmschrijving"] = this.productclusterOmschrijving;
        data["bloemenPlantenCode"] = this.bloemenPlantenCode;
        data["eersteProductgroepen"] = this.eersteProductgroepen;
        data["eersteVeilgroepen"] = this.eersteVeilgroepen;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        if (Array.isArray(this.veilgroepRegels)) {
            data["veilgroepRegels"] = [];
            for (let item of this.veilgroepRegels)
                data["veilgroepRegels"].push(item.toJSON());
        }
        if (Array.isArray(this.productclusterProductgroepen)) {
            data["productclusterProductgroepen"] = [];
            for (let item of this.productclusterProductgroepen)
                data["productclusterProductgroepen"].push(item.toJSON());
        }
        return data;
    }

    clone(): Productcluster {
        const json = this.toJSON();
        let result = new Productcluster();
        result.init(json);
        return result;
    }
}

export interface IProductcluster {
    productclusterID?: number;
    productclusterOmschrijving?: string | undefined;
    bloemenPlantenCode?: string | undefined;
    eersteProductgroepen?: string | undefined;
    eersteVeilgroepen?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    veilgroepRegels?: VeilgroepRegel[];
    productclusterProductgroepen?: ProductclusterProductgroep[];
}

export class ProductclusterProductgroep implements IProductclusterProductgroep {
    productclusterProductgroepID?: number;
    productgroepCode?: number;
    productclusterID?: number | undefined;
    productgroepOmschrijving?: string | undefined;
    volgordeNummer?: number | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    productcluster?: Productcluster2;

    constructor(data?: IProductclusterProductgroep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productclusterProductgroepID = _data["productclusterProductgroepID"];
            this.productgroepCode = _data["productgroepCode"];
            this.productclusterID = _data["productclusterID"];
            this.productgroepOmschrijving = _data["productgroepOmschrijving"];
            this.volgordeNummer = _data["volgordeNummer"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
            this.productcluster = _data["productcluster"];
        }
    }

    static fromJS(data: any): ProductclusterProductgroep {
        data = typeof data === 'object' ? data : {};
        let result = new ProductclusterProductgroep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productclusterProductgroepID"] = this.productclusterProductgroepID;
        data["productgroepCode"] = this.productgroepCode;
        data["productclusterID"] = this.productclusterID;
        data["productgroepOmschrijving"] = this.productgroepOmschrijving;
        data["volgordeNummer"] = this.volgordeNummer;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        data["productcluster"] = this.productcluster;
        return data;
    }

    clone(): ProductclusterProductgroep {
        const json = this.toJSON();
        let result = new ProductclusterProductgroep();
        result.init(json);
        return result;
    }
}

export interface IProductclusterProductgroep {
    productclusterProductgroepID?: number;
    productgroepCode?: number;
    productclusterID?: number | undefined;
    productgroepOmschrijving?: string | undefined;
    volgordeNummer?: number | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    productcluster?: Productcluster2;
}

export class ProductclusterView implements IProductclusterView {
    productclusterID?: number;
    productclusterOmschrijving?: string | undefined;
    bloemenPlantenCode?: string | undefined;
    eersteProductgroepen?: string | undefined;
    eersteVeilgroepen?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    veilgroepRegels?: ProductclusterVeilgroepRegel[];
    productclusterProductgroepen?: ProductclusterProductgroep[];

    constructor(data?: IProductclusterView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productclusterID = _data["productclusterID"];
            this.productclusterOmschrijving = _data["productclusterOmschrijving"];
            this.bloemenPlantenCode = _data["bloemenPlantenCode"];
            this.eersteProductgroepen = _data["eersteProductgroepen"];
            this.eersteVeilgroepen = _data["eersteVeilgroepen"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
            if (Array.isArray(_data["veilgroepRegels"])) {
                this.veilgroepRegels = [] as any;
                for (let item of _data["veilgroepRegels"])
                    this.veilgroepRegels!.push(ProductclusterVeilgroepRegel.fromJS(item));
            }
            if (Array.isArray(_data["productclusterProductgroepen"])) {
                this.productclusterProductgroepen = [] as any;
                for (let item of _data["productclusterProductgroepen"])
                    this.productclusterProductgroepen!.push(ProductclusterProductgroep.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductclusterView {
        data = typeof data === 'object' ? data : {};
        let result = new ProductclusterView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productclusterID"] = this.productclusterID;
        data["productclusterOmschrijving"] = this.productclusterOmschrijving;
        data["bloemenPlantenCode"] = this.bloemenPlantenCode;
        data["eersteProductgroepen"] = this.eersteProductgroepen;
        data["eersteVeilgroepen"] = this.eersteVeilgroepen;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        if (Array.isArray(this.veilgroepRegels)) {
            data["veilgroepRegels"] = [];
            for (let item of this.veilgroepRegels)
                data["veilgroepRegels"].push(item.toJSON());
        }
        if (Array.isArray(this.productclusterProductgroepen)) {
            data["productclusterProductgroepen"] = [];
            for (let item of this.productclusterProductgroepen)
                data["productclusterProductgroepen"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductclusterView {
        const json = this.toJSON();
        let result = new ProductclusterView();
        result.init(json);
        return result;
    }
}

export interface IProductclusterView {
    productclusterID?: number;
    productclusterOmschrijving?: string | undefined;
    bloemenPlantenCode?: string | undefined;
    eersteProductgroepen?: string | undefined;
    eersteVeilgroepen?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    veilgroepRegels?: ProductclusterVeilgroepRegel[];
    productclusterProductgroepen?: ProductclusterProductgroep[];
}

export class Productgroep implements IProductgroep {
    productgroepCode?: number;
    productgroepNaam?: string | undefined;

    constructor(data?: IProductgroep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productgroepCode = _data["productgroepCode"];
            this.productgroepNaam = _data["productgroepNaam"];
        }
    }

    static fromJS(data: any): Productgroep {
        data = typeof data === 'object' ? data : {};
        let result = new Productgroep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productgroepCode"] = this.productgroepCode;
        data["productgroepNaam"] = this.productgroepNaam;
        return data;
    }

    clone(): Productgroep {
        const json = this.toJSON();
        let result = new Productgroep();
        result.init(json);
        return result;
    }
}

export interface IProductgroep {
    productgroepCode?: number;
    productgroepNaam?: string | undefined;
}

export class ProductVeilgroep implements IProductVeilgroep {
    productVeilgroepAisID?: number;
    veilgroepCode?: number;
    bloemenPlantenCode?: string | undefined;
    veilgroepOmschrijving?: string | undefined;
    vestigingCode?: number;

    constructor(data?: IProductVeilgroep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productVeilgroepAisID = _data["productVeilgroepAisID"];
            this.veilgroepCode = _data["veilgroepCode"];
            this.bloemenPlantenCode = _data["bloemenPlantenCode"];
            this.veilgroepOmschrijving = _data["veilgroepOmschrijving"];
            this.vestigingCode = _data["vestigingCode"];
        }
    }

    static fromJS(data: any): ProductVeilgroep {
        data = typeof data === 'object' ? data : {};
        let result = new ProductVeilgroep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productVeilgroepAisID"] = this.productVeilgroepAisID;
        data["veilgroepCode"] = this.veilgroepCode;
        data["bloemenPlantenCode"] = this.bloemenPlantenCode;
        data["veilgroepOmschrijving"] = this.veilgroepOmschrijving;
        data["vestigingCode"] = this.vestigingCode;
        return data;
    }

    clone(): ProductVeilgroep {
        const json = this.toJSON();
        let result = new ProductVeilgroep();
        result.init(json);
        return result;
    }
}

export interface IProductVeilgroep {
    productVeilgroepAisID?: number;
    veilgroepCode?: number;
    bloemenPlantenCode?: string | undefined;
    veilgroepOmschrijving?: string | undefined;
    vestigingCode?: number;
}

export class TribuneKlok implements ITribuneKlok {
    klokNummer?: number;
    klokNaam?: string | undefined;
    vestigingCode?: number;

    constructor(data?: ITribuneKlok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.klokNummer = _data["klokNummer"];
            this.klokNaam = _data["klokNaam"];
            this.vestigingCode = _data["vestigingCode"];
        }
    }

    static fromJS(data: any): TribuneKlok {
        data = typeof data === 'object' ? data : {};
        let result = new TribuneKlok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["klokNummer"] = this.klokNummer;
        data["klokNaam"] = this.klokNaam;
        data["vestigingCode"] = this.vestigingCode;
        return data;
    }

    clone(): TribuneKlok {
        const json = this.toJSON();
        let result = new TribuneKlok();
        result.init(json);
        return result;
    }
}

export interface ITribuneKlok {
    klokNummer?: number;
    klokNaam?: string | undefined;
    vestigingCode?: number;
}

export class UitzonderingReden implements IUitzonderingReden {
    uitzonderingRedenCode?: number;
    uitzonderingRedenOmschrijving?: string | undefined;

    constructor(data?: IUitzonderingReden) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uitzonderingRedenCode = _data["uitzonderingRedenCode"];
            this.uitzonderingRedenOmschrijving = _data["uitzonderingRedenOmschrijving"];
        }
    }

    static fromJS(data: any): UitzonderingReden {
        data = typeof data === 'object' ? data : {};
        let result = new UitzonderingReden();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uitzonderingRedenCode"] = this.uitzonderingRedenCode;
        data["uitzonderingRedenOmschrijving"] = this.uitzonderingRedenOmschrijving;
        return data;
    }

    clone(): UitzonderingReden {
        const json = this.toJSON();
        let result = new UitzonderingReden();
        result.init(json);
        return result;
    }
}

export interface IUitzonderingReden {
    uitzonderingRedenCode?: number;
    uitzonderingRedenOmschrijving?: string | undefined;
}

export class VeildagVeilgroepTellingReport implements IVeildagVeilgroepTellingReport {
    veildatum?: Date;
    klokNaam?: string | undefined;
    veilgroepCode?: number | undefined;
    veilgroepOmschrijving?: string | undefined;
    vestigingCode?: number;
    aantalKarren?: number;
    aantalOntvangenKarren?: number;
    aantalInNeerzetvolgordeKarren?: number;

    constructor(data?: IVeildagVeilgroepTellingReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.veildatum = _data["veildatum"] ? new Date(_data["veildatum"].toString()) : <any>undefined;
            this.klokNaam = _data["klokNaam"];
            this.veilgroepCode = _data["veilgroepCode"];
            this.veilgroepOmschrijving = _data["veilgroepOmschrijving"];
            this.vestigingCode = _data["vestigingCode"];
            this.aantalKarren = _data["aantalKarren"];
            this.aantalOntvangenKarren = _data["aantalOntvangenKarren"];
            this.aantalInNeerzetvolgordeKarren = _data["aantalInNeerzetvolgordeKarren"];
        }
    }

    static fromJS(data: any): VeildagVeilgroepTellingReport {
        data = typeof data === 'object' ? data : {};
        let result = new VeildagVeilgroepTellingReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["veildatum"] = this.veildatum ? this.veildatum.toISOString() : <any>undefined;
        data["klokNaam"] = this.klokNaam;
        data["veilgroepCode"] = this.veilgroepCode;
        data["veilgroepOmschrijving"] = this.veilgroepOmschrijving;
        data["vestigingCode"] = this.vestigingCode;
        data["aantalKarren"] = this.aantalKarren;
        data["aantalOntvangenKarren"] = this.aantalOntvangenKarren;
        data["aantalInNeerzetvolgordeKarren"] = this.aantalInNeerzetvolgordeKarren;
        return data;
    }

    clone(): VeildagVeilgroepTellingReport {
        const json = this.toJSON();
        let result = new VeildagVeilgroepTellingReport();
        result.init(json);
        return result;
    }
}

export interface IVeildagVeilgroepTellingReport {
    veildatum?: Date;
    klokNaam?: string | undefined;
    veilgroepCode?: number | undefined;
    veilgroepOmschrijving?: string | undefined;
    vestigingCode?: number;
    aantalKarren?: number;
    aantalOntvangenKarren?: number;
    aantalInNeerzetvolgordeKarren?: number;
}

export class VeilgroepIndelingOverview implements IVeilgroepIndelingOverview {
    productclusterID?: number;
    bloemenPlantenCode?: string | undefined;
    productclusterOmschrijving?: string | undefined;
    eersteVeilgroepen?: string | undefined;
    vestigingCode?: number | undefined;

    constructor(data?: IVeilgroepIndelingOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productclusterID = _data["productclusterID"];
            this.bloemenPlantenCode = _data["bloemenPlantenCode"];
            this.productclusterOmschrijving = _data["productclusterOmschrijving"];
            this.eersteVeilgroepen = _data["eersteVeilgroepen"];
            this.vestigingCode = _data["vestigingCode"];
        }
    }

    static fromJS(data: any): VeilgroepIndelingOverview {
        data = typeof data === 'object' ? data : {};
        let result = new VeilgroepIndelingOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productclusterID"] = this.productclusterID;
        data["bloemenPlantenCode"] = this.bloemenPlantenCode;
        data["productclusterOmschrijving"] = this.productclusterOmschrijving;
        data["eersteVeilgroepen"] = this.eersteVeilgroepen;
        data["vestigingCode"] = this.vestigingCode;
        return data;
    }

    clone(): VeilgroepIndelingOverview {
        const json = this.toJSON();
        let result = new VeilgroepIndelingOverview();
        result.init(json);
        return result;
    }
}

export interface IVeilgroepIndelingOverview {
    productclusterID?: number;
    bloemenPlantenCode?: string | undefined;
    productclusterOmschrijving?: string | undefined;
    eersteVeilgroepen?: string | undefined;
    vestigingCode?: number | undefined;
}

export class VeilgroepIndelingRegelView implements IVeilgroepIndelingRegelView {
    productclusterVeilgroepRegelId?: number;
    productclusterID?: number;
    vestigingCode?: number;
    veilgroepCode?: number;
    volgordeNummer?: number;
    actiefIndicatie?: boolean;
    veilgroepOmschrijving?: string | undefined;
    veilgroepRegelId?: number | undefined;
    veilgroepRegelNummer?: number | undefined;
    veilgroepRegelOmschrijving?: string | undefined;
    veilgroepRegelTekst?: string | undefined;
    veilgroepCodeAanvoerder?: number | undefined;
    veilgroepOmschrijvingAanvoerder?: string | undefined;
    codeBeperkingIndicatie?: boolean;
    ingangsDatum?: Date | undefined;
    eindDatum?: Date | undefined;
    fustTekst?: string | undefined;
    productTekst?: string | undefined;
    productgroepTekst?: string | undefined;

    constructor(data?: IVeilgroepIndelingRegelView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productclusterVeilgroepRegelId = _data["productclusterVeilgroepRegelId"];
            this.productclusterID = _data["productclusterID"];
            this.vestigingCode = _data["vestigingCode"];
            this.veilgroepCode = _data["veilgroepCode"];
            this.volgordeNummer = _data["volgordeNummer"];
            this.actiefIndicatie = _data["actiefIndicatie"];
            this.veilgroepOmschrijving = _data["veilgroepOmschrijving"];
            this.veilgroepRegelId = _data["veilgroepRegelId"];
            this.veilgroepRegelNummer = _data["veilgroepRegelNummer"];
            this.veilgroepRegelOmschrijving = _data["veilgroepRegelOmschrijving"];
            this.veilgroepRegelTekst = _data["veilgroepRegelTekst"];
            this.veilgroepCodeAanvoerder = _data["veilgroepCodeAanvoerder"];
            this.veilgroepOmschrijvingAanvoerder = _data["veilgroepOmschrijvingAanvoerder"];
            this.codeBeperkingIndicatie = _data["codeBeperkingIndicatie"];
            this.ingangsDatum = _data["ingangsDatum"] ? new Date(_data["ingangsDatum"].toString()) : <any>undefined;
            this.eindDatum = _data["eindDatum"] ? new Date(_data["eindDatum"].toString()) : <any>undefined;
            this.fustTekst = _data["fustTekst"];
            this.productTekst = _data["productTekst"];
            this.productgroepTekst = _data["productgroepTekst"];
        }
    }

    static fromJS(data: any): VeilgroepIndelingRegelView {
        data = typeof data === 'object' ? data : {};
        let result = new VeilgroepIndelingRegelView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productclusterVeilgroepRegelId"] = this.productclusterVeilgroepRegelId;
        data["productclusterID"] = this.productclusterID;
        data["vestigingCode"] = this.vestigingCode;
        data["veilgroepCode"] = this.veilgroepCode;
        data["volgordeNummer"] = this.volgordeNummer;
        data["actiefIndicatie"] = this.actiefIndicatie;
        data["veilgroepOmschrijving"] = this.veilgroepOmschrijving;
        data["veilgroepRegelId"] = this.veilgroepRegelId;
        data["veilgroepRegelNummer"] = this.veilgroepRegelNummer;
        data["veilgroepRegelOmschrijving"] = this.veilgroepRegelOmschrijving;
        data["veilgroepRegelTekst"] = this.veilgroepRegelTekst;
        data["veilgroepCodeAanvoerder"] = this.veilgroepCodeAanvoerder;
        data["veilgroepOmschrijvingAanvoerder"] = this.veilgroepOmschrijvingAanvoerder;
        data["codeBeperkingIndicatie"] = this.codeBeperkingIndicatie;
        data["ingangsDatum"] = this.ingangsDatum ? this.ingangsDatum.toISOString() : <any>undefined;
        data["eindDatum"] = this.eindDatum ? this.eindDatum.toISOString() : <any>undefined;
        data["fustTekst"] = this.fustTekst;
        data["productTekst"] = this.productTekst;
        data["productgroepTekst"] = this.productgroepTekst;
        return data;
    }

    clone(): VeilgroepIndelingRegelView {
        const json = this.toJSON();
        let result = new VeilgroepIndelingRegelView();
        result.init(json);
        return result;
    }
}

export interface IVeilgroepIndelingRegelView {
    productclusterVeilgroepRegelId?: number;
    productclusterID?: number;
    vestigingCode?: number;
    veilgroepCode?: number;
    volgordeNummer?: number;
    actiefIndicatie?: boolean;
    veilgroepOmschrijving?: string | undefined;
    veilgroepRegelId?: number | undefined;
    veilgroepRegelNummer?: number | undefined;
    veilgroepRegelOmschrijving?: string | undefined;
    veilgroepRegelTekst?: string | undefined;
    veilgroepCodeAanvoerder?: number | undefined;
    veilgroepOmschrijvingAanvoerder?: string | undefined;
    codeBeperkingIndicatie?: boolean;
    ingangsDatum?: Date | undefined;
    eindDatum?: Date | undefined;
    fustTekst?: string | undefined;
    productTekst?: string | undefined;
    productgroepTekst?: string | undefined;
}

export class VeilgroepIndelingRegelWithCodesView implements IVeilgroepIndelingRegelWithCodesView {
    productclusterVeilgroepRegelId?: number;
    productclusterID?: number;
    veilgroepCode?: number;
    veilgroepRegelId?: number | undefined;
    veilgroepCodeAanvoerder?: number | undefined;
    ingangsDatum?: Date;
    eindDatum?: Date;
    vestigingCode?: number;
    volgordeNummer?: number;
    productclusterVeilgroepRegelCodes?: ProductclusterVeilgroepRegelCodeView[];

    constructor(data?: IVeilgroepIndelingRegelWithCodesView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productclusterVeilgroepRegelId = _data["productclusterVeilgroepRegelId"];
            this.productclusterID = _data["productclusterID"];
            this.veilgroepCode = _data["veilgroepCode"];
            this.veilgroepRegelId = _data["veilgroepRegelId"];
            this.veilgroepCodeAanvoerder = _data["veilgroepCodeAanvoerder"];
            this.ingangsDatum = _data["ingangsDatum"] ? new Date(_data["ingangsDatum"].toString()) : <any>undefined;
            this.eindDatum = _data["eindDatum"] ? new Date(_data["eindDatum"].toString()) : <any>undefined;
            this.vestigingCode = _data["vestigingCode"];
            this.volgordeNummer = _data["volgordeNummer"];
            if (Array.isArray(_data["productclusterVeilgroepRegelCodes"])) {
                this.productclusterVeilgroepRegelCodes = [] as any;
                for (let item of _data["productclusterVeilgroepRegelCodes"])
                    this.productclusterVeilgroepRegelCodes!.push(ProductclusterVeilgroepRegelCodeView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VeilgroepIndelingRegelWithCodesView {
        data = typeof data === 'object' ? data : {};
        let result = new VeilgroepIndelingRegelWithCodesView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productclusterVeilgroepRegelId"] = this.productclusterVeilgroepRegelId;
        data["productclusterID"] = this.productclusterID;
        data["veilgroepCode"] = this.veilgroepCode;
        data["veilgroepRegelId"] = this.veilgroepRegelId;
        data["veilgroepCodeAanvoerder"] = this.veilgroepCodeAanvoerder;
        data["ingangsDatum"] = this.ingangsDatum ? this.ingangsDatum.toISOString() : <any>undefined;
        data["eindDatum"] = this.eindDatum ? this.eindDatum.toISOString() : <any>undefined;
        data["vestigingCode"] = this.vestigingCode;
        data["volgordeNummer"] = this.volgordeNummer;
        if (Array.isArray(this.productclusterVeilgroepRegelCodes)) {
            data["productclusterVeilgroepRegelCodes"] = [];
            for (let item of this.productclusterVeilgroepRegelCodes)
                data["productclusterVeilgroepRegelCodes"].push(item.toJSON());
        }
        return data;
    }

    clone(): VeilgroepIndelingRegelWithCodesView {
        const json = this.toJSON();
        let result = new VeilgroepIndelingRegelWithCodesView();
        result.init(json);
        return result;
    }
}

export interface IVeilgroepIndelingRegelWithCodesView {
    productclusterVeilgroepRegelId?: number;
    productclusterID?: number;
    veilgroepCode?: number;
    veilgroepRegelId?: number | undefined;
    veilgroepCodeAanvoerder?: number | undefined;
    ingangsDatum?: Date;
    eindDatum?: Date;
    vestigingCode?: number;
    volgordeNummer?: number;
    productclusterVeilgroepRegelCodes?: ProductclusterVeilgroepRegelCodeView[];
}

export class VeilgroepRegel implements IVeilgroepRegel {
    veilgroepRegelId?: number;
    veilgroepRegelNummer?: number;
    veilgroepRegelOmschrijving?: string | undefined;
    weekVanaf?: number | undefined;
    weekTtm?: number | undefined;
    dagVanaf?: number | undefined;
    dagTtm?: number | undefined;
    gekoppeldePartijFoto?: boolean | undefined;
    geenDienstVeilen?: boolean | undefined;
    bronReclamatie?: boolean | undefined;
    aanvoerderRegelmatig?: boolean | undefined;
    aanvoerderOnregelmatig?: boolean | undefined;
    kwaliteit?: string | undefined;
    aanvoerTypen?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    ladingdragerTypen?: string | undefined;

    constructor(data?: IVeilgroepRegel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.veilgroepRegelId = _data["veilgroepRegelId"];
            this.veilgroepRegelNummer = _data["veilgroepRegelNummer"];
            this.veilgroepRegelOmschrijving = _data["veilgroepRegelOmschrijving"];
            this.weekVanaf = _data["weekVanaf"];
            this.weekTtm = _data["weekTtm"];
            this.dagVanaf = _data["dagVanaf"];
            this.dagTtm = _data["dagTtm"];
            this.gekoppeldePartijFoto = _data["gekoppeldePartijFoto"];
            this.geenDienstVeilen = _data["geenDienstVeilen"];
            this.bronReclamatie = _data["bronReclamatie"];
            this.aanvoerderRegelmatig = _data["aanvoerderRegelmatig"];
            this.aanvoerderOnregelmatig = _data["aanvoerderOnregelmatig"];
            this.kwaliteit = _data["kwaliteit"];
            this.aanvoerTypen = _data["aanvoerTypen"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
            this.ladingdragerTypen = _data["ladingdragerTypen"];
        }
    }

    static fromJS(data: any): VeilgroepRegel {
        data = typeof data === 'object' ? data : {};
        let result = new VeilgroepRegel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["veilgroepRegelId"] = this.veilgroepRegelId;
        data["veilgroepRegelNummer"] = this.veilgroepRegelNummer;
        data["veilgroepRegelOmschrijving"] = this.veilgroepRegelOmschrijving;
        data["weekVanaf"] = this.weekVanaf;
        data["weekTtm"] = this.weekTtm;
        data["dagVanaf"] = this.dagVanaf;
        data["dagTtm"] = this.dagTtm;
        data["gekoppeldePartijFoto"] = this.gekoppeldePartijFoto;
        data["geenDienstVeilen"] = this.geenDienstVeilen;
        data["bronReclamatie"] = this.bronReclamatie;
        data["aanvoerderRegelmatig"] = this.aanvoerderRegelmatig;
        data["aanvoerderOnregelmatig"] = this.aanvoerderOnregelmatig;
        data["kwaliteit"] = this.kwaliteit;
        data["aanvoerTypen"] = this.aanvoerTypen;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        data["ladingdragerTypen"] = this.ladingdragerTypen;
        return data;
    }

    clone(): VeilgroepRegel {
        const json = this.toJSON();
        let result = new VeilgroepRegel();
        result.init(json);
        return result;
    }
}

export interface IVeilgroepRegel {
    veilgroepRegelId?: number;
    veilgroepRegelNummer?: number;
    veilgroepRegelOmschrijving?: string | undefined;
    weekVanaf?: number | undefined;
    weekTtm?: number | undefined;
    dagVanaf?: number | undefined;
    dagTtm?: number | undefined;
    gekoppeldePartijFoto?: boolean | undefined;
    geenDienstVeilen?: boolean | undefined;
    bronReclamatie?: boolean | undefined;
    aanvoerderRegelmatig?: boolean | undefined;
    aanvoerderOnregelmatig?: boolean | undefined;
    kwaliteit?: string | undefined;
    aanvoerTypen?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    ladingdragerTypen?: string | undefined;
}

export class VeilgroepRegelKenmerk implements IVeilgroepRegelKenmerk {
    veilgroepRegelKenmerkId?: number;
    veilgroepRegelId?: number;
    kenmerkCode?: string | undefined;
    kenmerkWaardeVan?: string | undefined;
    kenmerkWaardeTtm?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;

    constructor(data?: IVeilgroepRegelKenmerk) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.veilgroepRegelKenmerkId = _data["veilgroepRegelKenmerkId"];
            this.veilgroepRegelId = _data["veilgroepRegelId"];
            this.kenmerkCode = _data["kenmerkCode"];
            this.kenmerkWaardeVan = _data["kenmerkWaardeVan"];
            this.kenmerkWaardeTtm = _data["kenmerkWaardeTtm"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
        }
    }

    static fromJS(data: any): VeilgroepRegelKenmerk {
        data = typeof data === 'object' ? data : {};
        let result = new VeilgroepRegelKenmerk();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["veilgroepRegelKenmerkId"] = this.veilgroepRegelKenmerkId;
        data["veilgroepRegelId"] = this.veilgroepRegelId;
        data["kenmerkCode"] = this.kenmerkCode;
        data["kenmerkWaardeVan"] = this.kenmerkWaardeVan;
        data["kenmerkWaardeTtm"] = this.kenmerkWaardeTtm;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        return data;
    }

    clone(): VeilgroepRegelKenmerk {
        const json = this.toJSON();
        let result = new VeilgroepRegelKenmerk();
        result.init(json);
        return result;
    }
}

export interface IVeilgroepRegelKenmerk {
    veilgroepRegelKenmerkId?: number;
    veilgroepRegelId?: number;
    kenmerkCode?: string | undefined;
    kenmerkWaardeVan?: string | undefined;
    kenmerkWaardeTtm?: string | undefined;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
}

export class ProductgroepenReport implements IProductgroepenReport {
    productGroepCode?: number;
    productGroepOmschrijving?: string | undefined;
    productGroepGeselecteerd?: boolean;

    constructor(data?: IProductgroepenReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productGroepCode = _data["productGroepCode"];
            this.productGroepOmschrijving = _data["productGroepOmschrijving"];
            this.productGroepGeselecteerd = _data["productGroepGeselecteerd"];
        }
    }

    static fromJS(data: any): ProductgroepenReport {
        data = typeof data === 'object' ? data : {};
        let result = new ProductgroepenReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productGroepCode"] = this.productGroepCode;
        data["productGroepOmschrijving"] = this.productGroepOmschrijving;
        data["productGroepGeselecteerd"] = this.productGroepGeselecteerd;
        return data;
    }

    clone(): ProductgroepenReport {
        const json = this.toJSON();
        let result = new ProductgroepenReport();
        result.init(json);
        return result;
    }
}

export interface IProductgroepenReport {
    productGroepCode?: number;
    productGroepOmschrijving?: string | undefined;
    productGroepGeselecteerd?: boolean;
}

export class ProductclusterVeilgroepRegelCode implements IProductclusterVeilgroepRegelCode {
    code?: number;
    codeSoort?: string | undefined;
    omschrijving?: string | undefined;
    productclusterVeilgroepRegelCodeId?: number | undefined;
    productclusterVeilgroepRegelId?: number | undefined;
    geselecteerd?: boolean;

    constructor(data?: IProductclusterVeilgroepRegelCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.codeSoort = _data["codeSoort"];
            this.omschrijving = _data["omschrijving"];
            this.productclusterVeilgroepRegelCodeId = _data["productclusterVeilgroepRegelCodeId"];
            this.productclusterVeilgroepRegelId = _data["productclusterVeilgroepRegelId"];
            this.geselecteerd = _data["geselecteerd"];
        }
    }

    static fromJS(data: any): ProductclusterVeilgroepRegelCode {
        data = typeof data === 'object' ? data : {};
        let result = new ProductclusterVeilgroepRegelCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeSoort"] = this.codeSoort;
        data["omschrijving"] = this.omschrijving;
        data["productclusterVeilgroepRegelCodeId"] = this.productclusterVeilgroepRegelCodeId;
        data["productclusterVeilgroepRegelId"] = this.productclusterVeilgroepRegelId;
        data["geselecteerd"] = this.geselecteerd;
        return data;
    }

    clone(): ProductclusterVeilgroepRegelCode {
        const json = this.toJSON();
        let result = new ProductclusterVeilgroepRegelCode();
        result.init(json);
        return result;
    }
}

export interface IProductclusterVeilgroepRegelCode {
    code?: number;
    codeSoort?: string | undefined;
    omschrijving?: string | undefined;
    productclusterVeilgroepRegelCodeId?: number | undefined;
    productclusterVeilgroepRegelId?: number | undefined;
    geselecteerd?: boolean;
}

export class VeilgroepRegelView implements IVeilgroepRegelView {
    veilgroepRegelId?: number;
    veilgroepRegelNummer?: number;
    veilgroepRegelOmschrijving?: string | undefined;

    constructor(data?: IVeilgroepRegelView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.veilgroepRegelId = _data["veilgroepRegelId"];
            this.veilgroepRegelNummer = _data["veilgroepRegelNummer"];
            this.veilgroepRegelOmschrijving = _data["veilgroepRegelOmschrijving"];
        }
    }

    static fromJS(data: any): VeilgroepRegelView {
        data = typeof data === 'object' ? data : {};
        let result = new VeilgroepRegelView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["veilgroepRegelId"] = this.veilgroepRegelId;
        data["veilgroepRegelNummer"] = this.veilgroepRegelNummer;
        data["veilgroepRegelOmschrijving"] = this.veilgroepRegelOmschrijving;
        return data;
    }

    clone(): VeilgroepRegelView {
        const json = this.toJSON();
        let result = new VeilgroepRegelView();
        result.init(json);
        return result;
    }
}

export interface IVeilgroepRegelView {
    veilgroepRegelId?: number;
    veilgroepRegelNummer?: number;
    veilgroepRegelOmschrijving?: string | undefined;
}

export class ClusterEnRegelsView implements IClusterEnRegelsView {
    clusterNaam?: string | undefined;
    productgroep?: string | undefined;
    veilgroepregels?: (string | undefined)[];

    constructor(data?: IClusterEnRegelsView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clusterNaam = _data["clusterNaam"];
            this.productgroep = _data["productgroep"];
            if (Array.isArray(_data["veilgroepregels"])) {
                this.veilgroepregels = [] as any;
                for (let item of _data["veilgroepregels"])
                    this.veilgroepregels!.push(item);
            }
        }
    }

    static fromJS(data: any): ClusterEnRegelsView {
        data = typeof data === 'object' ? data : {};
        let result = new ClusterEnRegelsView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterNaam"] = this.clusterNaam;
        data["productgroep"] = this.productgroep;
        if (Array.isArray(this.veilgroepregels)) {
            data["veilgroepregels"] = [];
            for (let item of this.veilgroepregels)
                data["veilgroepregels"].push(item);
        }
        return data;
    }

    clone(): ClusterEnRegelsView {
        const json = this.toJSON();
        let result = new ClusterEnRegelsView();
        result.init(json);
        return result;
    }
}

export interface IClusterEnRegelsView {
    clusterNaam?: string | undefined;
    productgroep?: string | undefined;
    veilgroepregels?: (string | undefined)[];
}

export class IActionResult implements IIActionResult {

    constructor(data?: IIActionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IActionResult {
        data = typeof data === 'object' ? data : {};
        let result = new IActionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): IActionResult {
        const json = this.toJSON();
        let result = new IActionResult();
        result.init(json);
        return result;
    }
}

export interface IIActionResult {
}

export class BeherenAanvoerderProductRegelmatigUitzondering extends Feature implements IBeherenAanvoerderProductRegelmatigUitzondering {
    overzichtAanvoerderProductRegelmatigUitzonderingen?: OverzichtAanvoerderProductRegelmatigUitzonderingen2;
    toevoegenAanvoerderProductRegelmatigUitzondering?: ToevoegenAanvoerderProductRegelmatigUitzondering2;
    updatenAanvoerderProductRegelmatigUitzondering?: UpdatenAanvoerderProductRegelmatigUitzondering2;
    verwijderenAanvoerderProductRegelmatigUitzondering?: VerwijderenAanvoerderProductRegelmatigUitzondering2;

    constructor(data?: IBeherenAanvoerderProductRegelmatigUitzondering) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.overzichtAanvoerderProductRegelmatigUitzonderingen = _data["overzichtAanvoerderProductRegelmatigUitzonderingen"];
            this.toevoegenAanvoerderProductRegelmatigUitzondering = _data["toevoegenAanvoerderProductRegelmatigUitzondering"];
            this.updatenAanvoerderProductRegelmatigUitzondering = _data["updatenAanvoerderProductRegelmatigUitzondering"];
            this.verwijderenAanvoerderProductRegelmatigUitzondering = _data["verwijderenAanvoerderProductRegelmatigUitzondering"];
        }
    }

    static override fromJS(data: any): BeherenAanvoerderProductRegelmatigUitzondering {
        data = typeof data === 'object' ? data : {};
        let result = new BeherenAanvoerderProductRegelmatigUitzondering();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overzichtAanvoerderProductRegelmatigUitzonderingen"] = this.overzichtAanvoerderProductRegelmatigUitzonderingen;
        data["toevoegenAanvoerderProductRegelmatigUitzondering"] = this.toevoegenAanvoerderProductRegelmatigUitzondering;
        data["updatenAanvoerderProductRegelmatigUitzondering"] = this.updatenAanvoerderProductRegelmatigUitzondering;
        data["verwijderenAanvoerderProductRegelmatigUitzondering"] = this.verwijderenAanvoerderProductRegelmatigUitzondering;
        super.toJSON(data);
        return data;
    }

    clone(): BeherenAanvoerderProductRegelmatigUitzondering {
        const json = this.toJSON();
        let result = new BeherenAanvoerderProductRegelmatigUitzondering();
        result.init(json);
        return result;
    }
}

export interface IBeherenAanvoerderProductRegelmatigUitzondering extends IFeature {
    overzichtAanvoerderProductRegelmatigUitzonderingen?: OverzichtAanvoerderProductRegelmatigUitzonderingen2;
    toevoegenAanvoerderProductRegelmatigUitzondering?: ToevoegenAanvoerderProductRegelmatigUitzondering2;
    updatenAanvoerderProductRegelmatigUitzondering?: UpdatenAanvoerderProductRegelmatigUitzondering2;
    verwijderenAanvoerderProductRegelmatigUitzondering?: VerwijderenAanvoerderProductRegelmatigUitzondering2;
}

export class OverzichtAanvoerderProductRegelmatigUitzonderingen implements IOverzichtAanvoerderProductRegelmatigUitzonderingen {
    description?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: IOverzichtAanvoerderProductRegelmatigUitzonderingen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): OverzichtAanvoerderProductRegelmatigUitzonderingen {
        data = typeof data === 'object' ? data : {};
        let result = new OverzichtAanvoerderProductRegelmatigUitzonderingen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        return data;
    }

    clone(): OverzichtAanvoerderProductRegelmatigUitzonderingen {
        const json = this.toJSON();
        let result = new OverzichtAanvoerderProductRegelmatigUitzonderingen();
        result.init(json);
        return result;
    }
}

export interface IOverzichtAanvoerderProductRegelmatigUitzonderingen {
    description?: string | undefined;
    isEnabled?: boolean;
}

export class ToevoegenAanvoerderProductRegelmatigUitzondering implements IToevoegenAanvoerderProductRegelmatigUitzondering {
    description?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: IToevoegenAanvoerderProductRegelmatigUitzondering) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ToevoegenAanvoerderProductRegelmatigUitzondering {
        data = typeof data === 'object' ? data : {};
        let result = new ToevoegenAanvoerderProductRegelmatigUitzondering();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        return data;
    }

    clone(): ToevoegenAanvoerderProductRegelmatigUitzondering {
        const json = this.toJSON();
        let result = new ToevoegenAanvoerderProductRegelmatigUitzondering();
        result.init(json);
        return result;
    }
}

export interface IToevoegenAanvoerderProductRegelmatigUitzondering {
    description?: string | undefined;
    isEnabled?: boolean;
}

export class UpdatenAanvoerderProductRegelmatigUitzondering implements IUpdatenAanvoerderProductRegelmatigUitzondering {
    description?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: IUpdatenAanvoerderProductRegelmatigUitzondering) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UpdatenAanvoerderProductRegelmatigUitzondering {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatenAanvoerderProductRegelmatigUitzondering();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        return data;
    }

    clone(): UpdatenAanvoerderProductRegelmatigUitzondering {
        const json = this.toJSON();
        let result = new UpdatenAanvoerderProductRegelmatigUitzondering();
        result.init(json);
        return result;
    }
}

export interface IUpdatenAanvoerderProductRegelmatigUitzondering {
    description?: string | undefined;
    isEnabled?: boolean;
}

export class VerwijderenAanvoerderProductRegelmatigUitzondering implements IVerwijderenAanvoerderProductRegelmatigUitzondering {
    description?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: IVerwijderenAanvoerderProductRegelmatigUitzondering) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): VerwijderenAanvoerderProductRegelmatigUitzondering {
        data = typeof data === 'object' ? data : {};
        let result = new VerwijderenAanvoerderProductRegelmatigUitzondering();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        return data;
    }

    clone(): VerwijderenAanvoerderProductRegelmatigUitzondering {
        const json = this.toJSON();
        let result = new VerwijderenAanvoerderProductRegelmatigUitzondering();
        result.init(json);
        return result;
    }
}

export interface IVerwijderenAanvoerderProductRegelmatigUitzondering {
    description?: string | undefined;
    isEnabled?: boolean;
}

export class ProductclusterVeilgroepRegel implements IProductclusterVeilgroepRegel {
    productclusterVeilgroepRegelId?: number;
    vestigingCode?: number;
    veilgroepCode?: number;
    veilgroepRegelId?: number | undefined;
    volgordeNummer?: number | undefined;
    ingangsDatum?: Date;
    eindDatum?: Date;
    actiefIndicatie?: boolean;
    uitwijkveilgroepIndicatie?: boolean;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    veilgroepCodeAanvoerder?: number | undefined;

    constructor(data?: IProductclusterVeilgroepRegel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productclusterVeilgroepRegelId = _data["productclusterVeilgroepRegelId"];
            this.vestigingCode = _data["vestigingCode"];
            this.veilgroepCode = _data["veilgroepCode"];
            this.veilgroepRegelId = _data["veilgroepRegelId"];
            this.volgordeNummer = _data["volgordeNummer"];
            this.ingangsDatum = _data["ingangsDatum"] ? new Date(_data["ingangsDatum"].toString()) : <any>undefined;
            this.eindDatum = _data["eindDatum"] ? new Date(_data["eindDatum"].toString()) : <any>undefined;
            this.actiefIndicatie = _data["actiefIndicatie"];
            this.uitwijkveilgroepIndicatie = _data["uitwijkveilgroepIndicatie"];
            this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
            this.aanmaakGebruiker = _data["aanmaakGebruiker"];
            this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
            this.mutatieGebruiker = _data["mutatieGebruiker"];
            this.veilgroepCodeAanvoerder = _data["veilgroepCodeAanvoerder"];
        }
    }

    static fromJS(data: any): ProductclusterVeilgroepRegel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductclusterVeilgroepRegel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productclusterVeilgroepRegelId"] = this.productclusterVeilgroepRegelId;
        data["vestigingCode"] = this.vestigingCode;
        data["veilgroepCode"] = this.veilgroepCode;
        data["veilgroepRegelId"] = this.veilgroepRegelId;
        data["volgordeNummer"] = this.volgordeNummer;
        data["ingangsDatum"] = this.ingangsDatum ? this.ingangsDatum.toISOString() : <any>undefined;
        data["eindDatum"] = this.eindDatum ? this.eindDatum.toISOString() : <any>undefined;
        data["actiefIndicatie"] = this.actiefIndicatie;
        data["uitwijkveilgroepIndicatie"] = this.uitwijkveilgroepIndicatie;
        data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
        data["aanmaakGebruiker"] = this.aanmaakGebruiker;
        data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
        data["mutatieGebruiker"] = this.mutatieGebruiker;
        data["veilgroepCodeAanvoerder"] = this.veilgroepCodeAanvoerder;
        return data;
    }

    clone(): ProductclusterVeilgroepRegel {
        const json = this.toJSON();
        let result = new ProductclusterVeilgroepRegel();
        result.init(json);
        return result;
    }
}

export interface IProductclusterVeilgroepRegel {
    productclusterVeilgroepRegelId?: number;
    vestigingCode?: number;
    veilgroepCode?: number;
    veilgroepRegelId?: number | undefined;
    volgordeNummer?: number | undefined;
    ingangsDatum?: Date;
    eindDatum?: Date;
    actiefIndicatie?: boolean;
    uitwijkveilgroepIndicatie?: boolean;
    aanmaakDatumTijd?: Date;
    aanmaakGebruiker?: string | undefined;
    mutatieDatumTijd?: Date;
    mutatieGebruiker?: string | undefined;
    veilgroepCodeAanvoerder?: number | undefined;
}

export class ProductclusterVeilgroepRegelCodeView implements IProductclusterVeilgroepRegelCodeView {
    productclusterVeilgroepRegelCodeId?: number | undefined;
    productclusterVeilgroepRegelId?: number;
    codeSoort?: string | undefined;
    code?: number;
    geselecteerd?: boolean;

    constructor(data?: IProductclusterVeilgroepRegelCodeView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productclusterVeilgroepRegelCodeId = _data["productclusterVeilgroepRegelCodeId"];
            this.productclusterVeilgroepRegelId = _data["productclusterVeilgroepRegelId"];
            this.codeSoort = _data["codeSoort"];
            this.code = _data["code"];
            this.geselecteerd = _data["geselecteerd"];
        }
    }

    static fromJS(data: any): ProductclusterVeilgroepRegelCodeView {
        data = typeof data === 'object' ? data : {};
        let result = new ProductclusterVeilgroepRegelCodeView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productclusterVeilgroepRegelCodeId"] = this.productclusterVeilgroepRegelCodeId;
        data["productclusterVeilgroepRegelId"] = this.productclusterVeilgroepRegelId;
        data["codeSoort"] = this.codeSoort;
        data["code"] = this.code;
        data["geselecteerd"] = this.geselecteerd;
        return data;
    }

    clone(): ProductclusterVeilgroepRegelCodeView {
        const json = this.toJSON();
        let result = new ProductclusterVeilgroepRegelCodeView();
        result.init(json);
        return result;
    }
}

export interface IProductclusterVeilgroepRegelCodeView {
    productclusterVeilgroepRegelCodeId?: number | undefined;
    productclusterVeilgroepRegelId?: number;
    codeSoort?: string | undefined;
    code?: number;
    geselecteerd?: boolean;
}

export enum Vestiging {
    Aalsmeer = "aalsmeer",
    Naaldwijk = "naaldwijk",
    Rijnsburg = "rijnsburg",
}

export class ODataError implements IODataError {
    error!: MainError;

    constructor(data?: IODataError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.error = new MainError();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] ? MainError.fromJS(_data["error"]) : new MainError();
        }
    }

    static fromJS(data: any): ODataError {
        data = typeof data === 'object' ? data : {};
        let result = new ODataError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }

    clone(): ODataError {
        const json = this.toJSON();
        let result = new ODataError();
        result.init(json);
        return result;
    }
}

export interface IODataError {
    error: MainError;
}

export class MainError implements IMainError {
    code!: string;
    message!: string;
    target?: string | undefined;
    details?: ErrorDetails[];
    innerError?: InnerError;

    constructor(data?: IMainError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.target = _data["target"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ErrorDetails.fromJS(item));
            }
            this.innerError = _data["innerError"] ? InnerError.fromJS(_data["innerError"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MainError {
        data = typeof data === 'object' ? data : {};
        let result = new MainError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["target"] = this.target;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["innerError"] = this.innerError ? this.innerError.toJSON() : <any>undefined;
        return data;
    }

    clone(): MainError {
        const json = this.toJSON();
        let result = new MainError();
        result.init(json);
        return result;
    }
}

export interface IMainError {
    code: string;
    message: string;
    target?: string | undefined;
    details?: ErrorDetails[];
    innerError?: InnerError;
}

export class ErrorDetails implements IErrorDetails {
    code!: string;
    message!: string;
    target?: string | undefined;

    constructor(data?: IErrorDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.target = _data["target"];
        }
    }

    static fromJS(data: any): ErrorDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["target"] = this.target;
        return data;
    }

    clone(): ErrorDetails {
        const json = this.toJSON();
        let result = new ErrorDetails();
        result.init(json);
        return result;
    }
}

export interface IErrorDetails {
    code: string;
    message: string;
    target?: string | undefined;
}

/** The structure of this object is service-specific */
export class InnerError implements IInnerError {

    constructor(data?: IInnerError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): InnerError {
        data = typeof data === 'object' ? data : {};
        let result = new InnerError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): InnerError {
        const json = this.toJSON();
        let result = new InnerError();
        result.init(json);
        return result;
    }
}

/** The structure of this object is service-specific */
export interface IInnerError {
}

export class AanvoerderCollectionResponse implements IAanvoerderCollectionResponse {
    value?: Aanvoerder[];

    constructor(data?: IAanvoerderCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(Aanvoerder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AanvoerderCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): AanvoerderCollectionResponse {
        const json = this.toJSON();
        let result = new AanvoerderCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderCollectionResponse {
    value?: Aanvoerder[];
}

export class AanvoerderclusterCollectionResponse implements IAanvoerderclusterCollectionResponse {
    value?: Aanvoerdercluster[];

    constructor(data?: IAanvoerderclusterCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(Aanvoerdercluster.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AanvoerderclusterCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderclusterCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): AanvoerderclusterCollectionResponse {
        const json = this.toJSON();
        let result = new AanvoerderclusterCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderclusterCollectionResponse {
    value?: Aanvoerdercluster[];
}

export class AanvoerderclusterAanvoerderCollectionResponse implements IAanvoerderclusterAanvoerderCollectionResponse {
    value?: AanvoerderclusterAanvoerder[];

    constructor(data?: IAanvoerderclusterAanvoerderCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderclusterAanvoerder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AanvoerderclusterAanvoerderCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderclusterAanvoerderCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): AanvoerderclusterAanvoerderCollectionResponse {
        const json = this.toJSON();
        let result = new AanvoerderclusterAanvoerderCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderclusterAanvoerderCollectionResponse {
    value?: AanvoerderclusterAanvoerder[];
}

export class AanvoerderclusterViewCollectionResponse implements IAanvoerderclusterViewCollectionResponse {
    value?: AanvoerderclusterView[];

    constructor(data?: IAanvoerderclusterViewCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderclusterView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AanvoerderclusterViewCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderclusterViewCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): AanvoerderclusterViewCollectionResponse {
        const json = this.toJSON();
        let result = new AanvoerderclusterViewCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderclusterViewCollectionResponse {
    value?: AanvoerderclusterView[];
}

export class AanvoerderOnregelmatigCollectionResponse implements IAanvoerderOnregelmatigCollectionResponse {
    value?: AanvoerderOnregelmatig[];

    constructor(data?: IAanvoerderOnregelmatigCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderOnregelmatig.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AanvoerderOnregelmatigCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderOnregelmatigCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): AanvoerderOnregelmatigCollectionResponse {
        const json = this.toJSON();
        let result = new AanvoerderOnregelmatigCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderOnregelmatigCollectionResponse {
    value?: AanvoerderOnregelmatig[];
}

export class AanvoerderProductgroepRegelmatigCollectionResponse implements IAanvoerderProductgroepRegelmatigCollectionResponse {
    value?: AanvoerderProductgroepRegelmatig[];

    constructor(data?: IAanvoerderProductgroepRegelmatigCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderProductgroepRegelmatig.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AanvoerderProductgroepRegelmatigCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductgroepRegelmatigCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): AanvoerderProductgroepRegelmatigCollectionResponse {
        const json = this.toJSON();
        let result = new AanvoerderProductgroepRegelmatigCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductgroepRegelmatigCollectionResponse {
    value?: AanvoerderProductgroepRegelmatig[];
}

export class AanvoerderProductgroepRegelmatigUitzonderingCollectionResponse implements IAanvoerderProductgroepRegelmatigUitzonderingCollectionResponse {
    value?: AanvoerderProductgroepRegelmatigUitzondering[];

    constructor(data?: IAanvoerderProductgroepRegelmatigUitzonderingCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderProductgroepRegelmatigUitzondering.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AanvoerderProductgroepRegelmatigUitzonderingCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductgroepRegelmatigUitzonderingCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): AanvoerderProductgroepRegelmatigUitzonderingCollectionResponse {
        const json = this.toJSON();
        let result = new AanvoerderProductgroepRegelmatigUitzonderingCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductgroepRegelmatigUitzonderingCollectionResponse {
    value?: AanvoerderProductgroepRegelmatigUitzondering[];
}

export class AanvoerderProductgroepRegelmatigUitzonderingViewCollectionResponse implements IAanvoerderProductgroepRegelmatigUitzonderingViewCollectionResponse {
    value?: AanvoerderProductgroepRegelmatigUitzonderingView[];

    constructor(data?: IAanvoerderProductgroepRegelmatigUitzonderingViewCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderProductgroepRegelmatigUitzonderingView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AanvoerderProductgroepRegelmatigUitzonderingViewCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductgroepRegelmatigUitzonderingViewCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): AanvoerderProductgroepRegelmatigUitzonderingViewCollectionResponse {
        const json = this.toJSON();
        let result = new AanvoerderProductgroepRegelmatigUitzonderingViewCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductgroepRegelmatigUitzonderingViewCollectionResponse {
    value?: AanvoerderProductgroepRegelmatigUitzonderingView[];
}

export class AanvoerderProductgroepRegelmatigViewCollectionResponse implements IAanvoerderProductgroepRegelmatigViewCollectionResponse {
    value?: AanvoerderProductgroepRegelmatigView[];

    constructor(data?: IAanvoerderProductgroepRegelmatigViewCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderProductgroepRegelmatigView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AanvoerderProductgroepRegelmatigViewCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductgroepRegelmatigViewCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): AanvoerderProductgroepRegelmatigViewCollectionResponse {
        const json = this.toJSON();
        let result = new AanvoerderProductgroepRegelmatigViewCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductgroepRegelmatigViewCollectionResponse {
    value?: AanvoerderProductgroepRegelmatigView[];
}

export class AanvoerderProductRegelmatigCollectionResponse implements IAanvoerderProductRegelmatigCollectionResponse {
    value?: AanvoerderProductRegelmatig[];

    constructor(data?: IAanvoerderProductRegelmatigCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderProductRegelmatig.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AanvoerderProductRegelmatigCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductRegelmatigCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): AanvoerderProductRegelmatigCollectionResponse {
        const json = this.toJSON();
        let result = new AanvoerderProductRegelmatigCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductRegelmatigCollectionResponse {
    value?: AanvoerderProductRegelmatig[];
}

export class AanvoerderProductRegelmatigUitzonderingCollectionResponse implements IAanvoerderProductRegelmatigUitzonderingCollectionResponse {
    value?: AanvoerderProductRegelmatigUitzondering[];

    constructor(data?: IAanvoerderProductRegelmatigUitzonderingCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderProductRegelmatigUitzondering.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AanvoerderProductRegelmatigUitzonderingCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductRegelmatigUitzonderingCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): AanvoerderProductRegelmatigUitzonderingCollectionResponse {
        const json = this.toJSON();
        let result = new AanvoerderProductRegelmatigUitzonderingCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductRegelmatigUitzonderingCollectionResponse {
    value?: AanvoerderProductRegelmatigUitzondering[];
}

export class AanvoerderProductRegelmatigUitzonderingViewCollectionResponse implements IAanvoerderProductRegelmatigUitzonderingViewCollectionResponse {
    value?: AanvoerderProductRegelmatigUitzonderingView[];

    constructor(data?: IAanvoerderProductRegelmatigUitzonderingViewCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderProductRegelmatigUitzonderingView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AanvoerderProductRegelmatigUitzonderingViewCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductRegelmatigUitzonderingViewCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): AanvoerderProductRegelmatigUitzonderingViewCollectionResponse {
        const json = this.toJSON();
        let result = new AanvoerderProductRegelmatigUitzonderingViewCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductRegelmatigUitzonderingViewCollectionResponse {
    value?: AanvoerderProductRegelmatigUitzonderingView[];
}

export class AanvoerderProductRegelmatigViewCollectionResponse implements IAanvoerderProductRegelmatigViewCollectionResponse {
    value?: AanvoerderProductRegelmatigView[];

    constructor(data?: IAanvoerderProductRegelmatigViewCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderProductRegelmatigView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AanvoerderProductRegelmatigViewCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderProductRegelmatigViewCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): AanvoerderProductRegelmatigViewCollectionResponse {
        const json = this.toJSON();
        let result = new AanvoerderProductRegelmatigViewCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderProductRegelmatigViewCollectionResponse {
    value?: AanvoerderProductRegelmatigView[];
}

export class AanvoerderPromotieKenmerkCollectionResponse implements IAanvoerderPromotieKenmerkCollectionResponse {
    value?: AanvoerderPromotieKenmerk[];

    constructor(data?: IAanvoerderPromotieKenmerkCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderPromotieKenmerk.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AanvoerderPromotieKenmerkCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AanvoerderPromotieKenmerkCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): AanvoerderPromotieKenmerkCollectionResponse {
        const json = this.toJSON();
        let result = new AanvoerderPromotieKenmerkCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IAanvoerderPromotieKenmerkCollectionResponse {
    value?: AanvoerderPromotieKenmerk[];
}

export class KenmerkCollectionResponse implements IKenmerkCollectionResponse {
    value?: Kenmerk[];

    constructor(data?: IKenmerkCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(Kenmerk.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KenmerkCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KenmerkCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): KenmerkCollectionResponse {
        const json = this.toJSON();
        let result = new KenmerkCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IKenmerkCollectionResponse {
    value?: Kenmerk[];
}

export class KenmerkWaardeCollectionResponse implements IKenmerkWaardeCollectionResponse {
    value?: KenmerkWaarde[];

    constructor(data?: IKenmerkWaardeCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(KenmerkWaarde.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KenmerkWaardeCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KenmerkWaardeCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): KenmerkWaardeCollectionResponse {
        const json = this.toJSON();
        let result = new KenmerkWaardeCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IKenmerkWaardeCollectionResponse {
    value?: KenmerkWaarde[];
}

export class PartijStatusReportCollectionResponse implements IPartijStatusReportCollectionResponse {
    value?: PartijStatusReport[];

    constructor(data?: IPartijStatusReportCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(PartijStatusReport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartijStatusReportCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PartijStatusReportCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): PartijStatusReportCollectionResponse {
        const json = this.toJSON();
        let result = new PartijStatusReportCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IPartijStatusReportCollectionResponse {
    value?: PartijStatusReport[];
}

export class ProductCollectionResponse implements IProductCollectionResponse {
    value?: Product[];

    constructor(data?: IProductCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(Product.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductCollectionResponse {
        const json = this.toJSON();
        let result = new ProductCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IProductCollectionResponse {
    value?: Product[];
}

export class ProductclusterCollectionResponse implements IProductclusterCollectionResponse {
    value?: Productcluster[];

    constructor(data?: IProductclusterCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(Productcluster.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductclusterCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductclusterCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductclusterCollectionResponse {
        const json = this.toJSON();
        let result = new ProductclusterCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IProductclusterCollectionResponse {
    value?: Productcluster[];
}

export class ProductclusterProductgroepCollectionResponse implements IProductclusterProductgroepCollectionResponse {
    value?: ProductclusterProductgroep[];

    constructor(data?: IProductclusterProductgroepCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ProductclusterProductgroep.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductclusterProductgroepCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductclusterProductgroepCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductclusterProductgroepCollectionResponse {
        const json = this.toJSON();
        let result = new ProductclusterProductgroepCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IProductclusterProductgroepCollectionResponse {
    value?: ProductclusterProductgroep[];
}

export class ProductclusterViewCollectionResponse implements IProductclusterViewCollectionResponse {
    value?: ProductclusterView[];

    constructor(data?: IProductclusterViewCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ProductclusterView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductclusterViewCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductclusterViewCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductclusterViewCollectionResponse {
        const json = this.toJSON();
        let result = new ProductclusterViewCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IProductclusterViewCollectionResponse {
    value?: ProductclusterView[];
}

export class ProductgroepCollectionResponse implements IProductgroepCollectionResponse {
    value?: Productgroep[];

    constructor(data?: IProductgroepCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(Productgroep.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductgroepCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductgroepCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductgroepCollectionResponse {
        const json = this.toJSON();
        let result = new ProductgroepCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IProductgroepCollectionResponse {
    value?: Productgroep[];
}

export class ProductVeilgroepCollectionResponse implements IProductVeilgroepCollectionResponse {
    value?: ProductVeilgroep[];

    constructor(data?: IProductVeilgroepCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ProductVeilgroep.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductVeilgroepCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductVeilgroepCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductVeilgroepCollectionResponse {
        const json = this.toJSON();
        let result = new ProductVeilgroepCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IProductVeilgroepCollectionResponse {
    value?: ProductVeilgroep[];
}

export class TribuneKlokCollectionResponse implements ITribuneKlokCollectionResponse {
    value?: TribuneKlok[];

    constructor(data?: ITribuneKlokCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(TribuneKlok.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TribuneKlokCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TribuneKlokCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): TribuneKlokCollectionResponse {
        const json = this.toJSON();
        let result = new TribuneKlokCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface ITribuneKlokCollectionResponse {
    value?: TribuneKlok[];
}

export class UitzonderingRedenCollectionResponse implements IUitzonderingRedenCollectionResponse {
    value?: UitzonderingReden[];

    constructor(data?: IUitzonderingRedenCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(UitzonderingReden.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UitzonderingRedenCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UitzonderingRedenCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): UitzonderingRedenCollectionResponse {
        const json = this.toJSON();
        let result = new UitzonderingRedenCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IUitzonderingRedenCollectionResponse {
    value?: UitzonderingReden[];
}

export class VeildagVeilgroepTellingReportCollectionResponse implements IVeildagVeilgroepTellingReportCollectionResponse {
    value?: VeildagVeilgroepTellingReport[];

    constructor(data?: IVeildagVeilgroepTellingReportCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(VeildagVeilgroepTellingReport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VeildagVeilgroepTellingReportCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VeildagVeilgroepTellingReportCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): VeildagVeilgroepTellingReportCollectionResponse {
        const json = this.toJSON();
        let result = new VeildagVeilgroepTellingReportCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IVeildagVeilgroepTellingReportCollectionResponse {
    value?: VeildagVeilgroepTellingReport[];
}

export class VeilgroepIndelingOverviewCollectionResponse implements IVeilgroepIndelingOverviewCollectionResponse {
    value?: VeilgroepIndelingOverview[];

    constructor(data?: IVeilgroepIndelingOverviewCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(VeilgroepIndelingOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VeilgroepIndelingOverviewCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VeilgroepIndelingOverviewCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): VeilgroepIndelingOverviewCollectionResponse {
        const json = this.toJSON();
        let result = new VeilgroepIndelingOverviewCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IVeilgroepIndelingOverviewCollectionResponse {
    value?: VeilgroepIndelingOverview[];
}

export class VeilgroepIndelingRegelViewCollectionResponse implements IVeilgroepIndelingRegelViewCollectionResponse {
    value?: VeilgroepIndelingRegelView[];

    constructor(data?: IVeilgroepIndelingRegelViewCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(VeilgroepIndelingRegelView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VeilgroepIndelingRegelViewCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VeilgroepIndelingRegelViewCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): VeilgroepIndelingRegelViewCollectionResponse {
        const json = this.toJSON();
        let result = new VeilgroepIndelingRegelViewCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IVeilgroepIndelingRegelViewCollectionResponse {
    value?: VeilgroepIndelingRegelView[];
}

export class VeilgroepIndelingRegelWithCodesViewCollectionResponse implements IVeilgroepIndelingRegelWithCodesViewCollectionResponse {
    value?: VeilgroepIndelingRegelWithCodesView[];

    constructor(data?: IVeilgroepIndelingRegelWithCodesViewCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(VeilgroepIndelingRegelWithCodesView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VeilgroepIndelingRegelWithCodesViewCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VeilgroepIndelingRegelWithCodesViewCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): VeilgroepIndelingRegelWithCodesViewCollectionResponse {
        const json = this.toJSON();
        let result = new VeilgroepIndelingRegelWithCodesViewCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IVeilgroepIndelingRegelWithCodesViewCollectionResponse {
    value?: VeilgroepIndelingRegelWithCodesView[];
}

export class VeilgroepRegelCollectionResponse implements IVeilgroepRegelCollectionResponse {
    value?: VeilgroepRegel[];

    constructor(data?: IVeilgroepRegelCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(VeilgroepRegel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VeilgroepRegelCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VeilgroepRegelCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): VeilgroepRegelCollectionResponse {
        const json = this.toJSON();
        let result = new VeilgroepRegelCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IVeilgroepRegelCollectionResponse {
    value?: VeilgroepRegel[];
}

export class VeilgroepRegelKenmerkCollectionResponse implements IVeilgroepRegelKenmerkCollectionResponse {
    value?: VeilgroepRegelKenmerk[];

    constructor(data?: IVeilgroepRegelKenmerkCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(VeilgroepRegelKenmerk.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VeilgroepRegelKenmerkCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VeilgroepRegelKenmerkCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): VeilgroepRegelKenmerkCollectionResponse {
        const json = this.toJSON();
        let result = new VeilgroepRegelKenmerkCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IVeilgroepRegelKenmerkCollectionResponse {
    value?: VeilgroepRegelKenmerk[];
}

export class ProductclusterVeilgroepRegelCollectionResponse implements IProductclusterVeilgroepRegelCollectionResponse {
    value?: ProductclusterVeilgroepRegel[];

    constructor(data?: IProductclusterVeilgroepRegelCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ProductclusterVeilgroepRegel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductclusterVeilgroepRegelCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductclusterVeilgroepRegelCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductclusterVeilgroepRegelCollectionResponse {
        const json = this.toJSON();
        let result = new ProductclusterVeilgroepRegelCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IProductclusterVeilgroepRegelCollectionResponse {
    value?: ProductclusterVeilgroepRegel[];
}

export class ProductclusterVeilgroepRegelCodeViewCollectionResponse implements IProductclusterVeilgroepRegelCodeViewCollectionResponse {
    value?: ProductclusterVeilgroepRegelCodeView[];

    constructor(data?: IProductclusterVeilgroepRegelCodeViewCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ProductclusterVeilgroepRegelCodeView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductclusterVeilgroepRegelCodeViewCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductclusterVeilgroepRegelCodeViewCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductclusterVeilgroepRegelCodeViewCollectionResponse {
        const json = this.toJSON();
        let result = new ProductclusterVeilgroepRegelCodeViewCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IProductclusterVeilgroepRegelCodeViewCollectionResponse {
    value?: ProductclusterVeilgroepRegelCodeView[];
}

export class StringCollectionResponse implements IStringCollectionResponse {
    value?: string[];

    constructor(data?: IStringCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): StringCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StringCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }

    clone(): StringCollectionResponse {
        const json = this.toJSON();
        let result = new StringCollectionResponse();
        result.init(json);
        return result;
    }
}

export interface IStringCollectionResponse {
    value?: string[];
}

export class ReferenceUpdate implements IReferenceUpdate {
    odataId?: string;
    odataType?: string | undefined;

    constructor(data?: IReferenceUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataId = _data["@odata.id"];
            this.odataType = _data["@odata.type"];
        }
    }

    static fromJS(data: any): ReferenceUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.id"] = this.odataId;
        data["@odata.type"] = this.odataType;
        return data;
    }

    clone(): ReferenceUpdate {
        const json = this.toJSON();
        let result = new ReferenceUpdate();
        result.init(json);
        return result;
    }
}

export interface IReferenceUpdate {
    odataId?: string;
    odataType?: string | undefined;
}

export class ReferenceCreate implements IReferenceCreate {
    odataId?: string;

    constructor(data?: IReferenceCreate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataId = _data["@odata.id"];
        }
    }

    static fromJS(data: any): ReferenceCreate {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.id"] = this.odataId;
        return data;
    }

    clone(): ReferenceCreate {
        const json = this.toJSON();
        let result = new ReferenceCreate();
        result.init(json);
        return result;
    }
}

export interface IReferenceCreate {
    odataId?: string;
}

export enum ReferenceNumeric {
    MinusINF = "-INF",
    INF = "INF",
    NaN = "NaN",
}

export class Body implements IBody {
    key?: number;

    constructor(data?: IBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        return data;
    }

    clone(): Body {
        const json = this.toJSON();
        let result = new Body();
        result.init(json);
        return result;
    }
}

export interface IBody {
    key?: number;
}

export class Body2 implements IBody2 {
    key?: number;

    constructor(data?: IBody2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): Body2 {
        data = typeof data === 'object' ? data : {};
        let result = new Body2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        return data;
    }

    clone(): Body2 {
        const json = this.toJSON();
        let result = new Body2();
        result.init(json);
        return result;
    }
}

export interface IBody2 {
    key?: number;
}

export class Body3 implements IBody3 {
    key?: number;

    constructor(data?: IBody3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): Body3 {
        data = typeof data === 'object' ? data : {};
        let result = new Body3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        return data;
    }

    clone(): Body3 {
        const json = this.toJSON();
        let result = new Body3();
        result.init(json);
        return result;
    }
}

export interface IBody3 {
    key?: number;
}

export class Anonymous implements IAnonymous {

    constructor(data?: IAnonymous) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Anonymous {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): Anonymous {
        const json = this.toJSON();
        let result = new Anonymous();
        result.init(json);
        return result;
    }
}

export interface IAnonymous {
}

export class Anonymous2 implements IAnonymous2 {
    value?: AanvoerderOnregelmatig[];

    constructor(data?: IAnonymous2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderOnregelmatig.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous2 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous2 {
        const json = this.toJSON();
        let result = new Anonymous2();
        result.init(json);
        return result;
    }
}

export interface IAnonymous2 {
    value?: AanvoerderOnregelmatig[];
}

export class Anonymous3 implements IAnonymous3 {
    value?: AanvoerderProductgroepRegelmatigView[];

    constructor(data?: IAnonymous3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderProductgroepRegelmatigView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous3 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous3 {
        const json = this.toJSON();
        let result = new Anonymous3();
        result.init(json);
        return result;
    }
}

export interface IAnonymous3 {
    value?: AanvoerderProductgroepRegelmatigView[];
}

export class Anonymous4 implements IAnonymous4 {
    value?: AanvoerderProductRegelmatigView[];

    constructor(data?: IAnonymous4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderProductRegelmatigView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous4 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous4 {
        const json = this.toJSON();
        let result = new Anonymous4();
        result.init(json);
        return result;
    }
}

export interface IAnonymous4 {
    value?: AanvoerderProductRegelmatigView[];
}

export class Anonymous5 implements IAnonymous5 {

    constructor(data?: IAnonymous5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Anonymous5 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): Anonymous5 {
        const json = this.toJSON();
        let result = new Anonymous5();
        result.init(json);
        return result;
    }
}

export interface IAnonymous5 {
}

export class Anonymous6 implements IAnonymous6 {

    constructor(data?: IAnonymous6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Anonymous6 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): Anonymous6 {
        const json = this.toJSON();
        let result = new Anonymous6();
        result.init(json);
        return result;
    }
}

export interface IAnonymous6 {
}

export class Anonymous7 implements IAnonymous7 {
    value?: AanvoerderPromotieKenmerk[];

    constructor(data?: IAnonymous7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AanvoerderPromotieKenmerk.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous7 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous7 {
        const json = this.toJSON();
        let result = new Anonymous7();
        result.init(json);
        return result;
    }
}

export interface IAnonymous7 {
    value?: AanvoerderPromotieKenmerk[];
}

export class Anonymous8 implements IAnonymous8 {

    constructor(data?: IAnonymous8) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Anonymous8 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous8();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): Anonymous8 {
        const json = this.toJSON();
        let result = new Anonymous8();
        result.init(json);
        return result;
    }
}

export interface IAnonymous8 {
}

export class Anonymous9 implements IAnonymous9 {
    value?: PartijStatusReport[];

    constructor(data?: IAnonymous9) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(PartijStatusReport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous9 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous9();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous9 {
        const json = this.toJSON();
        let result = new Anonymous9();
        result.init(json);
        return result;
    }
}

export interface IAnonymous9 {
    value?: PartijStatusReport[];
}

export class Anonymous10 implements IAnonymous10 {
    value?: PartijStatusReport[];

    constructor(data?: IAnonymous10) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(PartijStatusReport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous10 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous10();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous10 {
        const json = this.toJSON();
        let result = new Anonymous10();
        result.init(json);
        return result;
    }
}

export interface IAnonymous10 {
    value?: PartijStatusReport[];
}

export class Anonymous11 implements IAnonymous11 {

    constructor(data?: IAnonymous11) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Anonymous11 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous11();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): Anonymous11 {
        const json = this.toJSON();
        let result = new Anonymous11();
        result.init(json);
        return result;
    }
}

export interface IAnonymous11 {
}

export class Anonymous12 implements IAnonymous12 {
    value?: ProductgroepenReport[];

    constructor(data?: IAnonymous12) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ProductgroepenReport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous12 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous12();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous12 {
        const json = this.toJSON();
        let result = new Anonymous12();
        result.init(json);
        return result;
    }
}

export interface IAnonymous12 {
    value?: ProductgroepenReport[];
}

export class Anonymous13 implements IAnonymous13 {
    value?: (string | undefined)[];

    constructor(data?: IAnonymous13) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): Anonymous13 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous13();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }

    clone(): Anonymous13 {
        const json = this.toJSON();
        let result = new Anonymous13();
        result.init(json);
        return result;
    }
}

export interface IAnonymous13 {
    value?: (string | undefined)[];
}

export class Anonymous14 implements IAnonymous14 {
    value?: ProductVeilgroep[];

    constructor(data?: IAnonymous14) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ProductVeilgroep.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous14 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous14();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous14 {
        const json = this.toJSON();
        let result = new Anonymous14();
        result.init(json);
        return result;
    }
}

export interface IAnonymous14 {
    value?: ProductVeilgroep[];
}

export class Anonymous15 implements IAnonymous15 {
    value?: ProductVeilgroep[];

    constructor(data?: IAnonymous15) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ProductVeilgroep.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous15 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous15();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous15 {
        const json = this.toJSON();
        let result = new Anonymous15();
        result.init(json);
        return result;
    }
}

export interface IAnonymous15 {
    value?: ProductVeilgroep[];
}

export class Anonymous16 implements IAnonymous16 {
    value?: VeilgroepIndelingOverview[];

    constructor(data?: IAnonymous16) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(VeilgroepIndelingOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous16 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous16();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous16 {
        const json = this.toJSON();
        let result = new Anonymous16();
        result.init(json);
        return result;
    }
}

export interface IAnonymous16 {
    value?: VeilgroepIndelingOverview[];
}

export class Anonymous17 implements IAnonymous17 {

    constructor(data?: IAnonymous17) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Anonymous17 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous17();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): Anonymous17 {
        const json = this.toJSON();
        let result = new Anonymous17();
        result.init(json);
        return result;
    }
}

export interface IAnonymous17 {
}

export class Anonymous18 implements IAnonymous18 {

    constructor(data?: IAnonymous18) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Anonymous18 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous18();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): Anonymous18 {
        const json = this.toJSON();
        let result = new Anonymous18();
        result.init(json);
        return result;
    }
}

export interface IAnonymous18 {
}

export class Anonymous19 implements IAnonymous19 {
    value?: VeilgroepIndelingRegelView[];

    constructor(data?: IAnonymous19) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(VeilgroepIndelingRegelView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous19 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous19();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous19 {
        const json = this.toJSON();
        let result = new Anonymous19();
        result.init(json);
        return result;
    }
}

export interface IAnonymous19 {
    value?: VeilgroepIndelingRegelView[];
}

export class Anonymous20 implements IAnonymous20 {
    value?: ProductclusterVeilgroepRegelCode[];

    constructor(data?: IAnonymous20) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ProductclusterVeilgroepRegelCode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous20 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous20();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous20 {
        const json = this.toJSON();
        let result = new Anonymous20();
        result.init(json);
        return result;
    }
}

export interface IAnonymous20 {
    value?: ProductclusterVeilgroepRegelCode[];
}

export class Anonymous21 implements IAnonymous21 {
    value?: ProductclusterVeilgroepRegelCode[];

    constructor(data?: IAnonymous21) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ProductclusterVeilgroepRegelCode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous21 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous21();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous21 {
        const json = this.toJSON();
        let result = new Anonymous21();
        result.init(json);
        return result;
    }
}

export interface IAnonymous21 {
    value?: ProductclusterVeilgroepRegelCode[];
}

export class Anonymous22 implements IAnonymous22 {
    value?: ProductclusterVeilgroepRegelCode[];

    constructor(data?: IAnonymous22) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ProductclusterVeilgroepRegelCode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous22 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous22();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous22 {
        const json = this.toJSON();
        let result = new Anonymous22();
        result.init(json);
        return result;
    }
}

export interface IAnonymous22 {
    value?: ProductclusterVeilgroepRegelCode[];
}

export class Anonymous23 implements IAnonymous23 {

    constructor(data?: IAnonymous23) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Anonymous23 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous23();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): Anonymous23 {
        const json = this.toJSON();
        let result = new Anonymous23();
        result.init(json);
        return result;
    }
}

export interface IAnonymous23 {
}

export class Anonymous24 implements IAnonymous24 {
    value?: VeilgroepRegel[];

    constructor(data?: IAnonymous24) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(VeilgroepRegel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous24 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous24();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous24 {
        const json = this.toJSON();
        let result = new Anonymous24();
        result.init(json);
        return result;
    }
}

export interface IAnonymous24 {
    value?: VeilgroepRegel[];
}

export class Anonymous25 implements IAnonymous25 {

    constructor(data?: IAnonymous25) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Anonymous25 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous25();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): Anonymous25 {
        const json = this.toJSON();
        let result = new Anonymous25();
        result.init(json);
        return result;
    }
}

export interface IAnonymous25 {
}

export class Anonymous26 implements IAnonymous26 {

    constructor(data?: IAnonymous26) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Anonymous26 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous26();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): Anonymous26 {
        const json = this.toJSON();
        let result = new Anonymous26();
        result.init(json);
        return result;
    }
}

export interface IAnonymous26 {
}

export class Anonymous27 implements IAnonymous27 {
    value?: VeilgroepRegelView[];

    constructor(data?: IAnonymous27) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(VeilgroepRegelView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous27 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous27();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous27 {
        const json = this.toJSON();
        let result = new Anonymous27();
        result.init(json);
        return result;
    }
}

export interface IAnonymous27 {
    value?: VeilgroepRegelView[];
}

export class Anonymous28 implements IAnonymous28 {
    value?: VeildagVeilgroepTellingReport[];

    constructor(data?: IAnonymous28) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(VeildagVeilgroepTellingReport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous28 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous28();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous28 {
        const json = this.toJSON();
        let result = new Anonymous28();
        result.init(json);
        return result;
    }
}

export interface IAnonymous28 {
    value?: VeildagVeilgroepTellingReport[];
}

export class Anonymous29 implements IAnonymous29 {
    value?: VeildagVeilgroepTellingReport[];

    constructor(data?: IAnonymous29) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(VeildagVeilgroepTellingReport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous29 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous29();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }

    clone(): Anonymous29 {
        const json = this.toJSON();
        let result = new Anonymous29();
        result.init(json);
        return result;
    }
}

export interface IAnonymous29 {
    value?: VeildagVeilgroepTellingReport[];
}

export class Productcluster2 implements IProductcluster2 {

    constructor(data?: IProductcluster2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Productcluster2 {
        data = typeof data === 'object' ? data : {};
        let result = new Productcluster2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): Productcluster2 {
        const json = this.toJSON();
        let result = new Productcluster2();
        result.init(json);
        return result;
    }
}

export interface IProductcluster2 {
}

export class OverzichtAanvoerderProductRegelmatigUitzonderingen2 implements IOverzichtAanvoerderProductRegelmatigUitzonderingen2 {

    constructor(data?: IOverzichtAanvoerderProductRegelmatigUitzonderingen2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): OverzichtAanvoerderProductRegelmatigUitzonderingen2 {
        data = typeof data === 'object' ? data : {};
        let result = new OverzichtAanvoerderProductRegelmatigUitzonderingen2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): OverzichtAanvoerderProductRegelmatigUitzonderingen2 {
        const json = this.toJSON();
        let result = new OverzichtAanvoerderProductRegelmatigUitzonderingen2();
        result.init(json);
        return result;
    }
}

export interface IOverzichtAanvoerderProductRegelmatigUitzonderingen2 {
}

export class ToevoegenAanvoerderProductRegelmatigUitzondering2 implements IToevoegenAanvoerderProductRegelmatigUitzondering2 {

    constructor(data?: IToevoegenAanvoerderProductRegelmatigUitzondering2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ToevoegenAanvoerderProductRegelmatigUitzondering2 {
        data = typeof data === 'object' ? data : {};
        let result = new ToevoegenAanvoerderProductRegelmatigUitzondering2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ToevoegenAanvoerderProductRegelmatigUitzondering2 {
        const json = this.toJSON();
        let result = new ToevoegenAanvoerderProductRegelmatigUitzondering2();
        result.init(json);
        return result;
    }
}

export interface IToevoegenAanvoerderProductRegelmatigUitzondering2 {
}

export class UpdatenAanvoerderProductRegelmatigUitzondering2 implements IUpdatenAanvoerderProductRegelmatigUitzondering2 {

    constructor(data?: IUpdatenAanvoerderProductRegelmatigUitzondering2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdatenAanvoerderProductRegelmatigUitzondering2 {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatenAanvoerderProductRegelmatigUitzondering2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdatenAanvoerderProductRegelmatigUitzondering2 {
        const json = this.toJSON();
        let result = new UpdatenAanvoerderProductRegelmatigUitzondering2();
        result.init(json);
        return result;
    }
}

export interface IUpdatenAanvoerderProductRegelmatigUitzondering2 {
}

export class VerwijderenAanvoerderProductRegelmatigUitzondering2 implements IVerwijderenAanvoerderProductRegelmatigUitzondering2 {

    constructor(data?: IVerwijderenAanvoerderProductRegelmatigUitzondering2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): VerwijderenAanvoerderProductRegelmatigUitzondering2 {
        data = typeof data === 'object' ? data : {};
        let result = new VerwijderenAanvoerderProductRegelmatigUitzondering2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): VerwijderenAanvoerderProductRegelmatigUitzondering2 {
        const json = this.toJSON();
        let result = new VerwijderenAanvoerderProductRegelmatigUitzondering2();
        result.init(json);
        return result;
    }
}

export interface IVerwijderenAanvoerderProductRegelmatigUitzondering2 {
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

export function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
